'use strict';

(function (angular) {
  angular.module('ibf').directive('showErrors', function () {
    return {
      restrict: 'A',
      require: '^form',
      link: function link(scope, el, attrs, formCtrl) {
        var inputEl = el[0].querySelector('[name]'); // find the text box element, which has the 'name' attribute

        var inputNgEl = angular.element(inputEl); // convert the native text box element to an angular element

        var inputName = inputNgEl.attr('name'); // get the name on the text box so we know the property to check on the controller

        //get the general event broadcasted from the save action
        scope.$on('show-errors-check-validity', function () {
          if (formCtrl && formCtrl[inputName]) {
            el.toggleClass('has-error', formCtrl[inputName].$invalid);
          }

          // console.log('input', inputName)

        });
        // only apply the has-error class after the user leaves the text box
        inputNgEl.bind('blur', function () {
          el.toggleClass('has-error', formCtrl[inputName].$invalid);
        });
      }
    };
  });
})(angular);

(function (angular) {
  angular.module('ibf').directive('onFinishRender', ['$timeout', onFinishRender]);

  function onFinishRender($timeout) {
    return {
      restrict: 'A',
      link: function link(scope, element, attr) {
        if (scope.$last === true) {
          $timeout(function () {
            scope.$emit('ngRepeatFinished');
          });
        }
      }
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').filter('truncate', truncate);

  function truncate() {
    return function (text, length, end) {
      try {
        if (isNaN(length)) length = 10;

        if (end === undefined) end = '...';

        if (text.length <= length || text.length - end.length <= length) {
          return text;
        } else {
          return String(text).substring(0, length - end.length) + end;
        }
      } catch (err) {}
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').directive('stopPropagation', stopPropagation).directive('fileModel', ['$parse', 'growerSrv', function ($parse, growerSrv) {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {

        var model = $parse(attrs.fileModel);
        var modelSetter = model.assign;
        element.bind('change', function () {
          scope.$apply(function () {
            modelSetter(scope, element[0].files[0]);
          });
        });
      }
    };
  }]);

  function stopPropagation() {
    return function (scope, element, attrs) {
      element.bind('click', function (event) {
        event.stopPropagation();
      });
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').directive('ngEnter', ngEnter);

  function ngEnter() {
    return function (scope, element, attrs) {

      element.bind('keydown keypress', function (event) {

        if (event.which === 13) {
          if (!event.altKey) {
            scope.$apply(function () {
              scope.$eval(attrs.ngEnter);
            });
            event.preventDefault();
          }
        }
      });
    };
  }
})(angular);

(function () {
  angular.module('ibf').directive('numberDecimal', numberDecimal);

  function numberDecimal() {
    return {
      require: 'ngModel',
      link: function link(scope, element, attrs, modelCtrl) {
        modelCtrl.$parsers.push(function (inputValue) {
          // this next if is necessary for when using ng-required on your input.
          // In such cases, when a letter is typed first, this parser will be called
          // again, and the 2nd time, the value will be undefined

          if (inputValue == undefined) {
            return '';
          }
          var transformedInput = inputValue.replace(/[^0-9\.]/g, '');
          if (transformedInput.indexOf('.') != transformedInput.lastIndexOf('.')) {
            transformedInput = transformedInput.substring(0, transformedInput.lastIndexOf('.'));
          }
          if (transformedInput != inputValue) {
            modelCtrl.$setViewValue(transformedInput);
            modelCtrl.$render();
          }

          return transformedInput;
        });
      }
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').directive('formatToCurrency', ['$filter', formatToCurrency]);

  function formatToCurrency($filter) {
    return {
      scope: {
        amount: '='
      },
      link: function link(scope, el, attrs) {
        el.val($filter('currency')(scope.amount));

        el.bind('focus', function () {
          el.val(scope.amount);
        });

        el.bind('input', function () {
          scope.amount = el.val();
          scope.$apply();
        });

        el.bind('blur', function () {
          el.val($filter('currency')(scope.amount));
        });
      }
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').directive('numericOnly', numericOnly);

  function numericOnly() {
    return {
      require: 'ngModel',
      link: function link(scope, element, attrs, modelCtrl) {

        modelCtrl.$parsers.push(function (inputValue) {
          var transformedInput = inputValue ? inputValue.replace(/[^\d.-]/g, '') : null;

          if (transformedInput != inputValue) {
            modelCtrl.$setViewValue(transformedInput);
            modelCtrl.$render();
          }

          return transformedInput;
        });
      }
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').filter('capitalize', function () {
    return function (input) {
      if (input) {
        var aryStr = input.split(' ');
        var res = '';
        angular.forEach(aryStr, function (element, index) {
          res += ' ' + element.charAt(0).toUpperCase() + element.substring(1, element.length);
        });
      }
      return res;
    };
  });
})(angular);

(function (angular) {
  angular.module('ibf').filter('filterByDate', function () {
    return function (items, dateFilter, nameProp) {
      if (!items) {
        return;
      }

      if (!dateFilter) {
        return items;
      }

      dateFilter.setUTCHours(0);
      dateFilter.setMinutes(0);
      dateFilter.setSeconds(0);
      var start = new Date(dateFilter);
      var end = new Date(start);
      end.setDate(start.getDate() + 1);
      var result = [];
      for (var i = 0; i < items.length; i++) {
        var time = items[i][nameProp];
        if (!(time instanceof Date)) {
          time = new Date(time);
          time.setHours(0);
        }
        // console.log(start.toISOString(), time.toISOString(), end.toISOString());
        if (time.getTime() >= start.getTime() && time.getTime() < end.getTime()) {
          result.push(items[i]);
        }
      }
      return result;
    };
  });
})(angular);

(function (angular) {
  angular.module('ibf').directive('backImg', function () {
    return function (scope, element, attrs) {
      var url = attrs.backImg;
      element.css({
        'background-image': 'url(' + url + ')'
      });
    };
  });
})(angular);

(function (angular) {
  angular.module('ibf').directive('imageonload', imageonload);

  function imageonload() {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        element.bind('load', function () {
          console.log('image is loaded');
          scope.$emit('image_loaded');
        });
        element.bind('error', function () {
          console.log('image could not be loaded');
        });
      }
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').directive('imageonload2', imageonload);

  function imageonload() {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        element.bind('load', function () {
          console.log('image is loaded');
          scope.$emit('image_loaded');
        });
        element.bind('error', function () {
          console.log('image could not be loaded');
        });
      }
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').directive('onFinishRender', ['$timeout', '$parse', function ($timeout, $parse) {
    return {
      restrict: 'A',
      link: function link(scope, element, attr) {
        if (scope.$last === true) {
          $timeout(function () {
            scope.$emit('ngRepeatFinished');
            if (!!attr.onFinishRender) {
              $parse(attr.onFinishRender)(scope);
            }
          });
        }
      }
    };
  }]);
})(angular);

(function (angular) {
  angular.module('ibf').directive('fileReader', function () {
    return {
      scope: {
        fileReader: '=',
        originalFile: '='
      },
      link: function link(scope, element) {
        $(element).on('change', function (changeEvent) {
          var files = changeEvent.target.files;
          if (files.length) {
            var r = new FileReader();
            r.onload = function (e) {
              var contents = e.target.result;
              scope.$apply(function () {
                var array = contents.split('\n');

                // Detectar el delimitador automáticamente (coma o punto y coma)
                var delimiter = ';';
                if (array.length > 0) {
                  var firstLine = array[0];
                  var commaCount = (firstLine.match(/,/g) || []).length;
                  var semicolonCount = (firstLine.match(/;/g) || []).length;

                  // Usar el delimitador que aparece más veces en la primera línea
                  if (commaCount > semicolonCount) {
                    delimiter = ',';
                  }
                }

                var newArray = [];
                array.forEach(function (row, index) {
                  // Manejar campos que contienen el delimitador dentro de comillas
                  var regex;
                  if (delimiter === ',') {
                    // Para CSV con comas, usar regex que respeta comillas
                    regex = /("(?:[^"]|"")*"|[^,]+)(?:,|$)/g;
                  } else {
                    // Para CSV con punto y coma
                    regex = /("(?:[^"]|"")*"|[^;]+)(?:;|$)/g;
                  }

                  var matches = [];
                  var match;
                  while ((match = regex.exec(row)) !== null) {
                    var value = match[1];
                    // Remover comillas al inicio y final si existen
                    if (value.charAt(0) === '"' && value.charAt(value.length - 1) === '"') {
                      value = value.substring(1, value.length - 1);
                      // Reemplazar comillas dobles escapadas
                      value = value.replace(/""/g, '"');
                    }
                    matches.push(value);
                  }

                  // Si no se encontraron matches con regex, usar split simple
                  if (matches.length === 0) {
                    matches = row.split(delimiter);
                  }

                  newArray.push(matches);
                });

                // console.log(newArray[0][0]);
                // console.log(typeof newArray[0][0]);
                for (var i = 0; i < newArray.length; i++) {
                  if (newArray[i][0] && newArray[i][0].substring(0, 1) === '"') {
                    var string2 = newArray[0].length - 1;
                    //newArray[0][0] = newArray[0][0].substring(1,newArray[0][0].length)
                    newArray[i][0] = newArray[i][0].replace('"', '');
                    if (newArray[i][string2]) {
                      newArray[i][string2] = newArray[i][string2].replace('"', '');
                    }
                  }
                }

                scope.fileReader = newArray;
                scope.originalFile = files[0];
                scope.testing = newArray;
                // console.log(newArray);
              });
            };

            r.readAsText(files[0]);
          }
        });
      }
    };
  });
})(angular);

(function (angular) {
  angular.module('ibf').filter('startFrom', startFrom);

  function startFrom() {
    return function (input, start) {
      return input ? input.slice(start) : [];
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').filter('orderObjectBy', orderObjectBy);

  function orderObjectBy() {
    return function (items, field, reverse) {
      var filtered = [];
      angular.forEach(items, function (item) {
        filtered.push(item);
      });
      filtered.sort(function (a, b) {
        return a[field] > b[field] ? 1 : -1;
      });
      if (reverse) filtered.reverse();
      return filtered;
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').filter('filterHighlight', filterHighlight);

  function filterHighlight() {
    function escapeRegexp(queryToEscape) {
      return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    return function (matchItem, query) {
      return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="highlight">$&</span>') : matchItem;
    };
    // return function (input, query) {
    //   var r = RegExp('(' + query + ')', 'gi');
    //   return input.replace(r, '<span class="highlight">$1</span>');
    // }
  }
})(angular);

(function (angular) {
  angular.module('ibf').directive('format', ['$filter', format]);

  function format($filter) {
    return {
      require: '?ngModel',
      link: function link(scope, elem, attrs, ctrl) {
        if (!ctrl) return;

        ctrl.$formatters.unshift(function (a) {
          return $filter(attrs.format)(ctrl.$modelValue);
        });

        elem.bind('blur', function (event) {
          var plainNumber = elem.val().replace(/[^\d|\-+|\.+]/g, '');
          elem.val($filter(attrs.format)(plainNumber));
        });
      }
    };
  }
})(angular);

(function (angular) {
  angular.module('ibf').directive('customDatepicker', ['uibDatepickerPopupConfig', '$parse', '$timeout', function (uibDatepickerPopupConfig, $parse, $timeout) {
    uibDatepickerPopupConfig.datepickerPopupTemplateUrl = 'views/custom-datepicker-popup.html';

    return {
      restrict: 'A',
      scope: false,
      link: function link(scope, element, attrs) {
        var loadingMonthGetter = $parse(attrs.loadingMonth);
        var datepickerCtrl = null;
        scope.isMonthMode = false;
        scope.selectedMonth = null;

        function getDatepickerCtrl() {
          if (!datepickerCtrl) {
            var datepickerElement = angular.element(document.querySelector('.uib-datepicker'));
            if (datepickerElement.length) {
              datepickerCtrl = datepickerElement.controller('uibDatepicker');
            }
          }
          return datepickerCtrl;
        }

        function isMonthMode() {
          var ctrl = getDatepickerCtrl();
          return ctrl && ctrl.step && ctrl.step.hasOwnProperty('months');
        }

        function updateNavigationButtons() {
          var prevButton = angular.element(document.querySelector('.uib-left'));
          var nextButton = angular.element(document.querySelector('.uib-right'));

          if (scope.loadingMonth) {
            prevButton.attr('disabled', 'disabled').addClass('disabled');
            nextButton.attr('disabled', 'disabled').addClass('disabled');
          } else {
            prevButton.removeAttr('disabled').removeClass('disabled');
            nextButton.removeAttr('disabled').removeClass('disabled');
          }
        }

        function handleLoadingAndSelection() {
          if (isMonthMode()) {
            scope.loadingMonth = loadingMonthGetter(scope);
            $timeout(function () {
              var ctrl = getDatepickerCtrl();
              if (ctrl) {
                updateNavigationButtons();
                ctrl.refreshView();
              }
            }, 100);
          }
        }

        scope.$watch(loadingMonthGetter, function () {
          handleLoadingAndSelection();
        });

        scope.$watch(function () {
          var ctrl = getDatepickerCtrl();
          var monthMode = isMonthMode();
          scope.isMonthMode = monthMode;
          return monthMode && ctrl ? ctrl.activeDate : null;
        }, function (newDate) {
          if (scope.isMonthMode && newDate instanceof Date && !isNaN(newDate)) {
            scope.selectedMonth = newDate;
          } else {
            scope.selectedMonth = null;
          }
        }, true);
      }
    };
  }]);
})(angular);
//# sourceMappingURL=directives.js.map

'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function (angular) {
  'use strict';

  angular.module('ibf').factory('commonSrv', ['$http', '$filter', '$cookies', '$state', '$uibModal', '$q', 'alertify', '$window', 'environment', commonSrv]);

  function commonSrv($http, $filter, $cookies, $state, $uibModal, $q, alertify, $window, environment) {
    var common = { maps: {} };

    common.version_app = environment.versionApp;

    common.offer_per = 0.5;
    common.margin_actual = 16;

    common.stripe = null;

    var aux = environment.label;

    common.registerEvent = function (metadata, eventName) {
      var ts = Math.round(new Date().getTime() / 1000);
      metadata.timestamp = ts;
    };

    common.env_app = aux;
    common.actual_login_redirect = environment.loginRedirect;
    common.grower_logout_redirect = environment.growerLogoutRedirect;
    common.isProd = environment.production;
    common.actual_tokens = environment.adminToken;
    common.actual_domain = environment.domain;
    common.actual_base_url = environment.publicPath;
    common.order_request_status = 'OPEN';
    common.current_app_key = environment.appKey;
    common.meta_event_data = {};

    common.sbx = new SbxCore();
    common.sbx.initialize(common.actual_domain, common.current_app_key);

    $window.sbx = common.sbx;

    common.urls = Object.assign({
      api: environment.api,
      appKeys: '/domain/v1/app/list',
      configAppKey: '/domain/v1/app/config'
    }, common.sbx.urls);

    // TODO: move to domain config

    common.growers_folder_key = environment.folderKeys.grower;
    common.growers_inventories_folder_key = environment.folderKeys.grower_inventories;
    common.florist_folder_key = environment.folderKeys.florist;
    common.varieties_folder_key = environment.folderKeys.varieties;
    common.product_group_folder_key = environment.folderKeys.product_group;
    common.images_folder_key = environment.folderKeys.images;
    common.season_images_folder_key = environment.folderKeys.season_images;
    common.publicPathV3 = environment.publicPathV3;
    common.seasons_images_folder_name = environment.seasons_images_folder_name;

    common.template_email_grower_purchase = environment.templateEmailKey.grower_purchase;
    common.template_email_customer_purchase = environment.templateEmailKey.customer_purchase;
    common.template_email_sign_up = environment.templateEmailKey.sign_up;
    common.template_email_request_auth = environment.templateEmailKey.request_auth;
    common.template_email_delete_notif = environment.templateEmailKey.notif_delete;
    common.request_claim_mail_customer = environment.templateEmailKey.request_claim_customer;
    common.request_claim_mail_grower = environment.templateEmailKey.request_claim_grower;
    common.response_claim_mail = environment.templateEmailKey.response_claim;
    common.standing_order_notif = environment.templateEmailKey.standing_order_notif;
    common.standing_order_response = environment.templateEmailKey.standing_order_response;
    common.password_mail = environment.templateEmailKey.password_retrieve;
    common.move_order_payment = environment.templateEmailKey.move_order_payment;
    common.move_order_supply = environment.templateEmailKey.move_order_supply;
    common.move_order_fedex = environment.templateEmailKey.move_order_fedex;
    common.move_order_grower_notification = environment.templateEmailKey.move_order_grower_notification;

    common.product_group_default = environment.productGroupDefaultObject;
    common.variety_default = environment.varietyDefaultKey;

    common.toMap = function (array, mapName, key) {
      if (!common.maps[mapName]) {
        common.maps[mapName] = {};
      } //else{
      //     return common.maps[mapName];
      // }

      for (var i = 0; i < array.length; i++) {
        common.maps[mapName][array[i][key]] = array[i];
      }
      return common.maps[mapName];
    };

    common.generateUUID = function () {
      var d = new Date().getTime();
      if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now();
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
      });
    };

    common.arrayToMap = function (array, key) {
      return array.reduce(function (current, item) {
        current[item[key]] = item;
        return current;
      }, {});
    };

    common.copyToClipboard = function (str) {
      var el = document.createElement('textarea');
      el.value = str;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    };

    common.setUserData = function (data) {
      $cookies.putObject('ibf_user', data, { path: '/' });
      // console.log('data', data)
      common.meta_event_data = {
        user: data.data.user_id,
        extra: {
          email: data.data.email,
          grower: data.data.metadata.grower,
          user_key: data.fromCountryManager ? data.country_manager_key : data.key,
          role: data.fromCountryManager ? data.main_role : data.data.role
        }
      };
      common.userData = data;
    };

    common.setConfig = function (data) {
      // $cookies.putObject('ibf_config', JSON.stringify(data), {path: '/'});
      common.config = data;
    };

    common.getUserData = function () {
      if (!common.userData) {
        common.userData = $cookies.getObject('ibf_user');
      }
      return common.userData;
    };

    common.getConfig = function () {
      // if (!common.config) {
      //   common.config = JSON.parse($cookies.getObject('ibf_config'));
      // }
      return common.config;
    };

    common.setCustomerMargin = function (data, options) {
      $cookies.put('ibf_customer_margin', data, options);
    };

    common.getCustomerMargin = function () {
      return $cookies.get('ibf_customer_margin');
    };

    common.getHeaders = function () {
      return common.headers;
    };

    common.upper = function (val) {
      return val == null ? '' : val.toUpperCase();
    };

    common.roundTo = function (n, digits) {
      if (digits === undefined) {
        digits = 0;
      }

      var multiplicator = Math.pow(10, digits);
      n = parseFloat((n * multiplicator).toFixed(11));
      var test = Math.round(n) / multiplicator;
      return +test.toFixed(digits);
    };

    common.convertType = function (value) {
      try {
        return new Function('return ' + value + ';')();
      } catch (e) {
        return value;
      }
    };

    common.setHeaders = function (token) {
      common.headers = {
        Authorization: 'Bearer ' + token,
        'App-Key': common.current_app_key
      };
    };

    common.setForgotHeaders = function (token) {
      common.headers = {
        'App-Key': common.current_app_key
      };
    };

    common.removeDuplicateFromArrayObj = function (arr, key) {
      var seen = new Set();
      return (arr ? arr : []).filter(function (element) {
        var duplicate = seen.has(element[key]);
        seen.add(element[key]);
        return !duplicate;
      });
    };

    common.response = {};
    common.method = {
      literalGet: function literalGet(url, params) {
        return $http({
          method: 'GET',
          url: url,
          params: angular.copy(params),
          headers: common.getHeaders()
        });
      },
      get: function get(urlRequest, params, headers) {

        var serviceHeaders = common.getHeaders();

        if (headers) {
          serviceHeaders = headers;
        }

        // console.log("Service headers")
        // console.log(serviceHeaders)

        return $http({
          method: 'GET',
          url: common.urls.api + urlRequest,
          params: angular.copy(params),
          headers: serviceHeaders
        }).then(function (response) {
          common.response.get = response;
        });
      },
      post: function post(urlRequest, params) {
        return $http({
          method: 'POST',
          url: common.urls.api + urlRequest,
          params: angular.copy(params),
          headers: common.getHeaders()
        }).then(function (response) {
          common.response.post = response;
        });
      },
      postData: function postData(urlRequest, params) {
        return $http({
          method: 'POST',
          url: common.urls.api + urlRequest,
          data: angular.copy(params),
          headers: common.getHeaders()
        }).then(function (response) {
          common.response.post = response;
        });
      },
      upload: function upload(url, params) {
        return $http.post(common.urls.api + common.urls.uploadFile, params, {
          headers: {
            Authorization: common.headers.Authorization,
            'App-Key': common.current_app_key,
            'content-type': undefined
          }
        }).then(function (response) {
          common.response.post = response;
        });
      },
      put: function put(urlRequest, params) {
        return $http({
          method: 'PUT',
          url: common.urls.api + urlRequest,
          data: angular.copy(params),
          headers: common.getHeaders()
        }).then(function (response) {
          common.response.put = response;
        });
      },
      query: function query(urlRequest, send_query) {
        return $http({
          method: 'POST',
          url: common.urls.api + urlRequest,
          data: angular.copy(send_query),
          headers: common.getHeaders()
        }).then(function (response) {
          common.response.post_query = response;
          return response;
        }, function (err) {
          common.response.post_query = { data: { success: false } };
          console.log('query error');
          console.log(err);
          return err;
        });
      },
      send_mail: function send_mail(body_mail) {
        var bcc = body_mail.bcc || null;
        var copy_mail_dev = 'sbxrouter@gmail.com';

        if (!common.isProd) {
          bcc = bcc ? bcc + ', ' + copy_mail_dev : copy_mail_dev;
        }

        body_mail.bcc = bcc;

        return this.query(common.urls.send_mail, body_mail).then(function (response) {
          return response.data;
        });
      },
      run: function run(params) {
        return this.query(common.urls.cloudscript_run, params).then(function (response) {
          return response.data ? response.data.success ? response.data.response.body : response.data : response;
        });
      },
      insert: function insert(sbxQuery) {
        return this.query(common.urls.row, sbxQuery).then(function (response) {
          return response.data;
        });
      },
      update: function update(sbxQuery) {
        return this.query(common.urls.update, sbxQuery).then(function (response) {
          return response.data;
        });
      },
      addZero: function addZero(n) {
        return n < 10 ? '0' + n : '' + n;
      }
    };

    common.salesforceSync = function (body) {
      common.method.run({
        key: environment.cloudscript.salesforceSync,
        params: body
      }).then();
    };

    common.confirmModal = function (_config, cb, cbErr) {
      var sw = null;
      var modal = $uibModal.open({
        templateUrl: 'views/confirm_modal.html',
        controller: 'confirmModalCtrl',
        controllerAs: 'obj',
        backdrop: 'static',
        size: _config.size || 'sm',
        resolve: {
          config: function config() {
            return {
              title: _config.title,
              msj: _config.msj,
              trustMsj: _config.trustMsj,
              save: _config.saveText,
              cancel: _config.cancelText,
              alignRight: _config.alignRight,
              hideCancel: _config.hideCancel,
              showIssue: _config.showIssue,
              showRestoreInventory: _config.showRestoreInventory,
              restoreInventory: _config.restoreInventory,
              msjClass: _config.msjClass,
              saveBtnColor: _config.saveBtnColor || 'btn-primary',
              cancelBtnColor: _config.cancelBtnColor || 'btn-danger'
            };
          }
        }
      });

      modal.result.then(function (assignTo) {
        sw = assignTo;
      });

      modal.closed.then(function () {
        if (sw) {
          cb();
          return;
        }
        if (sw != null) {
          if (cbErr) {
            cbErr();
          }
        }
      });
    };

    common.promptModal = function (_config2, cb, cbErr) {
      var modal = $uibModal.open({
        templateUrl: 'views/prompt_modal.html',
        controller: 'promptModalCtrl',
        controllerAs: 'obj',
        backdrop: 'static',
        keyboard: false,
        size: _config2.size || 'sm',
        resolve: {
          config: function config() {
            return {
              msj: _config2.msj,
              save: _config2.saveText,
              cancel: _config2.cancelText,
              hideCancel: _config2.hideCancel
            };
          }
        }
      });

      modal.result.then(function (message) {
        if (message) {
          cb(message);
          return;
        }
        if (cbErr) {
          cbErr();
        }
      });
    };

    common.setValueIssue = function (issue) {
      return issue;
    };

    common.setValueRestoreInventory = function (restoreInventory) {
      return restoreInventory;
    };

    common.listGrowers = function (countries, onSuccess, onError) {
      var query = common.sbx.with('grower').andWhereIsIn('country', countries).setPage(1).setPageSize(1000).compile();
      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res.results);
        } else {
          onError(res.error);
        }
      });
    };

    common.showDialogProgress = function (_config3, cb, cbErr) {
      return $uibModal.open({
        templateUrl: 'views/progress_dialog.html',
        controller: ['$uibModalInstance', 'config', function ($uibModalInstance, config) {
          var modal = this;
          modal.msj = config.msj;
        }],
        controllerAs: 'modal',
        keyboard: false,
        backdrop: 'static',
        animation: false,
        size: 'md',
        resolve: {
          config: function config() {
            return _config3;
          }
        }
      });
    };

    common.loadPage = function (query, page, onSuccess, onError) {
      query.page = page;

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    /**
     * Loads all the pages for a given entity
     * Also wires de fetched entities using the wireFetch function
     * @param query
     * @param onSuccess (with a results objects that contains {results:[], fetched_results:{}}
     * @param onError
     */
    common.loadAllPages = function (query, onSuccess, onError) {
      // always load from the first page
      query.page = 1;
      query.size = 1000;

      if (!query.where) {
        onError(new Error('Invalid value: ' + value));
        return;
      }

      async.waterfall([function (cb) {
        var items = [];

        var fetched_results = {};

        common.loadPage(query, 1, function (data) {

          items = items.concat(data.results);

          if (data.fetched_results) {
            fetched_results = data.fetched_results;
          }

          cb(null, items, data.total_pages, fetched_results);
        }, function (err) {
          cb(err);
        });
      }, function (items, total_pages, fetched, cb) {
        var fetched_results = fetched;

        // no more pages pending
        if (total_pages < 2) {
          cb(null, items, fetched_results);
          return;
        }

        // create an array with integers from 2..total_pages, like: [2,3,4...]
        //let pages = new Array(total_pages).fill().map((_, i) => i + 1).slice(1);

        var pages = [];

        for (var i = 2; i <= total_pages; i++) {
          pages.push(i);
        }

        async.eachLimit(pages, 10, function (index, cbIter) {
          common.loadPage(query, index, function (data) {
            if (data.fetched_results) {
              Object.keys(data.fetched_results).forEach(function (type_name) {
                if (!fetched_results.hasOwnProperty(type_name)) {
                  fetched_results[type_name] = {};
                }

                for (var key in data.fetched_results[type_name]) {
                  if (data.fetched_results[type_name].hasOwnProperty(key)) {
                    fetched_results[type_name][key] = data.fetched_results[type_name][key];
                  }
                }
              });
            }

            items = items.concat(data.results);

            cbIter(null);
          }, function (err) {
            cbIter(err);
          });
        }, function (errIter) {
          cb(errIter, items, fetched_results);
        });
      }], function (err, items, fetched_results) {
        if (err) {
          onError(err);
        } else {
          onSuccess({ results: items, fetched_results: fetched_results });
        }
      });
    };

    common.registerUser = function (query, onSuccess, onError) {
      common.method.get(common.urls.register, query).then(function () {
        var response = common.response.get.data;
        if (response.success) {
          onSuccess(response);
        } else {
          onError('Cannot register user');
        }
      });
    };

    common.getStripe = function () {
      return common.stripe;
    };

    common.setStripe = function (stripe) {
      common.stripe = stripe;
    };
    common.checkPicture = function (url, elem) {
      var deferred = $q.defer();
      elem.def = deferred;

      var image = new Image();
      image.onerror = function () {
        deferred.resolve(false);
      };
      image.onload = function () {
        deferred.resolve(true);
      };
      image.src = url;
      return deferred.promise;
    };

    common.onSuccessDefault = function (res) {
      console.log(res);
    };

    common.onErrorDefault = function (err) {
      if (err) {
        alertify.error(err);
      }
    };

    common.loadGrowerCustomerRelation = function (onSuccess, onError) {
      var model = common.getUserData().ibf_role === 'FLORIST' ? 'customer' : 'grower';

      var query = common.sbx.with('customer_grower_relationship').andWhereIsEqual(model, common.getUserData()[model]).compile();

      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer_grower_relationship')
        .addCondition('AND', model, '=', common.getUserData()[model])
        .compile();*/

      common.loadAllPages(query, function (res) {
        onSuccess(res);
      }, onError);
    };

    common.getGrowerShipDays = function (onSuccess, onError) {
      var query = common.sbx.with('grower');
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('grower')*/
    };

    common.getCurrentUserCountries = function () {
      var currentUser = common.getUserData();
      var countries = [];
      if (currentUser.ibf_role === 'COUNTRY_MANAGER') {
        countries = currentUser.countries.map(function (item) {
          return item.country;
        });
      }
      return countries;
    };

    common.listCountries = function (onSuccess, onError) {
      var countries = common.getCurrentUserCountries();

      var query = common.sbx.with('country');

      if (countries.length) {
        query.whereWithKeys(countries);
      }

      common.loadAllPages(query.compile(), function (data) {
        var countries = data.results.sort(function (a, b) {
          return a.country.localeCompare(b.country);
        });
        onSuccess({ countries: countries });
      }, onError);
    };

    common.listCities = function (onSuccess, onError) {
      var query = common.sbx.with('city').fetchModels(['country']).setPage(1).setPageSize(1000).compile();

      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('city')
        .fetchModels(['country'])
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res.results);
        } else {
          onError(res.error);
        }
      });
    };

    common.getWeekNum = function (d) {
      var weekShift = 1;
      d.setDate(d.getDate() + 4 - (d.getDay() + weekShift || 7));
      var yearStart = new Date(d.getFullYear(), 0, 4);
      var weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
      return weekNo;
    };

    common.convertNumberDateToDate = function (number_date) {
      try {
        var string_date = number_date.toString();
        var year = string_date.slice(0, 4);
        var month = string_date.slice(4, 6);
        var day = string_date.slice(6, 8);
        var date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        return date;
      } catch (e) {}
    };

    common.convertNumberDateToDateEst = function (number_date) {
      var string_date = number_date.toString();
      var year = string_date.slice(0, 4);
      var month = string_date.slice(4, 6);
      var day = string_date.slice(6, 8);
      var momentDate = moment.tz(year + '-' + month + '-' + day + ' 08:00', 'America/New_York');
      var date = new Date(momentDate.toISOString());
      return date;
    };

    common.convertDateToNumberDate = function (date) {
      var tz = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'America/New_York';

      date = new Date(date);
      var zone = tz ? moment.tz.guess() : 'America/New_York';
      var dateResult1 = new Date(date).numDateWithoutTimeZone();
      var dateResult2 = parseInt(moment(date).tz(zone).format('YYYYMMDD'), 10);
      switch (true) {
        case dateResult1 === dateResult2 && common.convertNumberDateToDate(dateResult1).getDay() === date.getDay():
          return dateResult1;
        case common.convertNumberDateToDate(dateResult1).getDay() === date.getDay():
          return dateResult1;
        case common.convertNumberDateToDate(dateResult2).getDay() === date.getDay():
          return dateResult1;
        default:
          alertify.error('Error on date conversion detected');
          return null;
      }
    };

    common.convertDateToNumberDateWithoutTimeZone = function (date) {
      return parseInt(moment(date).format('YYYYMMDD'), 10);
    };

    common.convertDateToMMDDYY = function (date) {
      return moment(date).format('MM-DD-YYYY');
    };

    common.getTimeEST = function getTimeEST() {
      var today = moment(new Date());
      var tz = today.tz('America/New_York').format('H');
      return tz;
    };

    common.getTodayEST = function getTodayEST() {
      var today = moment(new Date());
      var tz = today.tz('America/New_York').format('YYYYMMDD');
      return parseInt(tz);
    };

    // modifier: 1 for increasing list ej: [2019, 2020, 2021]; -1 for decresing ej: [2018, 2017, 2016];
    // max: how many years to count
    // year: starting year, empty to start from current year
    common.getYearList = function getYearList(modifier, max, year) {
      year = year || new Date().getFullYear();
      return Array.apply(null, { length: max }).map(function (value, index) {
        return year + modifier * index;
      });
    };

    common.getMonthList = function getMonthList() {
      return [{ month: 'January', id: 0 }, { month: 'February', id: 1 }, { month: 'March', id: 2 }, { month: 'April', id: 3 }, { month: 'May', id: 4 }, { month: 'June', id: 5 }, { month: 'July', id: 6 }, { month: 'August', id: 7 }, { month: 'September', id: 8 }, { month: 'October', id: 9 }, { month: 'November', id: 10 }, { month: 'December', id: 11 }];
    };

    common.checkUserPromotion = function (user, callback) {
      var query = common.sbx.with('purchase').andWhereIsEqual('customer_user.customer', user.customer).setPage(1).setPageSize(1000).compile();

      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('purchase')
        .setPage(1)
        .setPageSize(1000)
        .addCondition('AND', 'customer_user.customer', '=', user.customer)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        user.is_gift = false;
        if (res.success) {
          if (res.results.length == 0) {
            user.is_gift = true;
          }
        } else {
          alertify.error(ress.error);
        }

        callback();
      });
    };

    common.verifyCloseTimeFlorist = function (date) {
      var pd = new Date(date);
      var today = new Date();
      var today_hour = common.getTimeEST(today);
      if (today < pd) {
        return true;
      } else {
        if (today == pd && today_hour < 8) {
          return true;
        }
        return false;
      }
    };

    common.verifyCloseTimeGrower = function (date) {
      var pd = new Date(date);
      var today = new Date();
      var min = today.getMinutes();
      var today_hour = common.getTimeEST(today);
      if (today < pd) {
        return true;
      } else {
        if (today == pd && today_hour < 8 && min < 30) {
          return true;
        }
        return false;
      }
    };

    common.setConfigTrackJS = function (config) {
      config.version = common.version_app;
      $window.trackJs.configure(config);
    };

    common.addTrackJSMetadata = function (label, value) {
      $window.trackJs.addMetadata(label, value);
    };

    common.getBaseQueryCartBox = function (size, page) {
      return common.sbx.with('cart_box').setPageSize(size || 100).setPage(page || 1).fetchModels(['box', 'customer', 'grade', 'carrier', 'grower.country', 'product_group', 'status', 'purchase.state', 'variety']);
    };

    common.fetchCartBox = function (res, onSuccess, onError) {
      var fetched = res.fetched_results;
      angular.forEach(res.results, function (item) {
        item.box = fetched.admin_box[item.box];
        item.customer = fetched.customer[item.customer];
        item.grade = fetched.grade[item.grade];
        item.grower = fetched.grower[item.grower];

        if (item.grower.country && fetched.country && fetched.country[item.grower.country]) {
          item.grower.country = fetched.country[item.grower.country];
        }

        item.product_group = fetched.product_group[item.product_group];
        item.purchase = item.purchase ? fetched.purchase[item.purchase] : null;
        item.state = item.purchase ? fetched.state[item.purchase.state] : null;
        item.status = item.status ? fetched.cart_box_status[item.status] : null;
        item.variety = item.variety ? fetched.variety[item.variety] : null;
        item.arrival_date = new Date(item.arrival_date);
        item.eta_date = common.convertNumberDateToDate(item.eta_date);
        if (fetched.carrier && item.carrier && fetched.carrier[item.carrier]) {
          item.carrier_name = fetched.carrier[item.carrier].carrier;
        } else {
          item.carrier_name = "Fedex";
        }

        // debugger

        if (item.packing_date) {
          item.packing_date = common.convertNumberDateToDate(item.packing_date);
        }
        if (item.charge_date) {
          item.charge_date = common.convertNumberDateToDate(item.charge_date);
        }
      });
      onSuccess(res);
    };

    /**
     * Create audit in the model audit
     * @param auditObj Object Audit like this example: { action: 'ACTION', user: 'xxxx-xxxx-xxxx-xxxx', date: new Date(), description: 'lorem ipsum', object_string: JSON.stringify({}) }
     * @param onSuccess The success function that will return the array of users
     * @param onError The error callback with the Error object as a parameter.
     */
    common.createAudit = function (auditObj, onSuccess, onError) {
      var query = common.sbx.insert('audit', auditObj);

      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('audit')
        .addObject(auditObj).compile();*/

      common.method.insert(query).then(function (res) {
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    // SCRIPTS HELPERS

    common.imageExists = function (imageSrc, success, error) {
      var img = new Image();
      img.onload = success;
      img.onerror = error;
      img.src = imageSrc;
    };

    common.dataURItoBlob = function (dataURI) {
      var byteString = atob(dataURI.split(',')[1]);
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ab = new ArrayBuffer(byteString.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    };

    common.clearZero = function () {
      console.info('START CLEARZERO');
      async.waterfall([function (cb) {
        var box = {
          invs: []
        };

        var query = common.sbx.with('inventory').andWhereIsEqual('price', '0').compile();
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('inventory')
        .addCondition('AND', 'price', '=', '0')
        .compile();*/
        common.method.query(common.urls.find, query).then(function () {
          var response = common.response.post_query.data;
          if (response.success) {
            console.log('FIND->INVALID', response.results.length);
            box.invs = response.results;
            cb(null, box);
          }
        });
      }, function (box, cb) {
        var listTmp = [];
        angular.forEach(box.invs, function (inv) {
          listTmp.push({
            _KEY: inv._KEY,
            quantity: 0
          });
        });
        var query = common.sbx.insert('inventory', listTmp);

        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('inventory')
        .addObjectArray(listTmp)
        .compile();*/

        common.method.query(common.urls.update, query).then(function () {
          var response = common.response.post_query.data;
          cb(null, box);
        });
      }], function () {
        console.info('FINISH CLEARZERO');
      });
    };

    common.applyGift = function (cartboxes, callback) {
      var total_gift = 0;
      var user = common.getUserData();
      async.waterfall([function (cb) {
        // ACK PROMOTION
        common.checkUserPromotion(user, function () {
          cb(null);
        });
      }, function (cb) {
        // APPLY GIFT
        if (user.is_gift && cartboxes.length > 0) {
          cartboxes[0].is_gift = true;
          cartboxes[0].off = common.offer_per;
          total_gift = cartboxes[0].price * common.offer_per;
        }

        cb(null);
      }, function (cb) {
        // Apply cybermonday discount
        console.log('HUH?');
        if (common.actual_domain === 96) {
          if (common.getTodayEST() !== 20171126 && common.getTodayEST() !== 20171127) {
            console.log('No cybermonday for you!');
            return cb(null);
          }
        } else if (common.getTodayEST() !== 20171127) {
          console.log('No cybermonday for you!');
          return cb(null);
        }

        // if today is cybermonday, add 5% discount to all the boxes that have a discount of '0'
        cartboxes.forEach(function (cartBox) {
          if (cartBox.off === 0.0) {
            cartBox.off = 0.05;
            cartBox.is_gift = true;
            total_gift += cartBox.off * cartBox.price;
            console.log('New discount for box ' + cartBox.consecutive + ' it got: ' + cartBox.off);
          } else {
            console.log('No discount for box ' + cartBox.consecutive + ' it already has: ' + cartBox.off);
          }
        });

        cb(null);
      }], function (err) {
        if (err) {
          console.log(err);
        }
        callback({
          total_gift: total_gift
        });
      });
    };

    common.createFolders = function () {
      console.log('start createFolders');
      async.waterfall([function (cb) {
        var query = common.sbx.with('customer').setPage(1).setPageSize(1000).compile();
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer')
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

        common.method.query(common.urls.find, query).then(function () {
          var response = common.response.post_query.data;
          if (response.results.length > 0) {
            var customer_keys = [];
            angular.forEach(response.results, function (customer) {
              customer_keys.push(customer._KEY);
            });

            cb(null, customer_keys);
          }
        });
      }, function (customer_keys, cb) {
        angular.forEach(customer_keys, function (customer_key) {
          common.method.post(common.urls.addFolder, {
            parent_key: common.florist_folder_key,
            name: customer_key
          }).then(function () {
            var response = common.response.post.data;
            if (response.success) {
              console.log(customer_key + ' -> Customer Folder Created');
            } else {
              console.log(customer_key + ' -> Customer Folder Exist');
            }
          });
        });
      }], function () {
        console.log('finish createFolders');
      });
    };

    common.check = function (callback) {
      async.waterfall([function (cb) {
        var box = {
          invNotDelete: [],
          inventory: [],
          onlyInfo: true,
          mapping: {}
        };
        var query = common.sbx.with('inventory').compile();
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('inventory')
        .compile();*/

        common.loadAllPages(query, function (data) {
          box.inventory = angular.copy(data);
          cb(null, box);
        }, function (err) {
          alertify.error(err);
        });
      }, function (box, cb) {
        var query = common.sbx.with('cart_box_item').compile();
        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box_item')
        .compile();*/

        common.loadAllPages(query, function (res) {
          angular.forEach(res.results, function (item) {
            box.invNotDelete.push(item.inventory);
          });
          console.log(box.invNotDelete);
          cb(null, box);
        });
      }, function (box, cb) {
        var inv_ob = {};
        angular.forEach(box.inventory.results, function (item, key) {
          if (!box.mapping[item._KEY]) {
            box.mapping[item._KEY] = item;
          }
          var notDelete = false;
          for (var j = 0; j < box.invNotDelete.length; j++) {
            var invKey = box.invNotDelete[j];
            if (invKey == item._KEY) {
              console.log(invKey, '>--->', item._KEY);
              notDelete = true;
              break;
            }
          }
          item.notDelete = notDelete;
          if (!inv_ob[item.masterlist + '_' + item.week]) {
            inv_ob[item.masterlist + '_' + item.week] = {
              inv_max: null,
              items: []
            };
          }
          if (inv_ob[item.masterlist + '_' + item.week].inv_max) {
            if (item.price > inv_ob[item.masterlist + '_' + item.week].inv_max.price && !item.notDelete) {
              inv_ob[item.masterlist + '_' + item.week].inv_max = item.price;
            }
          } else {
            if (!item.notDelete) {
              inv_ob[item.masterlist + '_' + item.week].inv_max = item.price;
            }
          }
          inv_ob[item.masterlist + '_' + item.week].items.push(item);
        });

        box.invToDelete = [];
        var tmpIndex = 0;
        angular.forEach(inv_ob, function (data) {
          var item = data.items;
          if (item.length > 1) {
            for (var i = 0; i < item.length; i++) {
              tmpIndex++;
              console.info('INV TO DELETE->before ' + item[i]._KEY + ' ' + item[i].notDelete + ' : ' + tmpIndex);
              if (item[i].notDelete) {
                continue;
              }
              if (item[i]._KEY != data.inv_max._KEY) {
                box.invToDelete.push(item[i]._KEY);
              }
            }
          }
        });
        cb(null, box);
      }, function (box, cb) {
        console.log(JSON.stringify(box.invToDelete));
        for (var i = 0; i < box.invToDelete.length; i++) {
          var element = box.invToDelete[i];
          var aux = box.mapping[element]._META;
          var created = new Date(aux.created_time).toLocaleString();
          var updated = new Date(aux.updated_time).toLocaleString();
          console.info('INV TO DELETE->after -- ' + element + ' : ' + (i + 1) + ' > CREATED-> ' + created + ' -- UPDATED-> ' + updated);
        }
        cb(null, box);
      }, function (box, cb) {
        if (box.onlyInfo) {
          return cb(null, box);
        }
        var query = common.sbx.with('inventory').whereWithKeys(box.invToDelete).compile();
        /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('inventory')
        .whereWithKeys(box.invToDelete).compile();*/
        common.method.query(common.urls.delete, query).then(function () {
          var res = common.response.post_query.data;
          console.log('INV DELETED');
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.updateMarginPurchase = function (callback) {
      async.waterfall([function (cb) {
        var box = {};

        var query = common.sbx.with('purchase').fetchModels(['customer_user.customer']).compile();
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('purchase')
        .fetchModels([
          'customer_user.customer'
        ])
        .compile();*/

        common.loadAllPages(query, function (res) {
          var fetched = res.fetched_results;
          angular.forEach(res.results, function (item, index) {
            item.customer_user = fetched.user[item.customer_user];
            item.customer_user.customer = fetched.customer[item.customer_user.customer] || item.customer_user.customer;
          });
          box.purchases = res.results;
          cb(null, box);
        });
      }, function (box, cb) {
        var listTmp = [];
        angular.forEach(box.purchases, function (po) {
          listTmp.push({
            _KEY: po._KEY,
            margin: po.customer_user.customer.margin
          });
        });

        var query = common.sbx.insert('purchase', listTmp);
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('purchase')
        .addObjectArray(listTmp)
        .compile();*/

        common.method.query(common.urls.update, query).then(function () {
          var response = common.response.post_query.data;
          console.log(response);
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.updateMarginCustomer = function (callback) {
      async.waterfall([function (cb) {
        var box = {};

        var query = common.sbx.with('customer').compile();
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer')
        .compile();*/

        common.loadAllPages(query, function (res) {
          box.customers = res.results;
          cb(null, box);
        });
      }, function (box, cb) {
        var listTmp = [];
        angular.forEach(box.customers, function (customer) {
          listTmp.push({
            _KEY: customer._KEY,
            margin: 16
          });
        });
        var query = common.sbx.insert('customer', listTmp);
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer')
        .addObjectArray(listTmp)
        .compile();*/

        common.method.query(common.urls.update, query).then(function () {
          var response = common.response.post_query.data;
          console.log(response);
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.updateBasePrice = function (callback) {
      async.waterfall([function (cb) {
        var box = {
          array_update: []
        };
        var query = common.sbx.with('cart_box_item').andWhereIsNull('base_price').andWhereIsNotNull('inventory').fetchModels(['inventory']).compile();
        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box_item')
        .addCondition('AND', 'base_price', 'is', null)
        .addCondition('AND', 'inventory', 'is not', null)
        .fetchModels(['inventory'])
        .compile();*/

        common.loadAllPages(query, function (res) {
          angular.forEach(res.results, function (item) {
            item.inventory = res.fetched_results.inventory[item.inventory];
            switch (item.inventory.combo) {
              case 1:
                item.off = 10;
                break;
              case 2:
                item.off = 20;
                break;
              case 3:
                item.off = 30;
                break;
              case 4:
                item.off = 40;
                break;
              case 5:
                item.off = 50;
                break;
              default:
                item.off = 0;
            }
            box.array_update.push({
              _KEY: item._KEY,
              off: item.off,
              base_price: item.inventory.price
            });
          });
          cb(null, box);
        });
      }, function (box, cb) {
        console.log('Total Cartbox Items to Update: ' + box.array_update.length);
        var query = common.sbx.insert('cart_box_item', box.array_update);
        /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box_item')
        .addObjectArray(box.array_update)
        .compile();*/
        common.method.query(common.urls.update, query).then(function () {
          var res = common.response.post_query.data;
          console.log('Cart Box Item Updated');
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.updateCloseCartBox = function (callback) {
      async.waterfall([function (cb) {
        var box = {
          array_update: []
        };

        var query = common.sbx.with('cart_box').andWhereIsNull('closed').compile();
        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addCondition('AND', 'closed', 'is', null)
        .compile();*/

        common.loadAllPages(query, function (res) {
          angular.forEach(res.results, function (item) {
            if (item.current_items == item.total_items) {
              box.array_update.push({
                _KEY: item._KEY,
                closed: true
              });
            }
          });
          cb(null, box);
        });
      }, function (box, cb) {
        console.log('Total Cartbox Items to Update: ' + box.array_update.length);
        var query = common.sbx.insert('cart_box', box.array_update);
        /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addObjectArray(box.array_update)
        .compile();*/
        common.method.query(common.urls.update, query).then(function () {
          var res = common.response.post_query.data;
          console.log('Cart Boxes Updated');
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.updateMixedCartBox = function (callback) {
      async.waterfall([function (cb) {
        var box = {
          array_update: []
        };
        var query = common.sbx.with('cart_box');

        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addCondition('AND', 'mixed', '=', true)
        .compile();*/

        common.loadAllPages(query, function (res) {
          angular.forEach(res.results, function (item) {
            if (item.current_items == item.total_items) {
              box.array_update.push({
                _KEY: item._KEY,
                custom: true
              });
            }
          });
          cb(null, box);
        });
      }, function (box, cb) {
        console.log('Total Cartbox Items to Update: ' + box.array_update.length);
        var query = common.sbx.insert('cart_box', box.array_update);

        /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addObjectArray(box.array_update)
        .compile();*/
        common.method.query(common.urls.update, query).then(function () {
          var res = common.response.post_query.data;
          console.log('Cart Boxes Updated');
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.updateOrderInAdvance = function (callback) {
      async.waterfall([function (cb) {
        var box = {
          array_update: []
        };
        var query = common.sbx.with('add_masterlist').andWhereIsEqual('grower', 'a54161e3-60da-4d82-ab4c-8a7a2ecfc602').andWhereIsEqual('product_group', '7a68bebd-2346-4e73-9906-a7665c22ce20').compile();
        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('add_masterlist')
        .addCondition('AND', 'grower', '=', 'a54161e3-60da-4d82-ab4c-8a7a2ecfc602')
        .addCondition('AND', 'product_group', '=', '7a68bebd-2346-4e73-9906-a7665c22ce20')
        .compile();*/

        common.loadAllPages(query, function (res) {
          angular.forEach(res.results, function (item) {
            box.array_update.push({
              _KEY: item._KEY,
              order_in_advance: 1
            });
          });
          cb(null, box);
        });
      }, function (box, cb) {
        console.log('Total masterlist Items to Update: ' + box.array_update.length);
        var query = common.sbx.insert('add_masterlist', box.array_update);
        /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('add_masterlist')
        .addObjectArray(box.array_update)
        .compile();*/
        common.method.query(common.urls.update, query).then(function () {
          var res = common.response.post_query.data;
          console.log('Masterlist Updated');
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.createImportDuties = function (callback) {
      async.waterfall([function (cb) {
        var data = {
          countries: ['NL', 'EC'],
          verify: true,
          value: 6.4,
          countriesMap: {},
          list: [],
          mappingExist: {}
        };

        var query = common.sbx.with('product_group').compile();
        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('product_group')
        .compile();*/

        common.loadAllPages(query, function (res) {
          data.list = res.results;
          cb(null, data);
        });
      }, function (data, cb) {
        // load and mapping countries
        var query = common.with('country').compile();
        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('country')
        .compile();*/

        common.loadAllPages(query, function (res) {
          angular.forEach(res.results, function (item) {
            data.countriesMap[item.country_iso] = item._KEY;
          });
          cb(null, data);
        });
      }, function (data, cb) {
        // verify to prevent duplicate
        if (!data.verify) {
          return cb(null, data);
        }

        var query = common.sbx.with('import_duties').compile();
        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('import_duties')
        .compile();*/

        common.loadAllPages(query, function (res) {
          angular.forEach(res.results, function (item) {
            var relation = item.country + '_' + item.product_group;
            data.mappingExist[relation] = item._KEY;
          });
          cb(null, data);
        });
      }, function (data, cb) {
        var arrayObj = [];
        for (var i = 0; i < data.list.length; i++) {
          var productGroup = data.list[i];
          for (var j = 0; j < data.countries.length; j++) {
            var countryISO = data.countries[j];
            var countryKEY = data.countriesMap[countryISO];
            var rela = countryKEY + '_' + productGroup._KEY;
            if (data.mappingExist[rela]) {
              continue;
            }
            console.info(countryISO + '-' + productGroup.common_name + '-' + data.value);
            arrayObj.push({
              country: countryKEY,
              product_group: productGroup._KEY,
              tax: data.value
            });
          }
        }
        var query = common.sbx.insert('import_duties', arrayObj);
        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('import_duties')
        .addObjectArray(arrayObj)
        .compile();*/

        common.method.query(common.urls.row, query).then(function () {
          var res = common.response.post_query.data;
          if (res.success) {
            cb(null, data);
          }
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.setupGrowerCustomBoxCost = function (callback) {
      async.waterfall([function (cb) {
        var box = {};

        var query = common.sbx.with('grower').andWhereIsNull('custom_box_cost').compile();
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('grower')
        .addCondition('AND', 'custom_box_cost', 'is', null)
        .compile();*/

        common.loadAllPages(query, function (res) {
          box.growers = res.results;
          cb(null, box);
        });
      }, function (box, cb) {
        var listTmp = [];
        angular.forEach(box.growers, function (grower) {
          listTmp.push({
            _KEY: grower._KEY,
            custom_box_cost: 2.5
          });
        });
        var query = common.insert('grower', listTmp);
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('grower')
        .addObjectArray(listTmp)
        .compile();*/

        common.method.query(common.urls.update, query).then(function () {
          var response = common.response.post_query.data;
          console.log(response);
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.updateMasterlistLength = function (callback) {
      async.waterfall([function (cb) {
        var box = {};
        var query = common.sbx.with('add_masterlist').andWhereIsNotNull('box.fixed_length').newGroupWithAnd().andWhereIsNull('length').orWhereIsEqual('length', 0).fetchModels(['box']).compile();

        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('add_masterlist')
        .addCondition('AND', 'box.fixed_length', 'is not', null)
        .newGroup('AND')
        .addCondition('AND', 'length', 'is', null)
        .addCondition('OR', 'length', '=', 0)
        .fetchModels(['box'])
        .compile();*/

        common.loadAllPages(query, function (res) {
          box.res = res;
          cb(null, box);
        });
      }, function (box, cb) {
        var listTmp = [];
        angular.forEach(box.res.results, function (masterlist) {
          listTmp.push({
            _KEY: masterlist._KEY,
            length: parseInt(box.res.fetched_results.admin_box[masterlist.box].fixed_length.replace(/[^\d.-]/g, ''))
          });
        });
        var query = common.sbx.insert('add_masterlist', listTmp);
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('add_masterlist')
        .addObjectArray(listTmp)
        .compile();*/

        common.method.query(common.urls.update, query).then(function () {
          var response = common.response.post_query.data;
          console.log(response);
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };

    common.updateFixBasePrice = function (callback) {
      async.waterfall([function (cb) {
        var box = {
          array_update: []
        };

        var query = common.sbx.with('cart_box_item').andWhereIsEqual('cart_box_custom', true).andWhereIsNotNull('cart_box.custom_box_cost').fetchModels(['inventory.masterlist', 'cart_box', 'uom', 'stems_per_bunch']).compile();
        /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box_item')
        .addCondition('AND', 'cart_box.custom', '=', true)
        .addCondition('AND', 'cart_box.custom_box_cost', 'is not', null)
        .fetchModels(['inventory.masterlist', 'cart_box', 'uom', 'stems_per_bunch'])
        .compile();*/

        common.loadAllPages(query, function (res) {
          angular.forEach(res.results, function (item) {
            item.inventory = res.fetched_results.inventory[item.inventory];
            item.inventory.masterlist = res.fetched_results.add_masterlist[item.inventory.masterlist] || item.inventory.masterlist;
            item.cart_box = res.fetched_results.cart_box[item.cart_box];
            item.uom = res.fetched_results.uom[item.uom];
            item.stems_per_bunch = res.fetched_results.stems_per_bunch[item.stems_per_bunch];

            var boxGrower = item.inventory.masterlist.box_charge / item.inventory.masterlist.units;
            var custom_box_cost = item.cart_box.custom_box_cost * (item.percentage / 100);
            custom_box_cost = parseFloat(custom_box_cost) / parseFloat(item.stems_per_bunch.stems_per_bunch);
            custom_box_cost = parseFloat(custom_box_cost.toFixed(2));
            if (item.cart_box.consecutive == 6168) {
              console.log('custom_box_cost -> ' + item.cart_box.custom_box_cost, 'stems_per_bunch -> ' + item.stems_per_bunch.stems_per_bunch);
              console.log(item.inventory.price, boxGrower, custom_box_cost);
            }
            var base_price = item.inventory.price + boxGrower + custom_box_cost;

            box.array_update.push({
              _KEY: item._KEY,
              base_price: base_price
            });
          });
          cb(null, box);
        });
      }, function (box, cb) {
        console.log('Total Cartbox Items to Update: ' + box.array_update.length);
        var query = common.sbx.insert('cart_box_item', box.array_update);
        /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box_item')
        .addObjectArray(box.array_update)
        .compile();*/
        common.method.query(common.urls.update, query).then(function () {
          var res = common.response.post_query.data;
          console.log('Cart Box Item Updated');
          cb(null, box);
        });
      }], function () {
        console.log('FINISH');
        callback();
      });
    };
    common.updateStateOrder = function (_key, grower_approved, onSuccess, onError) {
      var query = common.sbx.insert('cart_box', {
        '_KEY': _key,
        'grower_approved': grower_approved,
        'grower_approved_date': moment(new Date()).tz('America/New_York')
      });
      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    common.updateMasterlistInventory = function (masterlists, callback) {
      async.waterfall([function (cb) {
        var chunk = _.chunk(masterlists, 1000);
        var inventories = [];
        async.eachSeries(chunk, function (pack, next) {
          var query = common.sbx.with('inventory').andWhereGreaterOrEqualThan('end_date', new Date().numDateWithoutTimeZone()).andWhereIsIn('masterlist', pack).compile();

          common.loadAllPages(query, function (data) {
            if (data.results.length) {
              inventories.push.apply(inventories, _toConsumableArray(data.results.map(function (inv) {
                return inv._KEY;
              })));
            }
            next();
          }, function (_) {
            return next();
          });
        }, function (_) {
          cb(null, inventories);
        });
      }, function (inventories, cb) {
        common.method.run({
          key: environment.cloudscript.updateMasterlistInventory,
          params: { keys: masterlists, inventories: inventories }
        }).then(function () {
          cb(null);
        }, cb);
      }, function (cb) {
        common.method.run({
          key: environment.cloudscript.loadDependencies,
          params: {
            fromDb: true,
            includes: ['add_masterlist'],
            keys: { add_masterlist: masterlists }
          }
        }).then(function () {
          cb(null);
        }, cb);
      }], callback);
    };

    common.getMasterlistByGrowerOrderRequestItem = function (grower, item, cb) {
      var product_group = item.product_group,
          variety = item.variety,
          length = item.length;

      common.getMasterlistByGrowerVarieyProductGroup(grower, variety, product_group, length, function (r) {
        return cb(null, r);
      }, cb);
    };

    common.getMasterlistByGrowerVarieyProductGroup = function (key_grower, key_variety, key_product_group, length, onSuccess, onError) {
      var query = common.sbx.with('add_masterlist').andWhereIsEqual('grower', key_grower).andWhereIsEqual('variety', key_variety).andWhereIsEqual('product_group', key_product_group).fetchModels(['stems_per_bunch']);

      if (length > 0) {
        query.andWhereGreaterOrEqualThan('length', length);
      }

      common.loadAllPages(query.compile(), onSuccess, onError);
    };

    common.iterator = function (f, u) {
      var arr = [];
      var i = f;
      while (i <= u) {
        arr.push(i++);
      }return arr;
    };
    common.diffMinutes = function (dt2, dt1) {
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    };

    common.refreshMasterlist = function () {
      return $http({
        method: 'GET',
        url: 'https://app.ibuyflowers.com/api/api_ibf/masterlist/refresh'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        console.log(error);
      });
    };

    return common;
  }
})(angular);
//# sourceMappingURL=commonSrv.js.map

'use strict';

(function (angular) {

  angular.module('ibf').factory('sessionSrv', ['$http', '$state', 'commonSrv', '$cookies', '$rootScope', '$window', 'environment', sessionSrv]);

  function sessionSrv($http, $state, commonSrv, $cookies, $rootScope, $window, environment) {
    var service = {},
        common = commonSrv;
    var url = document.URL;

    service.isLogged = function () {
      return service.user;
    };

    service.user = {};
    service.config = {};
    service.redirectUrl = '';

    service.getToken = function () {
      return localStorage.getItem('token');
    };

    service.setToken = function (token) {
      localStorage.setItem('token', token);
    };

    service.removeToken = function () {
      localStorage.removeItem('token');
      localStorage.removeItem(environment.appKey + '_token');
    };

    service.validateToken = function () {
      var userKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var fromCountryManager = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var main_role = "";
      if (fromCountryManager) {
        main_role = common.getUserData().data.role;
      }
      var params = {
        key: environment.cloudscript.validate,
        params: {
          token: service.getToken(),
          user_key: userKey
        }
      };

      return common.method.run(params).then(function (res) {

        if (res.success) {

          service.config = res.response.config;
          service.user = res.response.user;
          var user = {
            ibf_role: service.user.role,
            token: res.response.token,
            key: service.user.key,
            version_app: commonSrv.version_app,
            data: Object.assign({}, service.user)
          };

          Object.assign(user, service.user.metadata);
          if (fromCountryManager) {
            Object.assign(user, { fromCountryManager: true, main_role: main_role });
            common.setUserData(user);
            common.setConfig(service.config);
          } else {
            common.setUserData(user);
            common.setConfig(service.config);
          }
        }
        return res;
      });
    };

    service.validate = function (stateRedirect) {
      var user = $cookies.getObject('ibf_user');
      if (typeof user === 'undefined') {
        $state.go('login', { redirect: stateRedirect });
        return false;
      }

      if (user.version_app != common.version_app) {
        service.resetUserData();
        $state.go('login', { redirect: stateRedirect });
        return false;
      }

      var ts = Math.round(new Date().getTime() / 1000);
      common.setConfigTrackJS({
        userId: user.data.email,
        sessionId: user.data.id.toString(),
        onError: function onError(payload) {
          var ignoreErrors = ["Failed to fetch", "angular is not defined"];

          var shouldIgnore = ignoreErrors.some(function (error) {
            return payload.stack && payload.stack.includes(error);
          });

          return !shouldIgnore;
        }

      });
      common.addTrackJSMetadata('role', user.ibf_role);

      return true;
    };

    service.login = function (form_data) {

      return $http.get(common.urls.api + common.urls.login, { params: form_data }).then(function (response) {
        // console.log('login response', response)
        service.loginStatus = response.data.success;
        if (service.loginStatus) {
          var user = response.data.user;
          delete user.member_of;
          $rootScope.$emit('login');
          service.user = {
            token: response.data.token,
            data: user
          };
        }
      });
    };

    service.resetUserData = function () {
      if (typeof common.getUserData() != 'undefined') {
        var ts = Math.round(new Date().getTime() / 1000);
      }

      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        var eqPos = cookie.indexOf('=');
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        if (name === 'email') {
          continue;
        }
        document.cookie = name + '=;domain=.ibuyflowers.com;expires=Thu, 01 Jan 1970 00:00:00 GMT';
      }

      $http.defaults.headers.common['Authorization'] = 'xxxxx';
      $cookies.remove('token', { path: '/', domain: '.ibuyflowers.com' });
      $cookies.remove('ibf_user', { path: '/' });
      $cookies.remove('ibf-user-dev', { path: '/' });
      $cookies.remove('ibf-user', { path: '/' });
      $cookies.remove('token', { path: '/' });
      $cookies.remove('ibf_user', { path: '/v1' });
      $cookies.remove('ibf-user-dev', { path: '/v1' });
      $cookies.remove('ibf-user', { path: '/v1' });
      $cookies.remove('token', { path: '/v1' });

      service.removeToken();
    };

    service.logout = function () {
      var grower = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      $cookies.remove('token', { path: '/', domain: '.ibuyflowers.com' });
      service.resetUserData();
      if (url.indexOf('app.ibuyflowers.com') !== -1 || url.indexOf('test.ibuyflowers.com') !== -1) {
        window.location.href = grower ? common.grower_logout_redirect : common.actual_login_redirect;
        return;
      }
      $state.go('login');
    };

    return service;
  }
})(angular);
//# sourceMappingURL=sessionSrv.js.map

'use strict';

(function (angular) {
  angular.module('ibf').factory('productSrv', ['$rootScope', 'commonSrv', '$filter', productSrv]);

  function productSrv($rootScope, commonSrv, $filter) {
    function parseVariety(variety, fetched) {

      variety.product_group = fetched.product_group[variety.product_group];

      if (variety.product_group && variety.product_group.group_type && (typeof variety.product_group.group_type === 'string' || variety.product_group.group_type instanceof String)) {
        variety.product_group.group_type = fetched.group_type[variety.product_group.group_type];
      }

      variety.color = fetched.color[variety.color];
      variety.variety_name = variety.variety_name.replace(/\b[a-z]/g, function (x) {
        return x.toUpperCase();
      });
    }

    return {
      getMonths: function getMonths() {
        return [{ month: 'January', month_short: 'Jan', month_number: 0 }, { month: 'February', month_short: 'Feb', month_number: 1 }, { month: 'March', month_short: 'Mar', month_number: 2 }, { month: 'April', month_short: 'Apr', month_number: 3 }, { month: 'May', month_short: 'May', month_number: 4 }, { month: 'June', month_short: 'Jun', month_number: 5 }, { month: 'July', month_short: 'Jul', month_number: 6 }, { month: 'August', month_short: 'Aug', month_number: 7 }, { month: 'September', month_short: 'Sep', month_number: 8 }, { month: 'October', month_short: 'Oct', month_number: 9 }, { month: 'November', month_short: 'Nov', month_number: 10 }, { month: 'December', month_short: 'Dec', month_number: 11 }];
      },
      /**
       * Loads all the box_lenght items
       * Receives an onSuccess and onError functions, the success function will receive the Grower object,
       * the error function will receive the error object.
       * @returns {
       * all:[] // array with all the box lengths ordered by the length_type,
       * mapped :{
       * } // a map with all the box lengths separated by length_type
       * types:[] // an array containing all the box lengths
       * }
       *
       * <b>usage:</b>
       * productSrv.listBoxLengths(function(grades){
       *  TODO: do something with the box_lenghts
       * },function(err){
       *  TODO: do something on error
       * });
       */
      listBoxLengths: function listBoxLengths(onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('box_length').setPage(1).setPageSize(1000).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('box_length')
          .setPage(1)
          .setPageSize(1000)
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {

          var res = commonSrv.response.post_query.data;

          if (res.success) {

            var pack = {
              all: [],
              mapped: {},
              types: []
            };

            angular.forEach(res.results, function (item) {

              if (!pack.mapped[item.length_type]) {
                pack.mapped[item.length_type] = [];
                pack.types.push(item.length_type);
              }

              pack.mapped[item.length_type].push(item);
              pack.all.push(item);
            });

            pack.all = $filter('orderBy')(pack.all, 'length_type');

            angular.forEach(Object.keys(pack.mapped), function (key) {
              pack.mapped[key] = $filter('orderBy')(pack.mapped[key], 'index_order');
            });

            onSuccess(pack);
          } else {
            onError(new Error(res.error));
          }
        });
      },
      loadMasterlistByGrower: function loadMasterlistByGrower(grower_key, fetch_array, onSuccess, onError) {
        if (!Array.isArray(fetch_array)) {
          onError(new Error('Second parameter must be an array of strings for the fetched_results.'));
          return;
        }

        var query = commonSrv.sbx.with('add_masterlist').andWhereIsEqual('grower', grower_key).andWhereIsEqual('active', true).fetchModels(fetch_array).setPage(1).setPageSize(1000).compile();

        commonSrv.loadAllPages(query, function (response) {
          onSuccess(response);
        }, function (err) {
          onError(err);
        });
      },

      saveMasterlist: function saveMasterlist(rows, onSuccess, onError) {
        var masterlists = [];
        async.waterfall([function (cb) {
          var tmp = [];

          async.eachSeries(rows, function (row, iterCallback) {
            var item = {
              data: row,
              exists: row.hasOwnProperty('_KEY')
            };

            // console.log('EXISTS?:', item.exists);

            if (item.exists) {
              tmp.push(item);
              iterCallback(null);
              return;
            }

            // console.log('CHECKING');

            var query = commonSrv.sbx.with('add_masterlist').setPage(1).setPageSize(1).andWhereIsEqual('grower', item.data.grower).andWhereIsEqual('variety', item.data.variety).andWhereIsEqual('stems_per_bunch', item.data.stems_per_bunch).andWhereIsEqual('length', item.data.length);

            if (item.data.box) {
              query = query.andWhereIsEqual('box', item.data.box);
            }

            if (item.data.grade) {
              query.andWhereIsEqual('grade', item.data.grade);
            } else {
              query.andWhereIsNull('grade');
            }

            if (item.data.grower_code) {
              query.andWhereIsEqual('grower_code', item.data.grower_code);
            } else {
              query.andWhereIsNull('grower_code');
            }

            query = query.compile();

            commonSrv.method.query(commonSrv.urls.find, query).then(function () {

              var res = commonSrv.response.post_query.data;

              if (res.success) {

                if (res.row_count > 0) {
                  item.exists = true;
                  item.data._KEY = res.results[0]._KEY;
                } else {
                  item.exists = false;
                }

                tmp.push(item);

                iterCallback(null);
              } else {
                iterCallback(new Error(res.error));
              }
            });
          }, function (eachError) {
            cb(eachError, tmp);
          });
        }, function (items, cb) {

          var tmp_items = [];

          angular.forEach(items, function (item) {

            if (item.exists) {
              masterlists.push(item.data._KEY);
              tmp_items.push(item.data);
            }
          });

          if (tmp_items.length < 1) {
            cb(null, items);
            return;
          }

          var query = commonSrv.sbx.insert('add_masterlist', tmp_items, true);

          commonSrv.method.query(commonSrv.urls.update, query).then(function () {
            var response = commonSrv.response.post_query.data;

            if (response.success) {
              cb(null, items);
            } else {
              cb(new Error(response.error ? response.error : 'Error'), items);
            }
          });
        }, function (items, cb) {

          var tmp_items = [];

          angular.forEach(items, function (item) {

            if (!item.exists) {
              tmp_items.push(item.data);
            }
          });

          if (tmp_items.length < 1) {

            // console.log('NOTHING TO CREATE');

            cb(null, items);
            return;
          }

          var query = commonSrv.sbx.insert('add_masterlist', tmp_items);

          commonSrv.method.query(commonSrv.urls.row, query).then(function () {

            var response = commonSrv.response.post_query.data;

            if (response.success) {
              masterlists = masterlists.concat(response.keys);
              cb(null, items);
            } else {
              cb(new Error(response.error ? response.error : 'Error'), items);
            }
          });
        }, function (items, cb) {
          commonSrv.updateMasterlistInventory(masterlists, function () {
            cb(null, items);
          });
        }], function (err) {
          if (err) {
            return onError(err);
          }

          onSuccess(masterlists);
        });
      },

      saveInventory: function saveInventory(rows, masterlist, onSuccess, onError) {

        async.waterfall([
        /**
         * The first step is to check if the rows dont have a wrong date
         * @param cb
         * @author carlos@socobox.co
         */
        function (cb) {
          console.log('Validation the rows');
          rows.forEach(function (inv) {
            var week = new Date(commonSrv.convertNumberDateToDate(inv.week));

            if (week.getDay() === 0) {
              console.error(inv);
              week.setDate(week.getDate() + 1);
              var end_date = new Date(commonSrv.convertNumberDateToDate(inv.end_date));
              end_date.setDate(end_date.getDate() + 1);
              inv.week = week;
              inv.end_date = end_date;
            }
          });
          cb(null, cb);
        }, function (box, cb) {

          var tmp = [];

          angular.forEach(rows, function (row) {
            var item = {
              data: row,
              exists: row.hasOwnProperty('_KEY')
            };

            // console.log('EXISTS?:', item.exists);

            tmp.push(item);
          });
          cb(null, tmp);

          // async.eachSeries(rows,
          //   function (row, iterCallback) {


          //     // console.log("CHECKING");
          //     // console.log(masterlist);


          //     // var query = commonSrv.queryBuilder()
          //     //   .setDomain(commonSrv.actual_domain)
          //     //   .setModel("inventory")

          //     //   .addCondition("AND", "masterlist", "=",item.data.masterlist)
          //     //   .addCondition("AND", "variety", "=",item.data.variety)

          //     //   .addCondition("AND", "week", "=",item.data.week)
          //     //   .setPage(1)
          //     //   .setPageSize(1);

          //     //   if(masterlist.map[item.data.masterlist].length){
          //     //     query.addCondition("AND", "masterlist.length", "=",masterlist.map[item.data.masterlist].length);
          //     //   }else{
          //     //     query.addCondition("AND", "masterlist.box", "=",masterlist.map[item.data.masterlist].box._KEY)
          //     //   }

          //     //   query = query.compile();

          //     // console.log(query);


          //     // commonSrv.method.query(commonSrv.urls.find, query).then(function () {


          //     //   var res = commonSrv.response.post_query.data;

          //     //   if (res.success) {

          //     //     if (res.row_count > 0) {
          //     //       item.exists = true;
          //     //       item.data._KEY = res.results[0]._KEY;
          //     //     }else{
          //     //       item.exists = false;
          //     //     }

          //     //     tmp.push(item);

          //     //     iterCallback(null);
          //     //   } else {
          //     //     iterCallback(new Error(res.error));
          //     //   }

          //     // });

          //   },
          //   function (eachError) {
          //     cb(eachError, tmp);

          //   });

        }, function (items, cb) {

          var tmp_items = [];

          angular.forEach(items, function (item) {

            if (item.exists) {
              tmp_items.push(item.data);
            }
          });

          if (tmp_items.length < 1) {
            // console.log('NOTHING TO UPDATE');
            cb(null, items);
            return;
          }

          // console.log(tmp_items);

          var query = commonSrv.sbx.insert('inventory', tmp_items);
          /*var query = commonSrv.queryBuilder()
            .setDomain(commonSrv.actual_domain)
            .setModel('inventory')
            .addObjectArray(tmp_items)
            .compile();*/

          // console.log('UPDATE QUERY', JSON.stringify(query));


          commonSrv.method.query(commonSrv.urls.update, query).then(function () {

            var response = commonSrv.response.post_query.data;
            if (response.success) {

              cb(null, items);
            } else {

              cb(new Error(response.error ? response.error : 'Error'), items);
            }
          });
        }, function (items, cb) {

          var tmp_items = [];

          angular.forEach(items, function (item) {

            if (!item.exists) {
              tmp_items.push(item.data);
            }
          });

          if (tmp_items.length < 1) {
            // console.log('NOTHING TO CREATE');
            return cb(null, {
              items_new: [],
              items_new_keys: [],
              items: items
            });
          }

          var query = commonSrv.sbx.insert('inventory', tmp_items);
          /*var query = commonSrv.queryBuilder()
            .setDomain(commonSrv.actual_domain)
            .setModel('inventory')
            .addObjectArray(tmp_items)
            .compile();*/

          // console.log('ADD QUERY', JSON.stringify(query));

          commonSrv.method.query(commonSrv.urls.row, query).then(function () {

            var response = commonSrv.response.post_query.data;
            if (response.success) {

              cb(null, {
                items_new: tmp_items,
                items_new_keys: response.keys,
                items: items
              });
            } else {
              cb(new Error(response.error ? response.error : 'Error'), items);
            }
          });
        }], function (err, response) {
          if (err) {
            return onError(err);
          }

          onSuccess(response);
        });
      },

      /**
       * Receives an onSuccess and onError functions, the success function will receive the Grower object,
       * the error function will receive the error object.
       *
       * <b>usage:</b>
       * productSrv.listStemsPerBunch(function(stems){
       *  TODO: do something with the stems per bunch
       * },function(err){
       *  TODO: do something on error
       * });
       */
      listStemsPerBunch: function listStemsPerBunch(onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('stems_per_bunch').setPage(1).setPageSize(1000).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('stems_per_bunch')
          .setPage(1)
          .setPageSize(1000)
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {

          var res = commonSrv.response.post_query.data;

          if (res.success) {
            onSuccess({
              data: res.results,
              row_count: res.row_count,
              total_pages: res.total_pages
            });
          } else {
            onError(new Error(res.error));
          }
        });
      },
      /**
       * Receives an onSuccess and onError functions, the success function will receive the Grower object,
       * the error function will receive the error object.
       *
       * <b>usage:</b>
       * productSrv.listAdminLength(function(lenghts){
       *  TODO: do something with the admin lengths
       * },function(err){
       *  TODO: do something on error
       * });
       */
      listAdminLengths: function listAdminLengths(onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('admin_length').setPage(1).setPageSize(1000).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('admin_length')
          .setPage(1)
          .setPageSize(1000)
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {

          var res = commonSrv.response.post_query.data;

          if (res.success) {
            onSuccess({
              data: res.results,
              row_count: res.row_count,
              total_pages: res.total_pages
            });
          } else {
            onError(new Error(res.error));
          }
        });
      },
      /**
       * Receives an onSuccess and onError functions, the success function will receive the Grower object,
       * the error function will receive the error object.
       * @returns {
       * all:[] // array with all the grades,
       * mapped :{
       * } // a map with all the grades separated by grade_type
       * types:[] // an array contiainin all the grade types
       * }
       *
       * <b>usage:</b>
       * productSrv.listGrades(function(grades){
       *  TODO: do something with the grades
       * },function(err){
       *  TODO: do something on error
       * });
       */
      listGrades: function listGrades(onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('grade').setPage(1).setPageSize(1000).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('grade')
          .setPage(1)
          .setPageSize(1000)
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {

          var res = commonSrv.response.post_query.data;

          if (res.success) {

            var pack = {
              all: [],
              mapped: {},
              types: []
            };

            angular.forEach(res.results, function (item) {

              item.full_name = item.grade_type + ' - ' + item.grade;

              if (!pack.mapped[item.grade_type]) {
                pack.mapped[item.grade_type] = [];
                pack.types.push(item.grade_type);
              }

              pack.mapped[item.grade_type].push(item);
              pack.all.push(item);
            });

            pack.all = $filter('orderBy')(pack.all, 'full_name');

            angular.forEach(Object.keys(pack.mapped), function (key) {
              pack.mapped[key] = $filter('orderBy')(pack.mapped[key], 'index_order');
            });

            onSuccess(pack);
          } else {
            onError(new Error(res.error));
          }
        });
      },

      /**
       * Receives an onSuccess and onError functions, the success function will receive the Grower object,
       * the error function will receive the error object.
       * @returns {*}
       */
      listProductGroups: function listProductGroups(page, size, onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in or it is not a Grower.'));
          return;
        }

        var query = commonSrv.sbx.with('product_group').setPage(page).fetchModels(['category']).setPageSize(size).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('product_group')
          .setPage(page)
          .fetchModels(['category'])
          .setPageSize(size)
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {

          var res = commonSrv.response.post_query.data;

          var fetched = res.fetched_results;

          angular.forEach(res.results, function (item) {
            item.category = fetched.category[item.category].category;
          });

          if (res.success) {
            onSuccess({
              data: res.results,
              row_count: res.row_count,
              total_pages: res.total_pages
            });
          } else {
            onError(new Error(res.error));
          }
        });

        // user.info.grower

      },

      /**
       * Receives an onSuccess and onError functions, the success function will receive the Grower object,
       * the error function will receive the error object.
       * @returns {*}
       */
      listProductColors: function listProductColors(page, size, onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in or it is not a Grower.'));
          return;
        }

        var query = commonSrv.sbx.with('color').setPage(page).setPageSize(size).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('color')
          .setPage(page)
          .setPageSize(size)
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {

          var res = commonSrv.response.post_query.data;

          if (res.success) {

            angular.forEach(res.results, function (color) {

              color.colors = [];

              for (var i = 1; i < 8; i++) {

                var tmp = 'html_code_' + i;

                if (color[tmp]) {
                  color.colors.push(color[tmp]);
                }
              }
            });

            // console.log(res.row_count);
            // console.log(res.total_pages);

            onSuccess({
              data: res.results,
              row_count: res.row_count,
              total_pages: res.total_pages
            });
          } else {
            onError(new Error(res.error));
          }
        });

        // user.info.grower

      },

      saveColor: function saveColor(color, onSuccess, onError) {
        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }
        var ulrRequest = commonSrv.urls.row;
        var msg = 'Color created';
        if (color._KEY) {
          ulrRequest = commonSrv.urls.update;
          msg = 'Color updated';
        }

        var query = {
          domain: commonSrv.actual_domain,
          row_model: 'color',
          rows: [color]
        };

        commonSrv.method.query(ulrRequest, query).then(function () {

          var response = commonSrv.response.post_query.data;
          if (response.success) {
            onSuccess(msg);
          } else {
            onError(new Error(response.error));
          }
        });
      },
      saveGroupType: function saveGroupType(groupType, onSuccess, onError) {
        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }
        var ulrRequest = commonSrv.urls.row;
        var msg = 'Group Type created';
        if (groupType._KEY) {
          ulrRequest = commonSrv.urls.update;
          msg = 'Group Type updated';
        }

        var query = {
          domain: commonSrv.actual_domain,
          row_model: 'group_type',
          rows: [groupType]
        };

        commonSrv.method.query(ulrRequest, query).then(function () {

          var response = commonSrv.response.post_query.data;
          if (response.success) {
            onSuccess(msg);
          } else {
            onError(new Error(response.error));
          }
        });
      },

      /**
       * Saves the given variety into the system.
       * This deals with update and with save,
       * @param variety the variety to save
       * @param onSuccess with the variety as a parameter.
       * @param onError with the error message as a paramter.
       */
      saveVariety: function saveVariety(variety, onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.

        if (!user || user.ibf_role !== 'ADMIN' && user.ibf_role !== 'COUNTRY_MANAGER') {
          onError(new Error('User is not logged in or is not an ADMIN'));
          return;
        }

        // we need to check if there is no item with the same config

        var query = commonSrv.sbx.with('variety').setPage(1).setPageSize(1).andWhereIsEqual('product_group', variety.product_group._KEY).andWhereIsEqual('color', variety.color._KEY).andWhereIsEqual('variety_name', variety.variety_name).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('variety')
          .setPage(1)
          .setPageSize(1)
          .addCondition('AND', 'product_group', '=', variety.product_group._KEY)
          .addCondition('AND', 'color', '=', variety.color._KEY)
          .addCondition('AND', 'variety_name', '=', variety.variety_name)
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {

          var res = commonSrv.response.post_query.data;

          if (res.success) {

            // if the
            if (res.results.length > 0 && res.results[0]._KEY != variety._KEY) {
              onError(new Error('There is already a Variety with the same name and color in this product group.'));
              return;
            }

            var insert = {
              'domain': commonSrv.actual_domain,
              'row_model': 'variety',
              'rows': [{
                'color': variety.color._KEY,
                'product_group': variety.product_group._KEY,
                'variety_name': variety.variety_name,
                'is_combo': variety.is_combo

              }]
            };

            var url = commonSrv.urls.row;

            var isNew = true;

            if (variety._KEY) {
              isNew = false;
              url = commonSrv.urls.update;
              insert.rows[0]._KEY = variety._KEY;
            }

            commonSrv.method.query(url, insert).then(function () {

              var response = commonSrv.response.post_query.data.keys;

              if (res.success) {

                if (isNew) {
                  variety._KEY = response[0];
                }

                onSuccess(variety);
              }
            });
          } else {
            onError(new Error(res.error));
          }
        });
      },

      /**
       * Receives an onSuccess and onError functions, the success function will receive the Grower object,
       * the error function will receive the error object.
       * @returns {*}
       */
      listVarieties: function listVarieties(page, size, onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('variety').setPage(page).setPageSize(size).andWhereIsNotNull('product_group').andWhereIsNotNull('color').fetchModels(['product_group', 'product_group.group_type', 'color']).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('variety')
          .setPage(page)
          .setPageSize(size)
          .fetchModels(['product_group', 'product_group.group_type', 'color'])
          .compile();*/

        commonSrv.loadAllPages(query, function (res) {
          var varieties = res.results;
          var fetched = res.fetched_results;

          angular.forEach(varieties, function (variety) {
            parseVariety(variety, fetched);
          });

          onSuccess({
            data: varieties,
            row_count: varieties.length
          });
        }, onError);

        // user.info.grower

      },
      listVarietiesPG: function listVarietiesPG(page, size, onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('variety').setPage(page).setPageSize(size).andWhereIsEqual("inactive", false).fetchModels(['product_group', 'product_group.group_type', 'product_group.category', 'color']).compile();

        commonSrv.loadAllPages(query, function (res) {
          var varieties = res.results;
          var fetched = res.fetched_results;
          var pg = fetched.product_group;

          angular.forEach(varieties, function (variety) {
            parseVariety(variety, fetched);
          });
          var i = 0,
              groups = [];
          angular.forEach(pg, function (item) {
            item.category = fetched.category[item.category];
            if (!item.category) {
              item.category = { category: '' };
            }
            groups[i] = item;
            i++;
          });

          onSuccess({
            data: varieties,
            pg: groups,
            row_count: varieties.length
          });
        });

        // user.info.grower

      },
      /**
       * Receives an onSuccess and onError functions, the success function will receive the Grower object,
       * the error function will receive the error object.
       * @returns {
       * all:[] // array with all the grades,
       * mapped :{
       * } // a map with all the grades separated by grade_type
       * types:[] // an array contiainin all the grade types
       * }
       *
       * <b>usage:</b>
       * productSrv.listGrades(function(grades){
       *  TODO: do something with the grades
       * },function(err){
       *  TODO: do something on error
       * });
       */
      listBoxes: function listBoxes(page, size, onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('admin_box').fetchModels(['country']).setPage(page).setPageSize(size).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('admin_box')
          .fetchModels(['country'])
          .setPage(page)
          .setPageSize(size)
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {

          var res = commonSrv.response.post_query.data;
          var fetched = res.fetched_results;

          angular.forEach(res.results, function (item) {
            item.country = fetched.country[item.country];
          });

          if (res.success) {

            onSuccess({
              data: res.results,
              row_count: res.row_count,
              total_pages: res.total_pages
            });
          } else {
            onError(new Error(res.error));
          }
        });
      },
      saveBoxes: function saveBoxes(box_query, save_url, onSuccess, onError) {

        var user = commonSrv.getUserData();
        var msg = '';

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('admin_box').setPage(1).setPageSize(1).andWhereIsEqual('country', box_query.country).andWhereIsEqual('box_name', box_query.box_name);
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('admin_box')
          .setPage(1)
          .setPageSize(1)
          .addCondition('AND', 'country', '=', box_query.country)
          .addCondition('AND', 'box_name', '=', box_query.box_name);*/

        if (box_query.isNormal) {
          msg = 'There\'s already a box with the name:max_length combination.';
          query.andWhereIsEqual('box_max_length', box_query.box_max_length);
          //query.addCondition('AND', 'box_max_length', '=', box_query.box_max_length);
        } else {
          msg = 'There\'s already a box with the name:fixed_length combination.';
          query.andWhereIsEqual('fixed_length', box_query.fixed_length);
          //query.addCondition('AND', 'fixed_length', '=', box_query.fixed_length);
        }

        query = query.compile();

        delete box_query.isNormal;

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {
          var res = commonSrv.response.post_query.data;

          if (res.results.length > 0 && !box_query._KEY) {
            onError(new Error(msg));
          } else {
            var insert = {
              'domain': commonSrv.actual_domain,
              'row_model': 'admin_box',
              'rows': [box_query]
            };

            commonSrv.method.query(save_url, insert).then(function () {

              var response = commonSrv.response.post_query.data;
              if (response.success) {
                onSuccess(response.success);
              } else {
                onError(new Error(response.error));
              }
            });
          }
        });
      },
      listFactors: function listFactors(onSuccess, onError) {

        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('dim_factor').fetchModels(['country', 'carrier']).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('dim_factor')
          .fetchModels(['country', 'carrier'])
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {

          var res = commonSrv.response.post_query.data;
          var fetched = res.fetched_results;

          angular.forEach(res.results, function (item) {
            item.country = fetched.country[item.country];
            item.carrier = fetched.carrier[item.carrier];
          });

          if (res.success) {

            onSuccess({
              data: res.results,
              row_count: res.row_count,
              total_pages: res.total_pages
            });
          } else {
            onError(new Error(res.error));
          }
        });
      },
      saveDimFactor: function saveDimFactor(factor, save_url, onSuccess, onError) {
        var user = commonSrv.getUserData();

        // if there was no user  just return an error.
        if (!user) {
          onError(new Error('User is not logged in.'));
          return;
        }

        var query = commonSrv.sbx.with('dim_factor').setPage(1).setPageSize(1).andWhereIsEqual('carrier', factor.carrier).andWhereIsEqual('country', factor.country).compile();
        /*var query = commonSrv.queryBuilder()
          .setDomain(commonSrv.actual_domain)
          .setModel('dim_factor')
          .setPage(1)
          .setPageSize(1)
          .addCondition('AND', 'carrier', '=', factor.carrier)
          .addCondition('AND', 'country', '=', factor.country)
          .compile();*/

        commonSrv.method.query(commonSrv.urls.find, query).then(function () {
          var response = commonSrv.response.post_query.data;

          if (response.results.length > 0 && !factor._KEY) {
            onError(new Error('There\'s already a weight factor assigned to this country and carrier'));
          } else {
            var insert = {
              'domain': commonSrv.actual_domain,
              'row_model': 'dim_factor',
              'rows': [factor]
            };

            commonSrv.method.query(save_url, insert).then(function () {
              var res = commonSrv.response.post_query.data;

              if (res.success) {
                onSuccess(res.success);
              } else {
                onError(res.error);
              }
            });
          }
        });
      },
      getReplacement: function getReplacement(variety) {
        var query = commonSrv.sbx.with('replacement').orWhereIsEqual('replace', variety).orWhereIsEqual('variety', variety).fetchModels(['replace.product_group', 'variety.product_group']).compile();

        return commonSrv.method.query(commonSrv.urls.find, query).then(function () {
          var res = commonSrv.response.post_query.data;
          var fetched = res.fetched_results;

          return res.results.map(function (item) {
            item.replace = Object.assign({}, fetched.variety[item.replace]);
            item.variety = Object.assign({}, fetched.variety[item.variety]);
            item.replace.product_group = Object.assign({}, fetched.product_group[item.replace.product_group]);
            item.variety.product_group = Object.assign({}, fetched.product_group[item.variety.product_group]);
            if (item.replace._KEY === variety) {
              item.replace = Object.assign({}, item.variety);
            }
            return item;
          });
        });
      }
    };
  }
})(angular);
//# sourceMappingURL=productSrv.js.map

'use strict';

(function (angular) {
  angular.module('ibf').factory('growerSrv', ['commonSrv', '$filter', '$uibModal', 'environment', '$http', growerSrv]);

  function growerSrv(commonSrv, $filter, $uibModal, environment, $http) {
    var grower = {},
        common = commonSrv;
    var inventoryRecommendationCache = {};
    //console.log('common in GS',common.getUserData())
    grower.user = common.getUserData();

    grower.dayHours = {
      hours: [{ hour: '00:00' }, { hour: '01:00' }, { hour: '02:00' }, { hour: '03:00' }, { hour: '04:00' }, { hour: '05:00' }, { hour: '06:00' }, { hour: '07:00' }, { hour: '08:00' }, { hour: '09:00' }, { hour: '10:00' }, { hour: '11:00' }, { hour: '12:00' }, { hour: '13:00' }, { hour: '14:00' }, { hour: '15:00' }, { hour: '16:00' }, { hour: '17:00' }, { hour: '18:00' }, { hour: '19:00' }, { hour: '20:00' }, { hour: '21:00' }, { hour: '22:00' }, { hour: '23:00' }]
    };

    grower.updateInventoryCS = function (inventories, startDate, endDate, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.inventoryUpdateAssistant,
        params: {
          inventories: inventories,
          grower: common.getUserData().grower,
          startDate: common.convertDateToNumberDate(startDate, true),
          endDate: common.convertDateToNumberDate(endDate, true)
        }
      }).then(function (response) {
        if (response.success) {
          onSuccess(response);
        } else {
          onError(response.error);
        }
      }, onError);
    };

    grower.getInventoryRecommendationForecast = function (growerCompanyName, weekStart, weekEnd) {
      var cacheKey = [growerCompanyName, weekStart, weekEnd].join('|');

      if (!growerCompanyName) {
        return Promise.reject(new Error('Missing grower company name.'));
      }

      if (!weekStart || !weekEnd) {
        return Promise.reject(new Error('Missing week range.'));
      }

      if (!inventoryRecommendationCache[cacheKey]) {
        inventoryRecommendationCache[cacheKey] = {
          items: null,
          inFlightPromise: null
        };
      }

      var cacheEntry = inventoryRecommendationCache[cacheKey];
      if (cacheEntry.items) {
        return Promise.resolve(cacheEntry.items);
      }

      if (cacheEntry.inFlightPromise) {
        return cacheEntry.inFlightPromise;
      }

      var headers = angular.extend({}, common.getHeaders(), {
        'Content-Type': 'application/json'
      });

      cacheEntry.inFlightPromise = $http({
        method: 'POST',
        url: 'https://app.ibuyflowers.com/api/api_ibf/grower/forecast',
        data: {
          grower: growerCompanyName,
          week_start: weekStart,
          week_end: weekEnd
        },
        headers: headers
      }).then(function (response) {
        var data = response && response.data ? response.data : {};
        if (!data.success) {
          throw new Error(data.error || 'Error loading inventory recommendation.');
        }
        cacheEntry.items = angular.copy(data.items || []);
        cacheEntry.inFlightPromise = null;
        return cacheEntry.items;
      }).catch(function (error) {
        cacheEntry.inFlightPromise = null;
        throw error;
      });

      return cacheEntry.inFlightPromise;
    };

    // grower.getOrderRequestBid = function (onSuccess, onError) {
    //   return common.sbx
    //     .with('order_request_bid')
    //     .fetchModels(['order_request_item', 'grower'])
    //     .compile();
    // };

    grower.getOrderRequest = function (selectedDate, onSuccess, onError) {
      var userData = common.getUserData().data;
      var grower = userData.metadata.grower;
      common.method.run({
        key: environment.cloudscript.getOrderReqItemByGrower,
        params: { grower: grower, selectedDate: selectedDate }
      }).then(function (res) {
        if (res.success) {
          onSuccess(res.results);
        } else {
          onError(res);
        }
      }, onError);
    };

    grower.getOrderRequestCb = function (cb) {
      grower.getOrderRequest(null, function (r) {
        return cb(null, r);
      }, cb);
    };

    grower.DeclineOrderRequest = function (ori, cb) {
      common.method.run({
        key: environment.cloudscript.declineOrderRequest,
        params: { order_request_bid: ori.order_request_bid._KEY,
          order_request: ori.order_request }
      }).then(function (res) {
        cb(res);
      });
    };

    grower.list = function (onSuccess, onError) {
      var countries = common.getCurrentUserCountries();

      // if there was no user just return an error.
      if (!grower.user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      var query = common.sbx.with('user').setPage(1).fetchModels(['grower']).andWhereIsEqual('active', true).andWhereIsEqual('grower.active', true).setPageSize(1000);

      if (countries.length) {
        query.andWhereIn('grower.country', countries);
      }

      common.loadAllPages(query.compile(), function (res) {
        var growers = Object.keys(res.fetched_results.grower).map(function (item) {
          return res.fetched_results.grower[item];
        });

        onSuccess({
          data: growers.sort(function (a, b) {
            return a.company_name.localeCompare(b.company_name);
          })
        });
      }, function (errr) {
        onError(new Error(res.error));
      });
    };

    grower.getLengthList = function (callback) {
      var lengths = new Array(81).fill(0).map(function (x, i) {
        return i;
      });
      lengths.concat([90, 100, 110, 120, 130, 140, 150, 160, 170, 175, 180, 190, 200, 225, 240, 250, 300, 450]);
      var query = commonSrv.sbx.with('length').compile();
      commonSrv.loadAllPages(query, function (data) {
        if (data.results.length) {
          return callback(data.results);
        }
        callback(lengths.map(function (length) {
          return { value: length, _KEY: common.generateUUID() };
        }));
      }, function () {
        callback(lengths.map(function (length) {
          return { value: length, _KEY: common.generateUUID() };
        }));
      });
    };

    grower.getBulkDiscount = function (callback) {
      async.parallel([function (cb) {
        var query = commonSrv.sbx.with('bulk_promo').andWhereIsEqual('grower', grower.user.grower).compile();
        commonSrv.loadAllPages(query, function (data) {
          cb(null, data.results);
        }, function (err) {
          cb(err);
        });
      }, function (cb) {
        var query = commonSrv.sbx.with('add_masterlist').andWhereIsEqual('grower', grower.user.grower).fetchModels(['product_group']).compile();

        commonSrv.loadAllPages(query, function (data) {
          var list = [];
          for (var key in data.fetched_results.product_group) {
            list.push(data.fetched_results.product_group[key]);
          }
          cb(null, list);
        }, function (err) {
          cb(err);
        });
      }], function (err, data) {
        if (err) {
          return callback(err);
        }
        var list = data[1].map(function (item) {
          var aux = { product_group: item, status: false, amount: 0, percentage: 0 };
          var bp = data[0].find(function (bulk) {
            return bulk.product_group === item._KEY;
          });
          if (bp) {
            aux = bp;
            aux.product_group = item;
            aux.percentage *= 100;
            delete aux._META;
          }
          return aux;
        });
        callback({ success: true, list: list });
      });
    };

    grower.uomList = function (onSuccess, onError) {
      var user = common.getUserData();
      // if there was no user  just return an error.
      if (!user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      var query = common.sbx.with('uom').setPage(1).setPageSize(1000).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('uom')
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess({
            data: res.results,
            row_count: res.row_count,
            total_pages: res.total_pages
          });
        } else {
          onError(new Error(res.error));
        }
      });
    };

    grower.listCarriers = function (onSuccess, onError) {
      // if there was no user  just return an error.
      if (!grower.user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      var query = common.sbx.with('carrier').setPage(1).setPageSize(1000).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('carrier')
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess({
            data: res.results,
            row_count: res.row_count,
            total_pages: res.total_pages
          });
        } else {
          onError(new Error(res.error));
        }
      });
    };

    grower.updateMassiveInventory = function (params, onSuccess, onError) {

      common.method.run({
        key: environment.cloudscript.updateMassiveInventory,
        params: params
      }).then(function (res) {
        if (res.success) onSuccess(res);else onError(res.error);
      });
    };
    grower.messageSlackMassiveInventory = function (params, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.messageSlackMassiveInventory,
        params: params
      }).then(function (res) {
        if (res.success) onSuccess(res);else onError(res.error);
      });
    };

    grower.generateCSV = function (params, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.orderGenerator,
        params: params
      }).then(function (response) {
        if (response.success) {
          onSuccess(response);
        } else {
          console.log(response.error);
          onError(response.error);
        }
      }, onError);
    };

    grower.generateDutchCSV = function (params, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.dutchGenerator,
        params: params
      }).then(function (response) {
        if (response.success) {
          onSuccess(response);
        } else {
          console.log(response.error);
          onError(response.error);
        }
      }, onError);
    };
    /**
     *
     * Lists all the users that belong to a grower
     * @param grower_key The KEY of the grower to filter the users
     * @param options The objects with the different BOOLEAN flags for the users.
     * @param onSuccess The success function that will return the array of users
     * @param onError The error callback with the Error object as a parameter.
     */
    grower.loadUsers = function (grower_key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var onSuccess = arguments[2];
      var onError = arguments[3];

      var opt = [{
        ANDOR: 'AND',
        FIELD: 'user.grower',
        OP: '=',
        VAL: grower_key
      }];

      // var aux = [];
      //  for (let [k, v] of Object.entries(options)) {
      //    aux.push({
      //      "ANDOR": "AND",
      //      "FIELD": k,
      //      "OP": "=",
      //      "VAL": v
      //    })
      //  }

      Object.keys(options).forEach(function (key, index) {
        var v = options[key];
        opt.push({
          ANDOR: 'AND',
          FIELD: key,
          OP: '=',
          VAL: v
        });
      });

      var query = {
        domain: common.actual_domain,
        page: 1,
        row_model: 'grower_user_config',
        fetch: ['user'],
        size: 1000,
        where: [{
          ANDOR: 'AND',
          GROUP: opt
        }]
      };

      common.method.query(common.urls.find, query).then(function () {
        var response = common.response.post_query.data;

        if (response.success) {
          var _fetched_results = response.fetched_results;

          var users = [];

          angular.forEach(response.results, function (item) {
            var user = _fetched_results.user[item.user];
            user.config = item;
            //user.isAdmin = item.user.user_id == obj.grower_admin;
            users.push(user);
          });

          onSuccess(users);
        } else {
          onError(new Error('Internal error loading users'));
        }
      });
    };

    grower.listUsers = function (grower_key, onSuccess, onError) {
      // if there was no user  just return an error.
      if (!grower_key) {
        onError(new Error('The user key is required.'));
        return;
      }

      var query = common.sbx.with('user').andWhereIsEqual('grower', grower_key).setPage(1).setPageSize(1000).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('user')
        .addCondition('AND', 'grower', '=', grower_key)
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res.results);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    grower.userList = function (onSuccess, onError, role) {
      // if there was no user  just return an error.
      if (!grower.user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      var user_role = role ? role : 'GROWER';

      var query = common.sbx.with('user').andWhereIsEqual('role', user_role).setPage(1).setPageSize(1000).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('user')
        .addCondition('AND', 'role', '=', user_role)
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess({
            data: res.results,
            row_count: res.row_count,
            total_pages: res.total_pages
          });
        } else {
          onError(new Error(res.error));
        }
      });
    };

    grower.deleteBoxPurchase = function (cartbox, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.cancelBorder,
        params: {
          cartbox: cartbox._KEY,
          customer: cartbox.customer._KEY,
          userDispatcher: common.getUserData().key
        }
      }).then(function (response) {
        if (response.success) {
          onSuccess('The box has been deleted');
        } else {
          onError(response.error);
        }
      }, onError);
    };

    grower.getCancelledOrders = function (onSuccess, onError) {
      // if there was no user  just return an error.
      if (!grower.user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      async.waterfall([function (cb) {
        var query = common.sbx.with('audit').andWhereIsEqual('action', 'DELETED').andWhereContains('object_string', '%' + common.getUserData().grower + '%').compile();
        /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('audit')
        .addCondition('AND', 'action', '=', 'DELETED')
        .addCondition('AND', 'object_string', 'LIKE', `%${common.getUserData().grower}%`)
        .compile();*/

        common.loadAllPages(query, function (data) {
          cb(null, data.results);
        }, cb);
      }, function (res, cb) {
        var box = {
          orders: res.map(function (item) {
            return Object.assign({ cancel_date: new Date(item.date) }, JSON.parse(item.object_string));
          }),
          keys: { grades: [], product_groups: [], varieties: [] },
          maps: { pg: {}, v: {}, g: {} }
        };

        box.orders.forEach(function (item) {
          if (typeof item.product_group !== 'string') {
            item.product_group = item.product_group._KEY;
          }
          box.keys.product_groups.push(item.product_group);
          if (item.variety) {
            if (typeof item.variety !== 'string') {
              item.variety = item.variety._KEY;
            }
            box.keys.varieties.push(item.variety);
          }
          if (item.grade) {
            if (typeof item.grade !== 'string') {
              item.grade = item.grade._KEY;
            }
            box.keys.grades.push(item.grade);
          }
        });

        cb(null, box);
      }, function (box, cb) {
        var query1 = common.sbx.with('product_group').whereWithKeys(box.keys.product_groups).compile(),
            query2 = common.sbx.with('variety').fetchModels(['color']).whereWithKeys(box.keys.varieties).compile(),
            query3 = common.sbx.with('grade').whereWithKeys(box.keys.grades).compile();

        /*  const query1 = common.queryBuilder().setDomain(common.actual_domain).setModel('product_group')
        .whereWithKeys(box.keys.product_groups).compile();
        const query2 = common.queryBuilder().setDomain(common.actual_domain).setModel('variety').fetchModels(['color'])
        .whereWithKeys(box.keys.varieties).compile();
        const query3 = common.queryBuilder().setDomain(common.actual_domain).setModel('grade')
        .whereWithKeys(box.keys.grades).compile();
        */
        async.parallel([function (callback) {
          if (box.keys.product_groups.length) {
            common.loadAllPages(query1, function (data) {
              data.results.forEach(function (item) {
                box.maps.pg[item._KEY] = item;
              });
              callback(null, 1);
            }, callback);
          } else {
            callback(null, 1);
          }
        }, function (callback) {
          if (box.keys.varieties.length) {
            common.loadAllPages(query2, function (data) {
              data.results.forEach(function (item) {
                item.color = data.fetched_results.color[item.color];
                box.maps.v[item._KEY] = item;
              });
              callback(null, 2);
            }, callback);
          } else {
            callback(null, 2);
          }
        }, function (callback) {
          if (box.keys.grades.length) {
            common.loadAllPages(query3, function (data) {
              data.results.forEach(function (item) {
                box.maps.g[item._KEY] = item;
              });
              callback(null, 3);
            }, callback);
          } else {
            callback(null, 3);
          }
        }], function (err, res) {
          if (err) {
            return cb(err);
          }
          cb(null, box);
        });
      }, function (box, cb) {
        box.orders.forEach(function (item) {
          item.variety = box.maps.v[item.variety] || '';
          item.product_group = box.maps.pg[item.product_group] || '';
          item.grade = box.maps.g[item.grade] || '';
        });
        cb(null, box.orders);
      }], function (err, res) {
        if (err) {
          return onError(err);
        }
        onSuccess(res);
      });
    };

    grower.listTimeZones = function (onSuccess, onError) {
      // if there was no user  just return an error.
      if (!grower.user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      var query = common.sbx.with('time_zone').setPage(1).setPageSize(1000).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('time_zone')
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess({
            data: res.results,
            row_count: res.row_count,
            total_pages: res.total_pages
          });
        } else {
          onError(new Error(res.error));
        }
      });
    };

    grower.listPrinterLabels = function (onSuccess, onError) {
      // if there was no user  just return an error.
      if (!grower.user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      var query = common.sbx.with('printer_labels').setPage(1).setPageSize(1000).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('printer_labels')
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess({
            data: res.results,
            row_count: res.row_count,
            total_pages: res.total_pages
          });
        } else {
          onError(new Error(res.error));
        }
      });
    };

    grower.listProductGroups = function (onSuccess, onError) {
      var user = common.getUserData();

      // if there was no user  just return an error.
      if (!user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      var query = common.sbx.with('box_per_product').fetchModels(['product_group']).setPage(1).setPageSize(1000).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('box_per_product')
        .fetchModels(['product_group'])
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          angular.forEach(res.results, function (item) {
            item.product_group = fetched_results.product_group[item.product_group];
          });

          onSuccess({
            data: res.results,
            row_count: res.row_count,
            total_pages: res.total_pages
          });
        } else {
          onError(new Error(res.error));
        }
      });
    };

    //this function list all the cart box items for the actual grower and then fetch for the
    // purchase order linked to the cart box items
    grower.listOrdersForGrower = function (onSuccess, onError) {
      if (!grower.user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      async.waterfall([function (cb) {
        var data = {
          cart_boxes: {},
          purchaseMap: {},
          purchases: []
        };
        var query = fs.getBaseQueryCartBox().andWhereIsEqual('grower', grower.user.grower).andWhereIsNotNull('purchase').andWhereIsEqual('status.code', 1).compile();

        /*query.addCondition('AND', 'grower', '=', grower.user.grower)
        query.addCondition('AND', 'purchase', 'is not', null);
        query.addCondition('AND', 'status.code', '=', 1);
        query = query.compile();*/

        fs.getCartBoxes(query, function (response) {
          console.log('getCartBoxes', response);
          data.cart_boxes = response;

          cb(null, data);
        }, cb);
      }, function (data, cb) {
        angular.forEach(data.cart_boxes.results, function (item) {
          if (!data.purchaseMap[item.purchase._KEY]) {
            item.purchase.customer = item.customer;
            data.purchases.push(item.purchase);
            data.purchaseMap[item.purchase._KEY] = { purchase: item.purchase, items: [item] };
          } else {
            data.purchaseMap[item.purchase._KEY].items.push(item);
          }
        });
        cb(null, data);
      }], function (e, data) {
        if (e) {
          return onError(e);
        }
        onSuccess(data);
      });
    };

    grower.listCities = function (onSuccess, onError) {
      if (!grower.user) {
        onError(new Error('User is not logged in.'));
        return;
      }

      var query = common.sbx.with('city').fetchModels(['country']).setPage(1).setPageSize(1000).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('city')
        .fetchModels(['country'])
        .setPage(1)
        .setPageSize(1000)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res.results);
        } else {
          onError(res.error);
        }
      });
    };

    grower.getCustomersByGrower = function (onSuccess, onError) {
      async.waterfall([function (cb) {
        var query = common.sbx.with('customer').fetchModels(['country']).andWhereIsEqual('active', true).compile();
        /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer')
        .fetchModels([
          'country',
        ])
        .addCondition('AND', 'active', '=', true)
        .compile();*/
        common.method.query(common.urls.find, query).then(function () {
          var res = common.response.post_query.data;
          if (res.success) {
            var fetched_results = res.fetched_results;
            angular.forEach(res.results, function (item) {
              item.country = fetched_results.country[item.country];
            });

            var box = { customers: res.results };
            cb(null, box);
          } else {
            cb(res.error);
          }
        });
      }, function (box, cb) {
        common.loadGrowerCustomerRelation(function (res) {
          box.results = res.results;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        var resCustomers = [];
        var resMap = {};
        if (box.results.length > 0) {
          angular.forEach(box.results, function (item) {
            resMap[item.customer] = item;
          });
          angular.forEach(box.customers, function (customer) {
            customer.status = true;
            customer.your_rating = 0;
            if (resMap[customer._KEY]) {
              var item = resMap[customer._KEY];
              customer.your_rating = parseInt(item.rating);
              customer.status = item.customer_perm;
              customer.relationship = item._KEY;
              if (item.customer_perm) {
                resCustomers.push(customer);
              }
            } else {
              resCustomers.push(customer);
            }
          });
          box.res = resCustomers;
        } else {
          for (var i = 0; i < box.customers.length; i++) {
            var customer = box.customers[i];
            customer.status = true;
          }
          box.res = box.customers;
        }
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }
        // _setupTotal.customers = box.customers.length;
        onSuccess($filter('orderBy')(box.customers, 'company_name'));
      });
    };

    grower.changeCustomerGrowerStatus = function (customer, block, onSuccess, onError) {
      /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer_grower_relationship');
      if(block){
      query.addObject({
          customer: customer,
          grower: common.getUserData().grower,
          block_by: 'grower'
        });
        } else {
        query.addCondition('AND', 'customer', '=', customer)
              .addCondition('AND', 'grower', '=', common.getUserData().grower);
              }*/

      var query = block ? common.sbx.insert('customer_grower_relationship', {
        customer: customer,
        grower: common.getUserData().grower,
        block_by: 'grower'
      }) : common.sbx.with('customer_grower_relationship').andWhereIsEqual('customer', customer).andWhereIsEqual('grower', common.getUserData().grower).compile();

      common.method.query(block ? common.urls.row : common.urls.delete, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(res.error);
        }
      });
    };

    /**
     * get the customer that has relation with the current logged grower member
     */
    grower.getCustomersRelated = function (onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.customerGrowerRelation,
        params: {
          model: 'grower',
          key: common.getUserData().grower
        }
      }).then(function (response) {
        if (response.success) {
          onSuccess(response.relations);
        } else {
          onError('Error occurred, try again.');
        }
      }, onError);
    };

    /**
     * Function: get the masterlists related to a grower
     * {@return} data: fetched object with the masterlists and its dependencies
     */
    grower.getMasterlists = function (onSuccess, onError) {
      var query = common.sbx.with('add_masterlist').andWhereIsEqual('grower', common.getUserData().grower).fetchModels(['UoM', 'stems_per_bunch', 'grade', 'variety', 'variety.product_group', 'variety.color', 'box']).compile();
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('add_masterlist')
        .addCondition('AND', 'grower', '=', common.getUserData().grower)
        .fetchModels(['UoM', 'stems_per_bunch', 'grade', 'variety', 'variety.product_group', 'variety.color', 'box'])
        .compile();*/

      common.loadAllPages(query, function (res) {
        var fetched_results = res.fetched_results;

        angular.forEach(res.results, function (item) {
          item.UoM = fetched_results.uom[item.UoM];
          item.box = fetched_results.admin_box[item.box];
          item.stems_per_bunch = fetched_results.stems_per_bunch[item.stems_per_bunch];
          item.grade = fetched_results.grade[item.grade];
          item.variety = angular.copy(fetched_results.variety[item.variety]);
          item.product_group = fetched_results.product_group[item.variety.product_group];
          item.color = angular.copy(fetched_results.color[item.variety.color]);
          item.variety.colors = [];

          if (typeof item.variety.color === 'string' || item.variety.color instanceof String) {
            item.variety.color = angular.copy(fetched_results.color[item.variety.color]);
          }

          for (var i = 1; i < 8; i++) {
            var tmp = 'html_code_' + i;
            if (item.color[tmp]) {
              item.variety.colors.push(item.color[tmp]);
            }
          }
        });
        onSuccess(res.results);
      }, function (error) {
        onError(error);
      });
    };
    /**
     * mark the masterlist as special
     */
    grower.markSpecial = function (key, mark, onSuccess, onError) {
      var query = common.sbx.insert('add_masterlist', { _KEY: key, special: mark });

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          commonSrv.updateMasterlistInventory([key], function () {
            onSuccess('ok');
          });
        } else {
          onError(res.error);
        }
      });
    };
    /**
     * unmark all masterlist passed from special pack
     */
    grower.unMarkAll = function (list, onSuccess, onError) {
      var query = common.sbx.insert('add_masterlist', list);
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('add_masterlist')
        .addObjectArray(list)
        .compile();*/

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess('ok');
        } else {
          onError(res.error);
        }
      });
    };

    /*
    Make instance of the confirmation modal for the update inventory import
     */

    grower.confirmModal = function (config) {
      return $uibModal.open({
        templateUrl: 'views/grower/confirmation.update.inventory.html',
        controller: 'growerModalUpdate',
        controllerAs: 'obj',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          data: function data() {
            return config;
          }
        }
      });
    };
    /**
     * A function recive two dates and return and arrays with the start day and end date of each week
     * @param {Date} iniDate - Start date
     * @param {Date} endDate - End date
     * @returns {Array} weeksArray - Array with all the weeks
     * @author carlos@socobox.co
     */
    grower.getWeeks = function (initDate, endDate) {
      initDate = common.convertNumberDateToDate(initDate);
      endDate = common.convertNumberDateToDate(endDate);
      var weeksArray = [];
      var weeks = Math.round((endDate - initDate) / 604800000);
      var week = initDate;
      for (var i = 0; i < weeks; i++) {
        var week_start = new Date(week.getTime());
        week_start.setTime(week_start.getTime() + i * 7 * 86400000);
        var end_date = new Date(week_start.getTime());
        end_date.setDate(end_date.getDate() + 7);

        weeksArray.push({
          start_date: week_start.numDateWithoutTimeZone(),
          end_date: end_date.numDateWithoutTimeZone()
        });
      }
      return weeksArray;
    };

    /**
     * Manda el array de inventories para actualizar.
     * @param {Array} inventories - Array de strings con las keys de los inventarios
     */
    grower.batchUpdateInventories = function (inventories) {
      if (!inventories || !Array.isArray(inventories) || inventories.length === 0) {
        return;
      }
      try {
        $http({
          method: 'POST',
          url: 'https://shopping.ibuyflowers.com/api/inventory/update_keys',
          headers: {
            'Accept-Encoding': 'gzip,deflate',
            'Content-Type': 'application/json'
          },
          data: {
            keys: inventories
          }
        }).then(function () {
          // Success silently
        }, function (err) {
          console.error('Error in batchUpdateInventories request:', err);
        });
      } catch (e) {
        console.error('Exception in batchUpdateInventories:', e);
      }
    };

    /**
     *
     * @param {array} inventories - Array of inventory
     * @param {number} initDate - Init date in number date format
     * @param {number} endDate - End date in number date format
     * @param {string} growerKey - Grower key
     * @param {boolean} mustContinue - Control recursive calls
     * @param {function} onSuccess - Callback for success call
     * @param {function} onError - Callback for error
     * @author carlos@socobox.co
     */
    grower.updateInvZero = function (inventories, initDate, endDate, growerKey, mustContinue, onSuccess, onError) {
      if (mustContinue) {
        common.method.run({
          params: { inventories: inventories, initDate: initDate, endDate: endDate, grower: growerKey },
          key: environment.cloudscript.updateInvCeros
        }).then(function (res) {
          if (res.success) {
            // console.log('res', res)
            // console.log('1 step')
            // console.log('inventories',inventories )
            // console.log('initDate',initDate )
            // console.log('endDate',endDate )
            // console.log('growerKey',growerKey )
            // console.log('mustContinue',res.mustContinue )

            if (res.box && res.box.inventoriesToUpdate && Array.isArray(res.box.inventoriesToUpdate) && res.box.inventoriesToUpdate.length > 0) {
              try {
                var keys = res.box.inventoriesToUpdate.map(function (inv) {
                  return inv._KEY;
                });
                grower.batchUpdateInventories(keys);
              } catch (e) {
                console.error('Error processing inventoriesToUpdate in updateInvZero:', e);
              }
            }

            grower.updateInvZero(inventories, initDate, endDate, growerKey, res.mustContinue, onSuccess, onError);
          } else {

            onError(res);
          }
        });
      } else {
        onSuccess();
      }
    };

    var count = 0;
    grower.getMap = function (partialsChange, iniDate, endDate, keyGrow, totalChange, msg, onSuccess, onError, retry, close) {
      var weeksArray = grower.getWeeks(iniDate, endDate);
      var mapTotal = {
        changesNotFound: [],
        mapChangesNotFound: {},
        totalUpdate: 0,
        totalNew: 0
      };
      async.eachOfSeries(weeksArray, function (week, index, cbEach) {
        async.eachOfSeries(partialsChange, function (partial, key, callback) {
          var total = (key + 1) * 50;

          if (key === partialsChange.length - 1) {
            total = total - 50 + partial.length;
          }

          var growerName = common.getUserData().grower_name ? common.getUserData().grower_name : common.getUserData().data.metadata.grower_name;
          msg.msj = 'Updating inventory ' + total + ' of ' + totalChange + ' week ' + week.start_date + '...';
          msg.msjSlack = '*Updating inventory* ' + total + ' of ' + totalChange + ',\n *Date range:* ' + week.start_date + ' *to* ' + week.end_date + ',\n *Grower:* ' + growerName + ',\n';
          msg.changes = partial.map(function (res) {
            return ' *' + res.code + '* = ' + res.quantity + ' items';
          });
          var cloudParams = {
            changes: partial,
            initDate: week.start_date,
            endDate: week.end_date,
            grower: keyGrow
          };
          grower.updateMassiveInventory(cloudParams, function (data) {
            if (!data.success) {
              return callback(data.error);
            } else {
              if (data.success) {
                grower.messageSlackMassiveInventory({
                  username: "ibfBot",
                  message: msg.msjSlack + JSON.stringify(msg.changes).replace(/[\[\]"]/g, '').replace(/,/g, ',\n'),
                  url: "farm_update"
                }, function (dataSlack) {
                  if (!dataSlack.success) {
                    console.log("Error on send slack massive inventory messaqe");
                    console.error(dataSlack.error);
                  }
                });
              }
            }

            // console.log('partial', partial)

            if (data.box) {
              mapTotal.totalNew = mapTotal.totalNew + data.box.totalNew;
              mapTotal.totalUpdate = mapTotal.totalUpdate + data.box.totalUpdate;
              for (var i = 0; i < data.box.changesNotFound.length; i++) {
                var element = data.box.changesNotFound[i];
                if (!mapTotal.mapChangesNotFound[element]) {
                  mapTotal.changesNotFound.push(element);
                  mapTotal.mapChangesNotFound[element] = true;
                }
              }

              if (data.box.updateInventories && Array.isArray(data.box.updateInventories) && data.box.updateInventories.length > 0) {
                try {
                  var keys = data.box.updateInventories.map(function (inv) {
                    return inv._KEY;
                  });
                  grower.batchUpdateInventories(keys);
                } catch (e) {
                  console.error('Error processing updateInventories in getMap:', e);
                }
              }
            }

            callback();
          }, function (er) {
            close();
            if (count === 0) {
              // alertify.error("Error updating inventory, we'll try to re initialize the import process");
              retry();
              count = 1;
            } else {
              msg.msj = 'Error updating inventory \n';
              if (er || er && er.error) {
                msg.msj += ' The error is: ' + (er.error ? er.error : er) + ' \n';
              }
              // alertify.error("Error updating inventory");
              // alertify.error(er);
              count = 0;
              onError(er ? er : new Error('Error updating inventory'));
            }
          });
        }, function (err) {
          if (err) {
            console.log('err.message', err.message);
            // alertify.error(err.message);
            return cbEach(err);
          }
          if (index === 0) {
            mapTotal.totalChangesNotFound = mapTotal.changesNotFound.length;
          }
          return cbEach();
        });
      }, function (error) {
        if (error) {
          onError(error);
        }
        onSuccess(mapTotal);
      });
    };

    grower.uploadFileToUrl = function (fd, onSuccess) {
      common.method.upload(common.urls.uploadFile, fd).then(function () {
        var res = common.response.post.data;
        if (res.success) {
          return onSuccess(true);
        } else {
          return onSuccess(false);
        }
      }, function () {
        return onSuccess(false);
      });
    };

    /**
     * Hace el update del inventario por partes primero los coloca a cero todos los inventarios
     * luego los actualiza con los valores del array.
     *
     * @param {Array} inventories - Array con todos los inventarios a actualizar
     * @param {Array} partialsChange - Array de array de 100 elementos o menos los cuales serán actualizado
     * @param {Date} iniDate - La fecha inicial del update
     * @param {Date} endDate - La fecha final del update
     * @param {function} onSuccess - En caso de exitos
     * @param {function} onError - En caso de error
     * @author carlos@socobox.co
     */
    grower.updateInventory = function (inventories, partialsChange, keyGrow, iniDate, endDate, msg, onSuccess, onError, close) {
      console.log('entering update inventory');
      async.waterfall([function (cb) {
        msg.msj = 'Re-initializing the specified inventory';
        grower.updateInvZero(inventories, iniDate, endDate, keyGrow, true, function (res) {
          cb(null, {});
        }, function (err) {
          cb(err);
        });
      }, function (box, cb) {
        grower.getMap(partialsChange, iniDate, endDate, keyGrow, inventories.length, msg, function (mapTotal) {
          cb(null, mapTotal);
        }, function (err) {
          cb(err);
        }, function () {
          return grower.updateInventory(inventories, partialsChange, keyGrow, iniDate, endDate, msg, onSuccess, onError, close);
        }, close);
      }], function (err, result) {

        if (err) {
          return onError(err);
        }
        onSuccess(result);
      });
    };

    grower.cartBoxByGrower = function (onSuccess, onError) {
      if (!common.getUserData()) {
        return onError();
      }
      var query = common.sbx.with('cart_box').andWhereIsEqual('grower', common.getUserData().grower).andWhereIsNotNull('purchase').fetchModels(["carrier"]).compile();
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addCondition('AND', 'grower', '=', common.getUserData().grower)
        .addCondition('AND', 'purchase', 'is not', null)
        .compile();*/

      common.loadAllPages(query, function (res) {

        res.results = res.results.map(function (box) {

          var fetched = res.fetched_results;

          if (fetched["carrier"][box.carrier] && box.carrier) {
            box.carrier_name = fetched["carrier"][box.carrier].carrier;
          } else {
            box.carrier_name = "Fedex";
          }

          return box;
        });

        onSuccess(res.results);
      }, onError);
    };

    grower.addOrderReqBid = function (order, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.addOrderReqBid,
        params: order
      }).then(function (res) {
        if (res.success) {
          onSuccess(res);
        } else {
          onError(res);
        }
      }, onError);
    };

    grower.deleteOrderReqBid = function (key, inventory, order_request, onSuccess, onError) {
      var params = { order_request_bid: key, inventory: inventory, order_request: order_request };
      common.method.run({
        key: environment.cloudscript.removeOrderReqBid,
        params: params
      }).then(function (res) {
        if (res.success) {
          onSuccess(res);
        } else {
          onError(res);
        }
      }, onError);
    };

    /**
     * Actualiza propiedades del cart_box_item desde el grower usando Cloudscript
     * params esperados:
     *  {
     *    customer: <customer_key>,
     *    cart_box_item: <cart_box_item_key>,
     *    quantity: <number>,
     *    stems_per_bunch: <stems_per_bunch_key>
     *  }
     * Retorna una Promesa que se resuelve si success=true, o se rechaza con el error.
     */
    grower.updateCartBoxItemProperties = function (params) {
      return common.method.run({
        key: environment.cloudscript.update_cart_box_item_properties,
        params: params
      }).then(function (res) {
        if (res && res.success) {
          return res;
        }
        return Promise.reject(res && res.error ? res.error : 'Error updating cart box item');
      });
    };

    grower.getHistoryByGrower = function (grower, selectedDate, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.getHistoryByGrower,
        params: { grower: grower, selectedDate: selectedDate }
      }).then(function (res) {
        if (res.success) {
          onSuccess(res);
        } else {
          onError(res);
        }
      }, onError);
    };

    return grower;
  }
})(angular);
//# sourceMappingURL=growerSrv.js.map

'use strict';

(function (angular) {
  angular.module('ibf').factory('maskSrv', ['$filter', maskSrv]);

  function maskSrv($filter) {
    function maskMoney(value) {
      this.value = isNaN(parseFloat(value)) ? 0 : parseFloat(value);
      this.model = $filter('currency')(this.value);
    }

    maskMoney.prototype.unMask = function () {
      this.model = this.value != 0 ? this.value : '';
    };
    maskMoney.prototype.setValue = function () {
      this.value = this.model ? parseFloat(this.model) : 0;
    };

    maskMoney.prototype.Mask = function () {
      this.model = $filter('currency')(this.value);
    };

    return maskMoney;
  }
})(angular);
//# sourceMappingURL=maskSrv.js.map

'use strict';

(function (angular) {
    angular.module('ibf').service('filterSrv', ['$filter', filterSrv]);

    function filterSrv($filter) {
        var chain = {
            value: '',
            start: function start(value) {
                this.value = value;
                return this;
            },
            applyFilter: function applyFilter(filterName, args) {
                args = args || [];
                args.unshift(this.value);
                this.value = $filter(filterName).apply(undefined, args);
                return this;
            }
        };

        return chain;
    }
})(angular);
//# sourceMappingURL=filterSrv.js.map

'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function (angular) {
  'use strict';

  angular.module('ibf').factory('floristSrv', ['commonSrv', '$filter', '$uibModal', 'productSrv', 'growerSrv', 'shippingSrv', 'environment', floristSrv]);

  function floristSrv(commonSrv, $filter, $uibModal, productSrv, growerSrv, shippingSrv, environment) {

    var florist = {},
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv,
        ss = shippingSrv;
    var _totalList = 0;
    var _totalListFav = 0;
    var _totalListDisc = 0;
    var _totalListCart = 0;
    var _currentBox = {};
    var _standingBox = {};
    var _notLoad = null;
    var _freightCost = {};
    var _factors = null;
    var _importDuties = null;
    var _cartbox_status = null;
    var _arrival_date = null;
    var _list_fav = [];
    var _filterList = [];
    var _customerGrowerRel = [];
    var _setupTotal = {
      users: 0,
      payOptions: 0,
      growers: 0
    };

    function newBox() {
      return {
        model: {},
        items: [],
        itemsMap: {}
      };
    }

    florist.checkBox = function () {
      if (!_currentBox.model) {
        _currentBox = newBox();
      }
    };

    florist.checkStandingBox = function () {
      if (!_standingBox.model) {
        _standingBox = newBox();
      }
    };

    florist.getArrivalDate = function () {
      if (!_arrival_date) {
        _arrival_date = new Date();
      }
      return _arrival_date;
    };

    florist.getListFav = function () {
      return _list_fav;
    };

    florist.setListFav = function (list) {
      _list_fav = list;
    };

    florist.clearCurrentBox = function () {
      _currentBox = newBox();
    };

    florist.clearStandingBox = function () {
      _standingBox = newBox();
    };

    florist.isAdmin = function (user_id) {
      return common.getUserData().customer_admin == user_id;
    };

    florist.currentUserIsAdmin = function () {
      return common.getUserData().customer_admin == common.getUserData().data.id;
    };

    florist.getSeptupTotal = function () {
      return _setupTotal;
    };

    florist.getTotalList = function () {
      return _totalList;
    };

    florist.getTotalListFav = function () {
      return _totalListFav;
    };

    florist.getTotalListDisc = function () {
      return _totalListDisc;
    };

    florist.getTotalListCart = function () {
      return _totalListCart;
    };

    florist.getCurrentBox = function () {
      return _currentBox;
    };

    florist.getStandingBox = function () {
      return _standingBox;
    };

    florist.getBaseQueryInventory = function (size, page) {
      return common.sbx.with('inventory').setPageSize(size || 100).setPage(page || 1).fetchModels(['masterlist', 'masterlist.grower', 'masterlist.grade', 'masterlist.box', 'masterlist.UoM', 'masterlist.stems_per_bunch', 'variety', 'variety.color', 'variety.product_group', 'grower', 'grower.custom_box']);
      /*common.queryBuilder()
       .setDomain(common.actual_domain)
       .setPageSize(size || 100)
       .setPage(page || 1)
       .setModel('inventory')
       .fetchModels([
         'masterlist',
         'masterlist.grower',
         'masterlist.grade',
         'masterlist.box',
         'masterlist.UoM',
         'masterlist.stems_per_bunch',
         'variety',
         'variety.color',
         'variety.product_group',
         'grower',
         'grower.custom_box'
       ]);*/
    };

    florist.getBaseQueryCartBox = common.getBaseQueryCartBox;

    florist.getBaseQueryCartboxItem = function (size, page) {
      return common.sbx.with('cart_box_item').setPageSize(size || 100).setPage(page || 1).fetchModels(['grower', 'inventory.masterlist', 'product_group', 'variety.color', 'uom', 'grade', 'stems_per_bunch', 'cart_box.grade', 'cart_box.carrier', 'cart_box.customer', 'cart_box.purchase', 'cart_box.status', 'cart_box.box', 'cart_box.product_group']);

      /*return common.queryBuilder()
        .setDomain(common.actual_domain)
        .setPageSize(size || 100)
        .setPage(page || 1)
        .setModel('cart_box_item')
        .fetchModels([
          'grower',
          'inventory.masterlist',
          'product_group',
          'variety.color',
          'uom',
          'stems_per_bunch',
          'cart_box.grade',
          'cart_box.customer',
          'cart_box.purchase',
          'cart_box.status',
          'cart_box.box',
          'cart_box.product_group'
        ]);*/
    };

    florist.getBaseQueryPurchase = function (size, page) {
      return common.sbx.with('purchase').setPageSize(size || 100).setPage(page || 1).fetchModels(['customer_user.customer', 'state', 'country']);
      /*return common.queryBuilder()
        .setDomain(common.actual_domain)
        .setPageSize(size || 100)
        .setPage(page || 1)
        .setModel('purchase')
        .fetchModels([
          'customer_user.customer',
          'state',
          'country'
        ]);*/
    };

    florist.getFlowersList = function (conditions, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          conditions: conditions
        };

        if (!_currentBox.model._KEY) {
          box.now = box.conditions.date;
          if (!box.conditions.date) {
            var dateInt = common.convertDateToNumberDate(florist.getArrivalDate());
            box.now = dateInt;
          }
          _arrival_date = common.convertNumberDateToDateEst(box.now);
        } else {
          box.now = typeof _currentBox.model.eta_date == 'number' ? _currentBox.model.eta_date : common.convertDateToNumberDate(_currentBox.model.eta_date);
        }

        florist.verifyInventory(box.conditions, box.now, function (res) {
          box.res = res;
          cb(null, box);
        }, onError);
      }, function (box, cb) {
        if (!box.res.results.length) {
          return cb(null, box);
        }

        florist.processInventory(box.res, box.now, function (inventories) {
          box.inventories = inventories;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (!box.res.results.length) {
          return cb(null, box);
        }

        florist.loadAndCheckFav(box.inventories, function (res) {
          box.inventories = res.inventories;
          box.favorites = res.favorites;
          cb(null, box);
        }, cb);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        if (box.res.results.length) {
          _list_fav = box.favorites;
          box.res.results = $filter('orderBy')(box.res.results, ['variety.product_group.common_name', 'variety.variety_name', 'masterlist.length']);
        }

        if (box.conditions.by_fav) {
          _totalListFav = box.res.results.length;
        } else {
          _totalListFav = box.favorites ? box.favorites.length : box.res.results.length;
          _totalList = box.res.results.length;
        }
        onSuccess(box.res);
      });
    };

    florist.searchAvailable = function (conditions, onSuccess, onError) {
      var days = [];
      for (var i = 1; i <= 14; i++) {
        days.push(i);
      }

      var box = {
        initDate: conditions.date,
        search: [],
        conditions: conditions
      };

      async.eachLimit(days, 1, function (index, cbIter) {
        var dateSearch = common.convertNumberDateToDate(box.initDate);
        dateSearch.setDate(dateSearch.getDate() + index);
        var numberDate = common.convertDateToNumberDate(dateSearch);
        florist.verifyInventory(box.conditions, numberDate, function (inventories) {
          if (inventories.results.length) {
            box.search.push({
              numberDate: numberDate,
              date: dateSearch,
              inventories: inventories
            });
            return cbIter('found');
          }
          cbIter(null);
        }, cbIter);
      }, function (errIter) {
        if (errIter && errIter != 'found') {
          return onError(errIter);
        }
        onSuccess($filter('orderBy')(box.search, 'numberDate'));
      });
    };

    florist.processInventoryAvailable = function (res, numberDate, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          now: numberDate,
          res: res
        };

        florist.processInventory(box.res, box.now, function (inventories) {
          box.inventories = inventories;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        florist.loadAndCheckFav(box.inventories, function (res) {
          box.inventories = res.inventories;
          box.favorites = res.favorites;
          cb(null, box);
        }, cb);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        _totalListFav = box.favorites.length;
        _totalList = box.res.results.length;
        _list_fav = box.favorites;

        box.inventories = $filter('orderBy')(box.inventories, ['variety.product_group.common_name', 'variety.variety_name', 'masterlist.length']);
        onSuccess(box.inventories);
      });
    };

    florist.verifyInventory = function (conditions, numberDate, onSuccess, onError) {
      async.waterfall([function (cb) {
        // relacion de customer - set inicial de calendario o por box
        var box = {
          available: true,
          conditions: conditions,
          favorites: [],
          fav_masterlist: [],
          now: numberDate,
          isCurrentBox: _currentBox.model._KEY ? true : false
        };

        if (_customerGrowerRel.length) {
          box.conditions.notLoad = angular.copy(_customerGrowerRel);
          return cb(null, box);
        }

        common.loadGrowerCustomerRelation(function (response) {
          box.conditions.notLoad = [];
          angular.forEach(response.results, function (item) {
            if (!item.customer_perm) {
              box.conditions.notLoad.push(item.grower);
            }
          });
          _customerGrowerRel = angular.copy(box.conditions.notLoad);
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        //get shipping valid growers
        var now = common.convertNumberDateToDateEst(box.now);
        ss.getGrowersShipping(now, function (res) {
          if (res.notValid) {
            box.available = false;
          }
          box.countries = res.countries;
          for (var i = 0; i < res.invalid.length; i++) {
            var aux = res.invalid[i];
            if (box.conditions.notLoad.indexOf(aux) != -1) {
              continue;
            }

            box.conditions.notLoad.push(aux);
          }
          cb(null, box);
        }, cb);
      }, function (box, cb) {

        if (!box.available) {
          box.res = { results: [] };
          return cb(null, box);
        }

        if (box.conditions.grower && box.conditions.notLoad.indexOf(box.conditions.grower) != -1) {
          box.res = { results: [] };
          return cb(null, box);
        }

        if (box.conditions.country) {
          var auxCountry = [];
          for (var i = 0; i < box.countries.length; i++) {
            var country = box.countries[i];
            if (country._KEY == box.conditions.country) {
              auxCountry = [country];
              break;
            }
          }
          box.countries = auxCountry;
        }

        var params = {
          conditions: box.conditions,
          isCurrentBox: box.isCurrentBox,
          user_key: common.userData.key,
          now: box.now,
          countries: box.countries,
          currentBox: _currentBox
        };

        florist.searchInventory(params, function (res) {
          box.res = angular.copy(res);
          cb(null, box);
        }, cb);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }
        box.res.results = $filter('orderBy')(box.res.results, ['variety.product_group.common_name', 'variety.variety_name', 'masterlist.length']);
        onSuccess(box.res);
      });
    };

    florist.processInventory = function (res, numberDate, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          numberDate: numberDate
        };

        florist.fetchInventory(res, function (response) {
          box.inventories = response.results;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        florist.calculateInventory(box.inventories, box.numberDate, function (res) {
          box.inventories = res;
          cb(null, box);
        }, cb);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }
        onSuccess(box.inventories);
      });
    };

    florist.calculateInventory = function (inventories, numberDate, onSuccess, onError) {
      async.waterfall([function (cb) {
        console.log('loading dependencies...');
        var box = {
          inventories: inventories
        };

        florist.loadDependencieCalculateInventory(numberDate, function (err, res) {
          box.freightCosts = res.freightCosts;
          box.importDuties = res.importDuties;
          box.factorsMap = res.factorsMap;
          cb(err, box);
        });
      }, function (box, cb) {
        console.log('calculating price..');
        florist.calculateInventoryPrice(box.inventories, box.freightCosts, box.importDuties, box.factorsMap, function (res) {
          box.inventories = res;
          cb(null, box);
        }, cb);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box.inventories);
      });
    };

    florist.loadAndCheckFav = function (inventories, onSuccess, onError) {
      async.waterfall([function (cb) {
        // carga listado de favs
        var box = {
          inventories: inventories,
          favorites: [],
          fav_masterlist: []
        };

        var favListMap = {};
        var listFavKey = [];
        florist.getFlowersListFav(function (res) {
          angular.forEach(res.results, function (fav) {
            if (!favListMap[fav.masterlist]) {
              favListMap[fav.masterlist] = fav;
              box.fav_masterlist.push(fav);
            } else {
              listFavKey.push(fav._KEY);
            }
          });
          if (listFavKey.length) {
            florist.removeMasterlistFavDuplicate(listFavKey, function () {});
          }
          cb(null, box);
        }, cb);
      }, function (box, cb) {

        for (var i = 0; i < box.fav_masterlist.length; i++) {
          for (var j = 0; j < box.inventories.length; j++) {
            if (box.fav_masterlist[i].masterlist != box.inventories[j].masterlist._KEY) {
              continue;
            }

            box.inventories[j].is_favorite = true;
            box.favorites.push(box.inventories[j]);
          }
        }
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box);
      });
    };

    florist.searchInventory = function (params, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.searchInventory,
        params: params
      }).then(function (response) {
        if (response.success) {
          onSuccess(response.res);
        } else {
          console.log(response.error);
          onError(response.error);
        }
      }, onError);
    };

    florist.loadDependencieCalculateInventory = function (numberDate, callback) {
      var box = {
        now: numberDate
      };

      async.parallel([function (pCb) {
        // carga el margin del customer
        console.log('loadMargin');
        if (common.getCustomerMargin()) {
          pCb(null);
        } else {
          var query = common.sbx.with('user').setPage(1).fetchModels(['customer']).setPageSize(1000).whereWithKeys([common.getUserData().key]).compile();
          /*
          var query = common.queryBuilder()
            .setDomain(common.actual_domain)
            .setModel('user')
            .setPage(1)
            .fetchModels(['customer'])
            .setPageSize(1000)
            .whereWithKeys([common.getUserData().key])
            .compile();*/

          common.method.query(common.urls.find, query).then(function () {
            var response = common.response.post_query;
            var role = response.data.results[0].role ? response.data.results[0].role : null;

            if (role && role === 'FLORIST') {
              var user = common.getUserData();
              user.customer_margin = response.data.fetched_results.customer[user.customer].margin || 0;
              common.checkUserPromotion(user, function () {
                common.setUserData(user);
                var expire = new Date();
                expire.setHours(expire.getHours() + 1);
                common.setCustomerMargin(user.customer_margin, {
                  expires: expire
                });
                pCb(null);
              });
            }
          });
        }
      }, function (pCb) {
        //carga de los freight costs
        console.log('load_freightCost');
        var now = common.convertNumberDateToDate(box.now);
        var year = now.getFullYear();
        var month = now.getMonth();
        var yearMonth = year + '_' + month;

        if (_freightCost[yearMonth]) {
          box.freightCosts = _freightCost[yearMonth];
          return pCb(null);
        }

        florist.loadFreightCostByDate(now, function (res) {
          _freightCost[yearMonth] = res.results;
          box.freightCosts = res.results;
          pCb(null);
        }, pCb);
      }, function (pCb) {
        // carga de los factors
        console.log('load_factors');
        ps.listFactors(function (res) {
          var mapFactors = {};
          angular.forEach(res.data, function (factor) {
            var keyMap = factor.carrier._KEY + '_' + factor.country._KEY;
            if (!mapFactors[keyMap]) {
              mapFactors[keyMap] = factor;
            }
          });
          _factors = mapFactors;
          box.factorsMap = mapFactors;
          pCb(null);
        }, pCb);
      }, function (pCb) {
        // carga de los import duties
        console.log('load_importduties');
        if (_importDuties) {
          box.importDuties = _importDuties;
          return pCb(null);
        }

        florist.loadImportDuties(function (res) {
          var mapImportDuties = {};
          for (var i = 0; i < res.results.length; i++) {
            var importDutie = res.results[i];
            var keyMap = importDutie.product_group + '_' + importDutie.country;
            if (!mapImportDuties[keyMap]) {
              mapImportDuties[keyMap] = importDutie.tax;
            }
          }
          _importDuties = mapImportDuties;
          box.importDuties = mapImportDuties;
          pCb(null);
        }, pCb);
      }], function (err) {
        if (err) {
          return callback(err, box);
        }
        callback(null, box);
      });
    };

    florist.getFlowersListFav = function (onSuccess, onError) {
      console.log(common.getUserData().ibf_role);
      if (common.getUserData().ibf_role != 'FLORIST') {
        return onSuccess([]);
      }
      var query = common.sbx.with('fav_masterlist').andWhereIsEqual('user', common.getUserData().key).compile();
      /*var query = common.queryBuilder();
      query.setDomain(common.actual_domain);
      query.setModel('fav_masterlist');
      query.addCondition('AND', 'user', '=', common.getUserData().key);
      query = query.compile();*/

      common.loadAllPages(query, function (res) {
        onSuccess(res);
      }, onError);
    };

    florist.addInventoryConditionsByCartBox = function (query, cart_box) {
      query.andWhereIsEqual('masterlist.grower', cart_box.grower._KEY);
      //query.addCondition('AND', 'masterlist.grower', '=', cart_box.grower._KEY);
    };

    florist.updateBunchesInBox = function (onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {};
        var query = common.sbx.with('add_masterlist').fetchModels(['UoM', 'stems_per_bunch']);
        /*var query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('add_masterlist')
          .fetchModels([
            'UoM',
            'stems_per_bunch',
          ]);*/

        box.query = query.compile();
        cb(null, box);
      }, function (box, cb) {
        console.log('masterlist loading...');
        common.loadAllPages(box.query, function (res) {
          box.res = res;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        var fetched = box.res.fetched_results;
        async.eachSeries(box.res.results, function (item, cbEach) {

          item.UoM = fetched.uom[item.UoM];
          item.stems_per_bunch = fetched.stems_per_bunch[item.stems_per_bunch];
          if (!item.bunches_in_box) {
            console.log('masterlist ->', item._KEY);
            item.bunches_in_box = parseInt(item.units);
            if (item.UoM.uom == 'stem') {
              item.bunches_in_box = (parseInt(item.units) / parseInt(item.stems_per_bunch.stems_per_bunch)).toFixed(0);
            }
            var query = common.sbx.insert('add_masterlist', {
              '_KEY': item._KEY,
              'bunches_in_box': item.bunches_in_box
            });

            /*const query = common.queryBuilder()
              .setDomain(common.actual_domain)
              .setModel('add_masterlist')
              .addObject({
                '_KEY': item._KEY,
                'bunches_in_box': item.bunches_in_box
              }).compile();*/
            console.log('updating...', item.bunches_in_box);
            common.method.query(common.urls.update, query).then(function () {
              var res = common.response.post_query.data;
              if (res.success) {
                cbEach(null);
              } else {
                cbEach(new Error(res.error));
              }
            });
          } else {
            async.nextTick(function () {
              cbEach(null, box);
            });
          }
        }, function (errEach) {
          if (errEach) {
            return cb(errEach);
          }
          cb(null, box);
        });
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box.res);
      });
    };

    florist.fetchInventory = function (res, onSuccess, onError) {
      var fetched = res.fetched_results;
      angular.forEach(res.results, function (item) {
        item.masterlist = fetched.add_masterlist[item.masterlist];
        item.masterlist.grower = fetched.grower[item.masterlist.grower] || item.masterlist.grower;
        item.grower = fetched.grower[item.grower];
        item.grower.custom_box = fetched.admin_box[item.grower.custom_box] || item.grower.custom_box;
        item.masterlist.grade = fetched.grade[item.masterlist.grade] || item.masterlist.grade;
        item.masterlist.box = fetched.admin_box[item.masterlist.box] || item.masterlist.box;
        item.masterlist.UoM = fetched.uom[item.masterlist.UoM] || item.masterlist.UoM;
        item.masterlist.stems_per_bunch = fetched.stems_per_bunch[item.masterlist.stems_per_bunch] || item.masterlist.stems_per_bunch;

        item.variety = fetched.variety[item.variety];
        item.variety.color = fetched.color[item.variety.color] || item.variety.color;
        item.variety.product_group = fetched.product_group[item.variety.product_group] || item.variety.product_group;
        item.variety.color.list = [];
        for (var i = 0; i < 7; i++) {
          var j = i + 1;
          if (!item.variety.color['html_code_' + j]) {
            continue;
          }
          item.variety.color.list.push({ 'color': item.variety.color['html_code_' + j] });
        }
      });

      onSuccess(res);
    };

    florist.fetchImageInventory = function (inventories, onSuccess, onError) {
      var grower_map = {};
      var grower_array = [];
      var mapImage = {};
      angular.forEach(inventories, function (item) {
        if (!grower_map[item.masterlist.grower._KEY]) {
          grower_map[item.masterlist.grower._KEY] = true;
          grower_array.push(item.masterlist.grower._KEY);
        }

        var ref = item.masterlist.grower._KEY + '_' + item.variety._KEY;
        if (!mapImage[ref]) {
          mapImage[ref] = {
            variety: item.variety._KEY,
            grower: item.masterlist.grower._KEY,
            items: []
          };
        }
        mapImage[ref].items.push(item);
      });
      var mapsUrl = {};
      var array = Object.keys(mapImage);
      async.waterfall([function (cb) {
        florist.getInventoryPicture(grower_array, function (maps) {
          mapsUrl = maps;
          cb(null);
        }, function (err) {
          cb(null);
        });
      }, function (cb) {
        angular.forEach(array, function (item) {
          var obj = mapImage[item];
          var tmp = obj.items;
          var url = common.actual_base_url + '/varieties/variety_' + obj.variety + '.jpg';
          if (mapsUrl[item]) {
            url = mapsUrl[item];
          }
          for (var i = 0; i < tmp.length; i++) {
            tmp[i].picture = url;
          }
        });
        cb(null);
      }], function (err) {
        onSuccess(null);
      });
    };

    florist.calculateInventoryPrice = function (inventories, freightCosts, importDuties, factorsMap, onSuccess, onError) {
      angular.forEach(inventories, function (item) {
        switch (item.combo) {
          case 1:
            item.off = 10;
            break;
          case 2:
            item.off = 20;
            break;
          case 3:
            item.off = 30;
            break;
          case 4:
            item.off = 40;
            break;
          case 5:
            item.off = 50;
            break;
          default:
            item.off = 0;
        }

        var factor = 5000;

        var freightCost = void 0;

        for (var i = 0; i < freightCosts.length; i++) {
          if (freightCosts[i].carrier.code == 1) {
            freightCost = freightCosts[i];
          }
        }
        var keyFactor = freightCost.carrier._KEY + '_' + item.masterlist.grower.country;
        factor = parseInt(factorsMap[keyFactor].factor_calculator);

        item.base_price = item.price;
        var price = item.base_price;
        var importDutie = 0;
        var array = Object.keys(importDuties);
        for (var _i = 0; _i < array.length; _i++) {
          var aux = array[_i];
          var keyMap = item.variety.product_group._KEY + '_' + item.masterlist.grower.country;
          if (keyMap == aux) {
            importDutie = item.price * (parseFloat(importDuties[keyMap]) / 100);
            break;
          }
        }

        var priceFarm = price + importDutie;

        var boxGrower = item.masterlist.box_charge / item.masterlist.units;
        item.base_price = item.base_price + boxGrower;

        var boxAdmin = item.masterlist.box.box_cost / item.masterlist.units;

        var freightCostPerKg = freightCost.freight_cost * (freightCost.value / 100) + freightCost.freight_cost;

        var dimWeight = (item.masterlist.box.box_length * item.masterlist.box.box_heigth * item.masterlist.box.box_width / factor).toFixed(2);

        item.price = florist.getInventoryPrice(item, priceFarm, boxGrower, boxAdmin, freightCostPerKg, dimWeight);
        item.price_own_box = 0;
        item.custom_box_cost = 0;
        if (item.masterlist.customizable) {
          boxAdmin = item.grower.custom_box.box_cost / item.masterlist.units;
          dimWeight = (item.grower.custom_box.box_length * item.grower.custom_box.box_heigth * item.grower.custom_box.box_width / factor).toFixed(2);
          item.price_own_box = florist.getInventoryPrice(item, priceFarm, boxGrower, boxAdmin, freightCostPerKg, dimWeight);
          var percentage = item.masterlist.custom_percentage / 100;
          var custom_box_cost = item.grower.custom_box_cost || 2.5;
          item.custom_box_cost = percentage * custom_box_cost;
        }

        item.available = parseInt(item.quantity);
        item.total_box = parseInt(item.masterlist.bunches_in_box);
        if (item.masterlist.UoM.uom == 'stem') {
          item.available = (parseInt(item.quantity) / parseInt(item.masterlist.stems_per_bunch.stems_per_bunch)).toFixed(0);
          item.price = parseFloat(item.price) * parseInt(item.masterlist.stems_per_bunch.stems_per_bunch);
          item.price_own_box = parseFloat(item.price_own_box) * parseInt(item.masterlist.stems_per_bunch.stems_per_bunch);
        }
        item.price_ori = item.price;
        item.price_own_box_ori = item.price_own_box;
        if (item.combo != 0) {
          item.price = item.price * (1 - item.off / 100);
          item.price_own_box = item.price_own_box * (1 - item.off / 100);
        }

        item.price = parseFloat(item.price.toFixed(2));
        item.price_own_box = item.price_own_box + item.custom_box_cost;
        item.price_own_box = parseFloat(item.price_own_box.toFixed(2));
      });

      onSuccess(inventories);
    };

    florist.getInventoryPrice = function (inventory, priceFarm, boxGrower, boxAdmin, freightCostPerKg, dimWeight) {

      var invKg = Math.max(parseFloat(inventory.masterlist.actual_weight), parseFloat(dimWeight));

      var freightCostUoM = freightCostPerKg * invKg / inventory.masterlist.units;
      var subtotal = priceFarm + boxGrower + boxAdmin + freightCostUoM;

      var marginPercentange = parseFloat(common.getUserData().customer_margin) / 100;
      var marginFol = subtotal / (1 - marginPercentange) - subtotal;
      return subtotal + marginFol;
    };

    florist.getInventoryPicture = function (grower_array, onSuccess, onError) {
      var query = common.sbx.with('variety_grower_photo').setPageSize(1000).setPage(1).andWhereIn('grower_id', grower_array).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setPageSize(1000)
        .setPage(1)
        .setModel('variety_grower_photo')
        .addCondition('AND', 'grower_id', 'in', grower_array)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          var mapsImages = {};
          angular.forEach(res.results, function (item) {
            mapsImages[item.grower_id + '_' + item.variety_id] = common.actual_base_url + '/growers/' + item.grower_id + '/variety_' + item.variety_id + '.jpg';
          });
          var url = '';
          // if (res.results.length > 0) {
          //   url = common.actual_base_url + '/growers/' + grower_key + '/variety_' + variety_key + '.jpg'
          // } else {
          //   url = common.actual_base_url + '/varieties/variety_' + variety_key + '.jpg';
          // }

          onSuccess(mapsImages);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.findAndFecthInventory = function (query, onSuccess, onError) {
      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          florist.fetchInventory(res, onSuccess, onError);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getShoppingCart = function (onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          results: [],
          cartboxes: []
        };
        florist.getCartBoxByCustomer(function (data) {
          box.cartboxes = data.results;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        var cartboxes = [];
        var cartboxesToDelete = [];
        angular.forEach(box.cartboxes, function (cartbox) {
          if (ss.checkCartBoxShipDay(cartbox)) {
            cartboxes.push(cartbox);
          } else {
            if (!cartbox.is_standing_order) {
              cartboxesToDelete.push(cartbox);
            }
          }
        });
        if (cartboxesToDelete.length) {
          angular.forEach(cartboxesToDelete, function (cartbox) {
            florist.deleteBox(cartbox, function () {
              console.log(cartbox._KEY + '-> DELETED');
            }, function (err) {
              console.log(err);
            });
          });
        }

        box.cartboxes = cartboxes;
        box.cartboxesDeleted = cartboxesToDelete;
        cb(null, box);
      }, function (box, cb) {
        angular.forEach(box.cartboxes, function (item) {
          if (item.closed) {
            box.results.push(item);
          }
        });

        _totalListCart = box.results.length;

        cb(null, box);
      }], function (e, box) {
        if (e) {
          return onError(e);
        }

        onSuccess(box.results);
      });
    };

    florist.getCartBoxByCustomer = function (onSuccess, onError) {
      var query = florist.getBaseQueryCartBox();

      query.andWhereIsEqual('customer', common.getUserData().customer);
      query.andWhereIsNull('purchase');
      /*query.addCondition('AND', 'customer', '=', common.getUserData().customer);
      query.addCondition('AND', 'purchase', 'is', null);*/

      query = query.compile();
      florist.getCartBoxes(query, function (res) {
        var total = res.row_count;
        angular.forEach(res.results, function (item, index) {
          if (!item.closed || item.is_standing_order) {
            total = total - 1;
          }
        });
        _totalListCart = total;
        onSuccess(res);
      }, onError);
    };

    florist.getCartBoxByPurchase = function (purchase_key, onSuccess, onError) {
      var query = florist.getBaseQueryCartBox();

      query.andWhereIsEqual('purchase', purchase_key);
      //query.addCondition('AND', 'purchase', '=', purchase_key);
      query = query.compile();

      florist.getCartBoxes(query, onSuccess, onError);
    };

    florist.getCartBoxes = function (query, onSuccess, onError) {

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {

          florist.fetchCartBox(res, onSuccess, onError);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getCartBox = function (cartboxKey, onSuccess, onError) {
      var query = florist.getBaseQueryCartBox();

      query = query.whereWithKeys([cartboxKey]).compile();

      florist.getCartBoxes(query, function (res) {
        if (res.results.length == 1) {
          var item = res.results[0];
          onSuccess(item);
        } else {
          onError(new Error('cart_box not exist.'));
        }
      }, onError);
    };

    /**
     * this fetch was based in getBaseQueryCartBox
     * allways send resourse(results, fetched_results) and callback
     */

    florist.fetchCartBox = common.fetchCartBox;

    florist.fetchCartboxItem = function (res, onSuccess, onError) {
      var fetched = res.fetched_results;

      angular.forEach(res.results, function (item, index) {

        item.grower = fetched.grower[item.grower];
        item.inventory = item.inventory && fetched.inventory[item.inventory];
        item.masterlist = item.inventory && fetched.add_masterlist[item.inventory.masterlist];
        item.product_group = fetched.product_group[item.product_group];
        item.variety = fetched.variety[item.variety];

        item.variety.color = fetched.color[item.variety.color] || item.variety.color;
        item.uom = fetched.uom[item.uom];
        item.stems_per_bunch = fetched.stems_per_bunch[item.stems_per_bunch];

        if (item.grade) {
          item.grade = fetched.grade[item.grade] || item.grade;
        }

        item.cart_box = fetched.cart_box[item.cart_box];
        item.cart_box.arrival_date = new Date(item.cart_box.arrival_date);
        item.cart_box.eta_date = typeof item.cart_box.eta_date == 'number' ? common.convertNumberDateToDate(item.cart_box.eta_date) : item.cart_box.eta_date;
        item.cart_box.packing_date = typeof item.cart_box.packing_date == 'number' ? common.convertNumberDateToDate(item.cart_box.packing_date) : item.cart_box.packing_date;
        item.cart_box.customer = fetched.customer[item.cart_box.customer] || item.cart_box.customer;
        item.cart_box.box = fetched.admin_box[item.cart_box.box] || item.cart_box.box;
        item.cart_box.grower = item.grower;
        item.cart_box.product_group = fetched.product_group[item.cart_box.product_group] || item.cart_box.product_group;

        if (fetched["carrier"][item.cart_box.carrier] && item.cart_box.carrier) {
          item.cart_box.carrier_name = fetched["carrier"][item.cart_box.carrier].carrier;
        } else {
          item.cart_box.carrier_name = "Fedex";
        }

        if (item.cart_box.grade) {
          item.cart_box.grade = fetched.grade[item.cart_box.grade] || item.cart_box.grade;
        }

        if (item.cart_box.purchase) {
          item.cart_box.purchase = fetched.purchase[item.cart_box.purchase] || item.cart_box.purchase;
        }

        if (item.cart_box.status) {
          item.cart_box.status = fetched.cart_box_status[item.cart_box.status] || item.cart_box.status;
        }

        if (item.uom && item.uom.uom) {
          item.per_uom = item.uom.uom == 'stem' ? 'bunch' : item.uom.uom;
        }
      });
      onSuccess(null);
    };

    florist.loadCartBoxStatus = function (onSuccess, onError) {
      if (_cartbox_status) {
        return onSuccess(_cartbox_status);
      }
      var query = common.sbx.with('cart_box_status').setPageSize(100).setPage(1).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setPageSize(100)
        .setPage(1)
        .setModel('cart_box_status')
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          _cartbox_status = res;
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getCurrentBoxItems = function (onSuccess, onError) {
      florist.getCurrentBox().items = [];
      florist.getCurrentBox().itemsMap = {};
      florist.getCartBoxItems(_currentBox.model._KEY, function (res) {
        angular.forEach(res.results, function (item, index) {
          item.is_editable = true;
          florist.getCurrentBox().items.push(item);
          florist.getCurrentBox().itemsMap[item.inventory._KEY] = item;
        });
        onSuccess(res);
      }, onError);
    };

    florist.getCartBoxItems = function (cartbox, onSuccess, onError) {
      var query = florist.getBaseQueryCartboxItem();

      query.andWhereIsEqual('cart_box', cartbox);
      /*query.addCondition('AND', 'cart_box', '=', cartbox);
       query = query.compile();*/

      common.method.query(common.urls.find, query.compile()).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          var fetched = res.fetched_results;
          florist.fetchCartboxItem(res, function () {
            onSuccess(res);
          }, onError);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getTimeZoneList = function (onSuccess, onError) {
      var query = common.sbx.with('time_zone').compile();
      //var query = common.queryBuilder().setDomain(common.actual_domain).setModel('time_zone').compile();

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getCountriesList = function (onSuccess, onError) {
      var query = common.sbx.with('country').compile();
      //var query = common.queryBuilder().setDomain(common.actual_domain).setModel('country').compile();

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getProductGroupList = function (onSuccess, onError) {
      var query = common.sbx.with('product_group').compile();
      // var query = common.queryBuilder().setDomain(common.actual_domain).setModel('product_group').compile();

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getVarietyList = function (params, onSuccess, onError) {
      var query = common.sbx.with('variety');
      //var query = common.queryBuilder().setDomain(common.actual_domain).setModel('variety');
      if (params.notAssorted) {
        query.andWhereIsNotEqual('variety_name', 'Assorted');
        query.orWhereIsNotEqual('variety_name', 'assorted');
        /*
        query.addCondition('AND', 'variety_name', '!=', 'Assorted');
        query.addCondition('OR', 'variety_name', '!=', 'assorted');*/
      }
      query = query.compile();

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getColorsList = function (onSuccess, onError) {
      var query = common.sbx.with('color').compile();
      //var query = common.queryBuilder().setDomain(common.actual_domain).setModel('color').compile();

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getCategoriesList = function (onSuccess, onError) {
      var query = common.sbx.with('category').compile();
      //var query = common.queryBuilder().setDomain(common.actual_domain).setModel('category').compile();

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getGroupTypeList = function (onSuccess, onError) {
      var query = common.sbx.with('group_type').compile();
      //var query = common.queryBuilder().setDomain(common.actual_domain).setModel('group_type').compile();

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getStatesList = function (onSuccess, onError) {
      var query = common.sbx.with('state').compile();
      //var query = common.queryBuilder().setDomain(common.actual_domain).setModel('state').compile();

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    // SALES ARGUMENT
    florist.loadSalesArgument = function (onSuccess, onError) {
      var query = common.sbx.with('sales_arguments').compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('sales_arguments')
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(res.error);
        }
      });
    };

    florist.addBoxComplete = function (params, onSuccess, onError) {
      var arrayTmp = new Array(params.numberBox).fill().map(function (_, i) {
        return i + 1;
      });
      async.eachSeries(arrayTmp, function (item, cbIter) {
        florist.addToBox(params, function (res) {
          cbIter(null);
        }, cbIter);
      }, function (err) {
        if (err) {
          return onError(err);
        }

        onSuccess();
      });
    };

    florist.addToBox = function (params, onSuccess, onError) {
      var inventory = params.inventory;
      var quantity = params.quantity;
      var arrival_date = params.arrival_date;
      var total_box = params.total_box;
      async.waterfall([function (cb) {
        var box = {
          currentBox: florist.getCurrentBox(),
          is_complete: false,
          invalid: false,
          arrival_date: arrival_date,
          inventory: inventory,
          quantity: quantity
        };
        florist.checkBox();
        if (box.currentBox.model._KEY && box.currentBox.model.grower._KEY != inventory.masterlist.grower._KEY) {
          box.invalid = true;
        }
        cb(null, box);
      }, function (box, cb) {
        if (box.invalid) {
          return cb(null, box);
        }
        florist.validateBox(params, function (data) {
          box.inventory.available = box.inventory.available - box.quantity;
          if (params.custom_box) {
            box.is_complete = box.currentBox.model.current_percentage >= 100;
          } else {
            box.is_complete = true;
          }

          cb(null, box);
        }, function (err) {
          cb(err, box);
        });
      }, function (box, cb) {
        if (box.is_complete) {
          florist.closeBox({
            currentBox: box.currentBox
          }, function () {
            cb(null, box);
          });
        } else {
          cb(null, box);
        }
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box);
      });
    };

    florist.closeBox = function (params, callback) {
      var meta = {
        grower: params.currentBox.model.grower.company_name,
        product: params.currentBox.model.product_group.common_name,
        user_id: common.getUserData().data.id
      };
      common.registerEvent(meta, 'added_to_cart');
      florist.clearCurrentBox();
      florist.calculateBoxPrice(params.currentBox, function (res) {
        florist.getCartBoxByCustomer(callback, common.onErrorDefault);
      }, common.onErrorDefault);
    };

    // IBUYFLOWERS
    florist.validateBox = function (params, onSuccess, onError) {

      var inventory = params.inventory;
      var quantity = params.quantity;
      var arrival_date = params.arrival_date;
      var custom_box = params.custom_box;

      var current_box = florist.getCurrentBox();

      async.waterfall([function (cb) {
        var box = {
          inv: inventory,
          quant: quantity,
          isBoxNew: false,
          percentage: custom_box ? inventory.masterlist.custom_percentage * quantity : 0,
          custom_box: custom_box
        };
        if (!current_box.model._KEY) {
          box.isBoxNew = true;
          current_box.model.custom = custom_box;
          current_box.model.product_group = custom_box ? common.product_group_default : inventory.variety.product_group;
          current_box.model.variety = custom_box ? common.variety_default : inventory.variety;
          current_box.model.grade = inventory.masterlist.grade;
          current_box.model.box = custom_box ? inventory.masterlist.grower.custom_box : inventory.masterlist.box;
          current_box.model.grower = inventory.masterlist.grower;
          current_box.model.customer = common.getUserData().customer;
          current_box.model.price = inventory.masterlist.box_charge;
          current_box.model.length = inventory.masterlist.length;
          current_box.model.current_items = quantity;
          current_box.model.total_items = custom_box ? quantity : inventory.total_box;
          current_box.model.eta_date = common.convertDateToNumberDate(arrival_date);
          current_box.model.packing_date = inventory.packing_date;
          current_box.model.arrival_date = arrival_date;
          current_box.model.current_percentage = custom_box ? inventory.masterlist.custom_percentage : 100;
          current_box.model.custom_box_cost = custom_box ? inventory.grower.custom_box_cost || 0 : 0;
        }

        cb(null, box);
      }, function (box, cb) {
        if (!box.isBoxNew) {
          return cb(null, box);
        }

        console.log('Creating CartBox..');
        florist.createBox(current_box.model, function (data) {
          current_box.model._KEY = data.keys[0];
          box.isBoxItemNew = true;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (box.isBoxNew) {
          return cb(null, box);
        }

        if (!current_box.model.custom) {
          return cb('Error Updating', box);
        }

        console.log('Updating CartBox..');
        var finalquant = parseInt(box.quant) + parseInt(current_box.model.current_items);
        var finalPercentage = current_box.model.current_percentage + box.percentage;
        if (finalPercentage > 100) {
          return cb('Error Updating', box);
        }

        var cartbox = {
          '_KEY': current_box.model._KEY,
          'current_items': current_box.model.current_items + box.quant,
          'total_items': finalquant,
          'current_percentage': current_box.model.current_percentage + box.percentage
        };

        florist.updateBox(cartbox, function (data) {
          if (!current_box.itemsMap[inventory._KEY]) {
            box.isBoxItemNew = true;
          } else {
            box.isBoxItemNew = false;
          }
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (!box.isBoxItemNew) {
          return cb(null, box);
        }

        console.log('Creating CartBoxItem..');
        var model = current_box.model;
        var custom_box_cost = 0;
        if (box.custom_box) {
          custom_box_cost = box.inv.custom_box_cost;

          if (box.inv.masterlist.UoM.uom == 'stem') {
            custom_box_cost = parseFloat(box.inv.custom_box_cost) / parseFloat(box.inv.masterlist.stems_per_bunch.stems_per_bunch);
            custom_box_cost = parseFloat(custom_box_cost.toFixed(2));
          }
        }
        var cart_box_item = {
          'inventory': box.inv._KEY,
          'product_group': box.inv.variety.product_group._KEY,
          'grower': model.grower._KEY,
          'variety': box.inv.variety._KEY,
          'quantity': box.quant,
          'cart_box': model._KEY,
          'price': !box.custom_box ? box.inv.price : box.inv.price_own_box,
          'picture': box.inv.picture,
          'uom': box.inv.masterlist.UoM._KEY,
          'stems_per_bunch': box.inv.masterlist.stems_per_bunch._KEY,
          'base_price': box.inv.base_price + custom_box_cost,
          'off': box.inv.off,
          'percentage': box.inv.masterlist.custom_percentage
        };
        florist.addBoxItem(cart_box_item, function (data) {
          cb(null, box);
        });
      }, function (box, cb) {
        if (box.isBoxItemNew) {
          return cb(null, box);
        }
        console.log('Updating CartBoxItem..');
        var maps = current_box.itemsMap;
        var box_item = maps[box.inv._KEY];
        var cart_box_item = {
          '_KEY': box_item._KEY,
          'quantity': box_item.quantity + box.quant
        };
        florist.updateBoxItem(cart_box_item, function (data) {
          cb(null, box);
        });
      }, function (box, cb) {

        console.log('Get CartBoxItem..');
        florist.getCurrentBoxItems(function (data) {
          cb(null, box);
        }, cb);
      }, function (box, cb) {

        console.log('Updating Inventory..');
        florist.updateInventory(box.inv._KEY, box.quant, function (data) {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (box.isBoxNew) {
          return cb(null, box);
        }
        current_box.model.current_items = current_box.model.current_items + box.quant;
        current_box.model.current_percentage = current_box.model.current_percentage + box.percentage;
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(null);
      });
    };

    florist.createBox = function (model, onSuccess, onError) {
      var cart_box = {
        'product_group': model.product_group._KEY,
        'grade': model.grade ? model.grade._KEY : null,
        'variety': model.variety._KEY,
        'box': model.box._KEY,
        'grower': model.grower._KEY,
        'customer': model.customer,
        'price': model.price,
        'current_items': model.current_items,
        'total_items': model.total_items,
        'length': model.length,
        'arrival_date': model.arrival_date,
        'eta_date': model.eta_date,
        'packing_date': model.packing_date,
        'is_standing_order': model.is_standing_order || false,
        'off': 0,
        'current_percentage': model.current_percentage,
        'custom': model.custom,
        'custom_box_cost': model.custom_box_cost
        //'standing_order_placed':model.placed || false
      };

      var query = common.sbx.insert('cart_box', cart_box);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addObject(cart_box).compile();*/

      common.method.query(common.urls.row, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.updateBox = function (cartbox, onSuccess, onError) {
      var query = common.sbx.insert('cart_box', cartbox);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addObject(cartbox).compile();*/

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.deletePurchaseOrder = function (purchase, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          purchase: purchase
        };
        florist.getCartBoxByPurchase(box.purchase._KEY, function (data) {
          box.cartboxes = data.results;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (!box.cartboxes.length) {
          return cb(null, box);
        }
        async.eachSeries(box.cartboxes, function (item, cbEach) {
          florist.deleteBox(item, function () {
            cbEach(null);
          }, cbEach);
        }, function (err) {
          if (err) {
            alertify.error(err);
            console.log(err);
          }
          cb(null, box);
        });
      }, function (box, cb) {
        console.log('deleting purchase');
        florist.deletePurchase(box.purchase._KEY, function () {
          box.purchase_deleted = true;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        var desc = 'The user ' + common.getUserData().data.name + ' with the ID ' + common.getUserData().data.id;
        desc += ' delete delete purchase with consecutive ' + box.purchase.consecutive;

        var auditObj = {
          action: 'DELETED',
          user: common.getUserData().key,
          date: new Date(),
          description: desc,
          object_string: JSON.stringify(box.purchase)
        };
        console.log('creating audit');
        florist.createAudit(auditObj, function () {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        // Mail Notification
        // let items = [];

        // for (let i = 0; i < box.items.length; i++) {
        //   items.push({
        //     product_group: box.items[i].product_group.common_name,
        //     variety: box.items[i].variety.variety_name,
        //     quantity: box.items[i].quantity
        //   });
        // }

        // let customer_mail = {
        //   "subject": "PO #" + box.cartbox.purchase.consecutive + " has been deleted via iBuyFlowers.com",
        //   "to": box.cartbox.customer.office_email,
        //   "domain": common.actual_domain,
        //   "from": "info@ibuyflowers.com",
        //   "template_key": common.template_email_delete_notif,
        //   "data": {
        //     "name": box.cartbox.customer.company_name,
        //     "items": items,
        //     "order_type": "Product Order",
        //     "consecutive": box.cartbox.purchase.consecutive,
        //     "quantity": box.cartbox.total_items
        //   }
        // };

        // common.method.send_mail(customer_mail).then(function (res) {
        //   if (res.success) {
        //     console.log('Customer email for delete notification has been sent !!!')
        //   }
        // });

        // let grower_mail = {
        //   "subject": "Order #" + box.cartbox.consecutive + " has been deleted via iBuyFlowers.com",
        //   "to": box.cartbox.grower.email_address,
        //   "domain": common.actual_domain,
        //   "from": "info@ibuyflowers.com",
        //   "template_key": common.template_email_delete_notif,
        //   "data": {
        //     "name": box.cartbox.grower.company_name,
        //     "order_type": "Order",
        //     "items": items,
        //     "consecutive": box.cartbox.consecutive,
        //     "quantity": box.cartbox.total_items
        //   }
        // };


        // common.method.send_mail(grower_mail).then(function (res) {
        //   if (res.success) {
        //     console.log('Grower email for delete notification has been sent !!!')
        //   }
        // });


        console.log('sending notification');
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess();
      });
    };

    florist.deletePurchase = function (purchase_key, onSuccess, onError) {
      var query = common.sbx.with('purchase').whereWithKeys([purchase_key]).compile();
      /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('purchase')
        .whereWithKeys([purchase_key]).compile();*/

      common.method.query(common.urls.delete, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.deleteBoxPurchase = function (cartbox, onSuccess, onError) {
      var country_managers = {};
      async.waterfall([function (cb) {
        var query = common.sbx.with('manager_countries').andWhereIsEqual("copy_email", true).orWhereIsEqual("main_email", true).fetchModels(["user"]).compile();

        common.loadAllPages(query, function (res) {
          res.results.forEach(function (manager) {
            if (res.fetched_results.user[manager.user]) {
              manager.email = res.fetched_results.user[manager.user].user_email;
              if (!modal.country_managers[manager.country]) {
                country_managers[manager.country] = {
                  from: "",
                  cc: [],
                  sign: manager.sign
                };
              }

              if (manager.email && manager.main_email) {
                country_managers[manager.country].from = manager.email;
              }

              if (manager.copy_email && manager.email) {
                country_managers[manager.country].cc.push(manager.email);
              }
            }
          });

          cb(null);
        }, cb);
      }, function (cb) {
        var box = {
          cartbox: cartbox,
          purchase: cartbox.purchase,
          total_bunches: 0,
          total_prices: 0
        };

        if ('items' in box.cartbox) {
          box.items = angular.copy(box.cartbox.items);
          cb(null, box);
        } else {
          florist.getCartBoxItems(box.cartbox._KEY, function (res) {
            box.items = res.results;
            cb(null, box);
          }, function (err) {
            cb(null, box);
          });
        }
      }, function (box, cb) {

        delete box.cartbox.items;
        console.log('deleting cartbox');
        florist.deleteBox(box.cartbox, function () {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        console.log('verify purchase');
        florist.getCartBoxByPurchase(box.purchase._KEY, function (data) {
          box.orders = data.results;
          angular.forEach(data.results, function (item, value) {
            box.total_bunches = box.total_bunches + parseInt(item.current_items);
            box.total_prices = box.total_prices + parseFloat(item.price);
          });
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (!box.orders.length) {
          return cb(null, box);
        }
        var purchaseObj = {
          '_KEY': box.purchase._KEY,
          'boxes': box.orders.length,
          'subtotal': box.total_prices,
          'total': box.total_prices
        };
        console.log('updating purchase');
        florist.updatePurchase(purchaseObj, function () {
          box.purchase_deleted = false;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (box.orders.length) {
          return cb(null, box);
        }
        console.log('deleting purchase');
        florist.deletePurchase(box.purchase._KEY, function () {
          box.purchase_deleted = true;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        var desc = 'The user ' + common.getUserData().data.name + ' with the ID ' + common.getUserData().data.id;
        desc += ' delete order with consecutive ' + box.cartbox.consecutive;
        if (box.purchase_deleted) {
          desc += ' and delete purchase with consecutive ' + box.purchase.consecutive;
        }

        var auditObj = {
          action: 'DELETED',
          user: common.getUserData().key,
          date: new Date(),
          description: desc,
          object_string: JSON.stringify(box.cartbox)
        };
        console.log('creating audit');
        florist.createAudit(auditObj, function () {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        // Mail Notification


        var items = [];

        for (var i = 0; i < box.items.length; i++) {
          items.push({
            product_group: box.items[i].product_group.common_name,
            variety: box.items[i].variety.variety_name,
            color: box.items[i].variety.color.color_name,
            quantity: box.items[i].quantity,
            uom: box.items[i].uom.uom,
            stems_per_bunch: box.items[i].stems_per_bunch.stems_per_bunch,
            length: box.items[i].masterlist.length,
            grower: box.items[i].grower.company_name,
            urlImage: box.items[i].picture,
            custom: box.items[i].cart_box.custom,
            percentage: box.items[i].percentage ? box.items[i].percentage : 0,
            grower_city: box.items[i].grower.city
          });
        }

        var customer_mail = {
          'subject': '',
          'to': box.cartbox.customer.office_email,
          'domain': common.actual_domain,
          'from': box.cartbox.customer.acc_manager ? box.cartbox.customer.acc_manager : 'info@ibuyflowers.com',
          'bcc': 'bcc@ibuyflowers.com,Supportteam@ibuyflowers.com',
          'template_key': common.template_email_delete_notif,
          'data': {
            'name': box.cartbox.customer.company_name,
            'items': items,
            'order_type': 'Product Order',
            'consecutive': box.cartbox.purchase.consecutive,
            'quantity': box.cartbox.current_items,
            'customer': true
          }
        };

        if (box.purchase_deleted) {
          customer_mail.subject = 'PO #' + box.cartbox.purchase.consecutive + ' has been deleted via iBuyFlowers.com';
          customer_mail.data.consecutive = box.cartbox.purchase.consecutive;
          customer_mail.data.order_type = 'Product Order';
        } else {
          customer_mail.subject = 'Order #' + box.cartbox.consecutive + ' has been deleted from de PO #' + box.cartbox.purchase.consecutive + ' via iBuyFlowers.com';
          customer_mail.data.consecutive = box.cartbox.consecutive;
          customer_mail.data.order_type = 'Order';
        }

        common.method.send_mail(customer_mail).then(function (res) {
          if (res.success) {
            console.log('Customer email for delete notification has been sent !!!');
          }
        });

        var from = 'farmmanager@ibuyflowers.com';
        var grower_country = box.cartbox.grower.country;
        var bcc = ['bcc@ibuyflowers.com'];

        if (country_managers[grower_country]) {
          if (country_managers[grower_country].cc.length > 0) {
            country_managers[grower_country].cc.forEach(function (cc) {
              bcc.push(cc);
            });
          }

          if (country_managers[grower_country].from) {
            from = country_managers[grower_country].from;
          }
        }

        console.log("frower country");
        console.log(grower_country);

        console.log("BCC");
        console.log(bcc);

        console.log("FROM");
        console.log(from);

        var grower_mail = {
          'subject': 'Order #' + box.cartbox.consecutive + ' has been deleted via iBuyFlowers.com',
          'to': box.cartbox.grower.email_address,
          'domain': common.actual_domain,
          "bcc": bcc.join(", "),
          'from': from ? from : 'info@ibuyflowers.com',
          'template_key': common.template_email_delete_notif,
          'data': {
            'name': box.cartbox.grower.company_name,
            'order_type': 'Order',
            'items': items,
            'consecutive': box.cartbox.consecutive,
            'quantity': box.cartbox.current_items,
            'customer': false
          }
        };

        common.method.send_mail(grower_mail).then(function (res) {
          if (res.success) {
            console.log('Grower email for delete notification has been sent !!!');
          }
        });

        console.log('sending notification');
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box);
      });
    };

    florist.deleteBox = function (cartbox, onSuccess, onError) {

      florist.getCartBoxItems(cartbox._KEY, function (items) {

        // Borrar los items, borrar la caja, actualizar inventario
        async.eachSeries(items.results, function (item, cbEach) {

          florist.deleteBoxItem(item, function () {
            cbEach(null);
          }, function (err) {
            cbEach(err);
          });
        }, function (errEach) {

          if (errEach) {
            return onError(errEach);
          }

          florist.deleteCartbox(cartbox._KEY, onSuccess, onError);
        });
      }, onError);
    };

    florist.deleteCartbox = function (cartbox_key, onSuccess, onError) {
      var query = common.sbx.with('cart_box').whereWithKeys([cartbox_key]).compile();
      /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .whereWithKeys([cartbox_key]).compile();*/

      common.method.query(common.urls.delete, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.addBoxItem = function (cart_box_item, onSuccess, onError) {
      var query = common.sbx.insert('cart_box_item', cart_box_item);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box_item')
        .addObject(cart_box_item).compile();*/

      common.method.query(common.urls.row, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.updateBoxItem = function (cart_box_item, onSuccess, onError) {
      var query = common.sbx.insert('cart_box_item', cart_box_item);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box_item')
        .addObject(cart_box_item).compile();*/

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.deleteCartboxItem = function (cartboxItem, onSuccess, onError) {
      var current_box = florist.getCurrentBox();

      async.waterfall([function (cb) {
        var box = {
          cartbox_item: cartboxItem,
          inv: cartboxItem.inventory,
          quant: -cartboxItem.quantity,
          percentage: -(cartboxItem.percentage * cartboxItem.quantity),
          cartbox_key: cartboxItem.cart_box._KEY
        };
        cb(null, box);
      }, function (box, cb) {
        florist.getCartBox(box.cartbox_key, function (cartbox) {
          box.cartbox = cartbox;
          cb(null, box);
        }, cb);
      }, function (box, cb) {

        var cartbox = {
          '_KEY': box.cartbox._KEY,
          'current_items': box.cartbox.current_items + box.quant,
          'current_percentage': box.cartbox.current_percentage + box.percentage
        };
        florist.updateBox(cartbox, function (data) {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        florist.deleteBoxItem(box.cartbox_item, function (data) {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        florist.getCurrentBoxItems(function (data) {
          box.cartboxitems = data.results;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (box.cartboxitems.length > 0) {
          return cb(null, box);
        }

        florist.deleteCartbox(box.cartbox_key, function () {
          florist.clearCurrentBox();
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (box.isBoxNew) {
          return cb(null, box);
        }
        current_box.model.current_items = current_box.model.current_items + box.quant;
        current_box.model.current_percentage = current_box.model.current_percentage + box.percentage;
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(null);
      });
    };

    florist.deleteBoxItem = function (cartboxItem, onSuccess, onError) {

      async.waterfall([function (cb) {
        var query = common.sbx.with('cart_box_item').whereWithKeys([cartboxItem._KEY]).compile();
        /*var query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('cart_box_item')
          .whereWithKeys([cartboxItem._KEY]).compile();*/

        common.method.query(common.urls.delete, query).then(function () {

          var res = common.response.post_query.data;
          if (res.success) {
            cb(null);
          } else {
            cb(new Error(res.error));
          }
        });
      }, function (cb) {
        // update the invetory the item
        florist.updateInventory(cartboxItem.inventory._KEY, -cartboxItem.quantity, function (tmp) {
          return cb(null);
        }, cb);
      }], function (err) {

        if (err) {
          return onError(err);
        }

        onSuccess(null);
      });
    };

    florist.deleteAllBoxItem = function (cartbox, onSuccess, onError) {
      var query = common.sbx.with('cart_box_item').andWhereIsEqual('cart_box', cartbox._KEY).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box_item')
        .addCondition('AND', 'cart_box', '=', cartbox._KEY).compile();*/
    };

    florist.updateInventory = function (inventory_key, quantity, onSuccess, onError) {
      // console.log(inventory_key, quantity);
      async.waterfall([

      // load the invetory with the masterlist
      function (cb) {

        var query = florist.getBaseQueryInventory(1, 1).whereWithKeys([inventory_key]);

        florist.findAndFecthInventory(query.compile(), function (res) {
          cb(null, res.results[0]);
        }, cb);
      }, function (inventory, cb) {

        var inv = {
          '_KEY': inventory._KEY,
          'quantity': inventory.quantity - quantity
        };
        if (inventory.masterlist.UoM.uom == 'stem') {
          var res = parseInt(quantity) * parseInt(inventory.masterlist.stems_per_bunch.stems_per_bunch);
          inv.quantity = inventory.quantity - res;
        }
        var query = common.sbx.insert('inventory', inv);

        /*var query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('inventory')
          .addObject(inv)
          .compile();*/

        common.method.query(common.urls.update, query).then(function () {
          var res = common.response.post_query.data;
          if (res.success) {
            cb(null);
          } else {
            cb(new Error(res.error));
          }
        });
      }], function (err) {

        if (err) {
          return onError(err);
        }

        onSuccess();
      });
    };

    florist.calculateSubtotalBoxPrice = function (cartboxItems) {
      var subtotal = 0;
      for (var i = 0; i < cartboxItems.length; i++) {
        var cartbox_item = cartboxItems[i];
        subtotal += parseFloat(cartbox_item.price) * parseInt(cartbox_item.quantity);
      }

      return subtotal;
    };

    florist.calculateExtraFreightCostBoxPrice = function (current_percentage) {
      var extra_freight_cost = 0;
      var per = (100 - current_percentage) / 100;
      extra_freight_cost = 6.4 * (5 * per);
      return extra_freight_cost;
    };

    florist.calculateBoxPrice = function (cartbox, onSuccess, onError) {
      var subtotal = florist.calculateSubtotalBoxPrice(cartbox.items);
      var extra_freight_cost = florist.calculateExtraFreightCostBoxPrice(cartbox.model.current_percentage);
      var total = subtotal + extra_freight_cost;

      var cart_box = {
        '_KEY': cartbox.model._KEY,
        'price': total,
        'subtotal': subtotal,
        'closed': true,
        'extra_freight_cost': extra_freight_cost
      };
      var query = common.sbx.insert('cart_box', cart_box);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addObject(cart_box).compile();*/

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.checkoutPurchase = function (shoppingcart, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          purchaseObj: {
            'customer_date': new Date(),
            'customer_user': common.getUserData().key,
            'street': shoppingcart.info.street,
            'state': shoppingcart.info.state._KEY,
            'zipcode': shoppingcart.info.zipcode,
            'city': shoppingcart.info.city,
            'country': shoppingcart.info.country._KEY,
            'boxes': shoppingcart.list.length,
            'subtotal': shoppingcart.subtotal,
            'total': shoppingcart.total,
            'customer_payment_option': shoppingcart.card._KEY,
            'payment_status': 'PENDING',
            'margin': common.getUserData().customer_margin

          },
          cartboxes: shoppingcart.list
        };

        cb(null, box);
      }, function (box, cb) {
        // CREATE PURCHASE
        console.log('createPurchase');
        florist.createPurchase(box.purchaseObj, function (data) {
          box.purchaseObj._KEY = data.keys[0];
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        // LOAD CARTBOX STATUS
        console.log('loadCartBoxStatus');
        florist.loadCartBoxStatus(function (data) {
          for (var i = 0; i < data.results.length; i++) {
            if (data.results[i].code == 1) {
              box.status = data.results[i];
              break;
            }
          }
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        //UPDATE CARTBOX
        console.log('updateBox');
        async.eachSeries(box.cartboxes, function (item, cbEach) {
          var cartbox = {
            '_KEY': item._KEY,
            'purchase': box.purchaseObj._KEY,
            'status': box.status._KEY,
            'is_gift': item.is_gift,
            'off': item.off
          };

          florist.updateBox(cartbox, function (data) {
            if (item.is_gift) {
              var temp = angular.copy(item);
              temp.purchase = box.purchaseObj._KEY;
              temp.status = box.status._KEY;
              temp.is_gift = item.is_gift;
              var auditObj = {
                action: 'GIFT',
                user: common.userData.key,
                date: new Date(),
                description: 'gift to customer from admin/grower',
                object_string: JSON.stringify(temp)
              };
              console.log('creating audit');
              florist.createAudit(auditObj, function () {
                cbEach(null);
              }, cbEach);
            } else {
              cbEach(null, box);
            }
          }, cbEach);
        }, function (errEach) {

          if (errEach) {
            return cb(errEach);
          }
          var user = common.getUserData();
          if (user.is_gift) {
            user.is_gift = false;
            common.setUserData(user);
          }

          cb(null, box);
        });
      }, function (box, cb) {
        // GET PURCHASE INFO
        florist.getPurchaseOrder(box.purchaseObj._KEY, function (data) {

          console.log('purchase info', data.results[0]);
          box.purchase_info = data.results[0];

          box.mail_head_info = {
            purchase: {
              consecutive: box.purchase_info.consecutive,
              boxes: box.purchase_info.boxes,
              total: box.purchase_info.total,
              customer: box.purchase_info.customer_user.first_name + ' ' + box.purchase_info.customer_user.last_name,
              mail: box.purchase_info.customer_user.user_email
            },
            shipping_address: {
              company_name: box.purchase_info.customer_user.customer.company_name,
              company_phone: box.purchase_info.customer_user.customer.office_phone,
              street: box.purchase_info.street,
              city: box.purchase_info.city,
              state: box.purchase_info.state.state_iso,
              country: box.purchase_info.country.country + ' (' + box.purchase_info.country.country_iso + ')',
              zipcode: box.purchase_info.zipcode || 'Zip Code not provided'
            }
          };

          cb(null, box);
        }, cb);
      }, function (box, cb) {
        // GET CARTBOXES INFO FOR PURCHASE
        florist.getOrdersByRole(box.purchaseObj._KEY, function (res_data) {
          var total_bunches = 0,
              total_boxes = 0,
              total_prices = 0,
              total_extra_freight_cost = 0;
          box.customer_summary = {};
          box.growers_involved = {};

          angular.forEach(res_data, function (item) {

            for (var i = 0; i < item.cartboxes.length; i++) {
              total_bunches = total_bunches + parseInt(item.cartboxes[i].current_items);
              total_extra_freight_cost = total_extra_freight_cost + parseInt(item.cartboxes[i].extra_freight_cost);

              for (var j = 0; j < item.cartboxes[i].items.length; j++) {
                var aux = item.cartboxes[i].items[j];

                if (!box.customer_summary[aux.grower.company_name]) {
                  box.customer_summary[aux.grower.company_name] = [];
                }
                box.growers_involved[aux.grower._KEY] = aux.grower;

                box.customer_summary[aux.grower.company_name].push({
                  custom: aux.cart_box.custom,
                  percentage: aux.percentage ? aux.percentage : 0,
                  arrival_date: item.cartboxes[i].eta_date,
                  grower: aux.grower.company_name,
                  grower_name: aux.grower.name,
                  grower_key: aux.grower._KEY,
                  grower_city: aux.grower.city,
                  grower_email: aux.grower.email_address,
                  grower_code: aux.masterlist.grower_code,
                  is_csv: aux.grower.is_csv,
                  product_group: aux.product_group.common_name,
                  variety: aux.variety.variety_name,
                  color: aux.variety.color.color_name,
                  grade: item.cartboxes[i].grade ? item.cartboxes[i].grade.grade : null,
                  length: aux.masterlist.length || aux.cart_box.box.fixed_length,
                  stems_per_bunch: aux.stems_per_bunch.stems_per_bunch,
                  total_bunches: aux.quantity,
                  price: aux.price,
                  inventory_price: aux.base_price,
                  customer: aux.cart_box.customer.company_name,
                  customer_city: aux.cart_box.customer.city,
                  uom: aux.uom.uom,
                  order: aux.cart_box.consecutive,
                  box: aux.cart_box.box.box_name + '-' + aux.cart_box.box.box_length + 'x' + aux.cart_box.box.box_heigth + 'x' + aux.cart_box.box.box_width,
                  packing_date: item.cartboxes[i].packing_date,
                  is_gift: aux.cart_box.is_gift,
                  off: aux.cart_box.off,
                  urlImage: aux.picture
                });
              }
            }

            //box.customer_summary = angular.copy(temp);

            total_boxes = total_boxes + item.cartboxes.length;
            total_prices = total_prices + parseFloat(item.total);
            //order #boxes product_group variety grade length(fixedlength) stems per bunch total bunches proce uom total
          });

          box.total_boxes = total_boxes;
          box.total_bunches = total_bunches;
          box.total_extra_freight_cost = total_extra_freight_cost;
          box.orders = res_data;
          // console.log('Box orders', box.orders);
          // console.log('total bunches', box.total_bunches);
          // console.log('total boxes', box.total_boxes);

          box.mail_head_info.purchase.arrival_date = box.orders[0].arrival_date;
          box.mail_head_info.order_totals = {
            total_bunches: total_bunches,
            total_boxes: total_boxes,
            total_price: total_prices,
            total_extra_freight_cost: total_extra_freight_cost
          };
          box.grower_orders = {};

          //order #boxes product_group variety grade length(fixedlength) stems per bunch total bunches proce uom total
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        // SEND ORDERS EMAIL
        /**
         * comentariado temporal mente por peticion de wilfred FLOWER-623
         */
        florist.sendOrdersMail(box.mail_head_info, box.customer_summary);
        cb(null, box);
      }, function (box, cb) {
        //look for grower customer relation

        var user = common.getUserData().customer;
        common.loadGrowerCustomerRelation(function (data) {
          angular.forEach(box.growers_involved, function (grower) {

            var count = 0;
            for (var i = 0; i < data.results.length; i++) {
              if (user == data.results[i].customer && data.results[i].grower == grower._KEY) {
                count = count + 1;
              }
            }
            if (count == 0) {
              var newr = {
                'customer': user,
                'grower': grower._KEY,
                'customer_perm': true,
                'grower_perm': true,
                'rating': 0
              };
              florist.createRelation(newr, function () {}, function (error) {
                cb(error);
              });
            }
          });
          cb(null, box);
        }, function (e) {
          cb(e, box);
        });
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box.purchaseObj._KEY);
      });
    };

    florist.sendOrdersMail = function (head_info, orders) {

      async.waterfall([function (cb) {
        var box = {};
        florist.getUserList('customer', function (res) {
          box.customer_users = res.results.filter(function (user) {
            if (user.purchase_orders) {
              return user;
            }
          });
          box.customer_users = box.customer_users.map(function (user) {
            return user.user;
          });
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        async.parallel([
        /**
         * Send Emails Customer and user of customer
         */
        function (cb) {
          var customer_date = new Date(head_info.purchase.arrival_date).toLocaleDateString();

          var customer_dates = '',
              cd_array = [];
          var cc_mails = box.customer_users.map(function (user) {
            return user.user_email;
          }).join(', ');

          angular.forEach(orders, function (item) {
            for (var i = 0; i < item.length; i++) {
              if (cd_array.indexOf(item[i].arrival_date.toISOString()) == -1) {
                cd_array.push(item[i].arrival_date.toISOString());
                customer_dates = $filter('date')(item[i].arrival_date, 'MM/dd/yyyy') + ',' + customer_dates;
              }
            }
          });

          customer_dates = customer_dates.substr(0, customer_dates.length - 1, customer_dates.length);
          var bcc_emails = null;
          if (common.getUserData().account_manager) {
            bcc_emails = common.getUserData().account_manager;
          }

          head_info.arrival_dates = customer_dates.split(',').join(', ');

          var customer_mail = {
            'subject': 'PO #' + head_info.purchase.consecutive + ' is placed for arrival on: ' + customer_dates + ' via iBuyFlowers.com',
            'to': head_info.purchase.mail,
            'cc': cc_mails,
            'domain': common.actual_domain,
            'from': 'info@ibuyflowers.com',
            'template_key': common.template_email_customer_purchase,
            'data': {
              'head': head_info,
              'orders': orders
            }
          };
          if (bcc_emails) {
            customer_mail.bcc = bcc_emails;
          }
          console.log('customer_mail:', customer_mail);
          common.method.send_mail(customer_mail).then(function (res) {
            if (res.success) {
              console.log('Customer email sent !!!');
              cb(null);
            }
          });
        },
        /**
         * Send Emails all users for each Grower
         */
        function (cb) {
          console.log(orders);
          var orderByNumber = {};
          angular.forEach(orders, function (item) {
            for (var i = 0; i < item.length; i++) {
              if (!orderByNumber[item[i].order]) {
                orderByNumber[item[i].order] = [item[i]];
              } else {
                orderByNumber[item[i].order].push(item[i]);
              }
            }
          });

          async.eachOfLimit(orderByNumber, 2, function (item, key, callNext) {
            var mail_info = {},
                mailto = '',
                name = '',
                order_number = null,
                grower_key = null,
                packing = null,
                box_type = '',
                total_box = 0;

            for (var i = 0; i < item.length; i++) {
              if (!order_number) {
                mailto = item[i].grower_email;
                name = item[i].grower_name || item[i].grower;
                grower_key = item[i].grower_key;
                order_number = item[i].order;
                packing = item[i].packing_date;
                box_type = item[i].box;
              }

              if (!mail_info[key]) {
                mail_info[key] = [item[i]];
              } else {
                mail_info[key].push(item[i]);
              }
              var price = parseFloat(item[i].inventory_price);

              if (item[i].uom == 'stem') {
                price = parseFloat(item[i].inventory_price) * parseFloat(item[i].stems_per_bunch);
              }

              item[i].inventory_price = common.roundTo(item[i].inventory_price, 2);
              total_box = total_box + price * parseFloat(item[i].total_bunches);
            }

            gs.loadUsers(grower_key, { orders: true }, function (users) {

              var cc = [];
              for (var _i2 = 0; _i2 < users.length; _i2++) {
                cc.push(users[_i2].user_email);
              }

              var grower_mail = {};

              try {
                grower_mail = {
                  'subject': 'Order #' + order_number + ' is placed for packing ' + $filter('date')(packing, 'MM/dd/yyyy') + ' via iBuyFlowers.com',
                  'to': mailto,
                  'cc': cc,
                  'domain': common.actual_domain,
                  'from': 'info@ibuyflowers.com',
                  'template_key': common.template_email_grower_purchase,
                  'data': {
                    'grower': name,
                    'head': head_info,
                    'orders': mail_info,
                    'order_number': order_number,
                    'packing_date': $filter('date')(packing, 'MM/dd/yyyy'),
                    'box_type': box_type,
                    'total_box': common.roundTo(total_box, 2)
                  }
                };
                /*
                Edit:carlos@socobox.co
                We look  if the grower have the flag of the csv then we iterate over the mail_info to make the csv
                and attach the csv in to the email
                */
                if (mail_info[order_number][0].is_csv) {
                  var today = new Date();
                  //TODO:Make a csv file that contain the same info like the mail
                  var csv = $filter('date')(packing, 'ddMMyyyy') + ',' + 'US3000' + ', #' + order_number + ',' + $filter('date')(today, 'ddMMyyyy') + '\r\n';
                  mail_info[order_number].forEach(function (order, index) {
                    var total = order.total_bunches * order.stems_per_bunch;
                    var grade = order.grade || '';
                    csv = csv + (total + ',' + order.grower_code + ',' + order.product_group + ' ' + order.variety + ' ' + grade + ',' + order.inventory_price + '\r\n');
                  });
                  grower_mail.attachment = {
                    'filename': 'orders.csv',
                    'contentType': 'text/csv',
                    'content': csv
                  };
                }
              } catch (e) {
                console.error(e);
              }
              if (common.isProd) {
                grower_mail.bcc = 'carloscoral@ibuyflowers.com';
              }
              console.log('grower mail', grower_mail);
              common.method.send_mail(grower_mail).then(function (res) {
                if (res.success) {
                  callNext(null);
                  console.log('Grower email sent !!!');
                }
              });
            }, function (error) {
              alertify.error(error);
              callNext(null);
            });
          }, function (err) {
            if (err) {
              return cb(err);
            }

            cb(null);
          });
        }], function (err) {});
      }], function (err, results) {
        if (err) {
          return console.log('email not finish');
        }

        console.log(results);

        console.log('ALL EMAIL SENDED');
      });
    };
    /**
     * this function use the following params
     * @param auditObj Object Audict like this example: { action: 'ACTION', user: 'xxxx-xxxx-xxxx-xxxx', date: new Date(), description: 'lorem ipsum', object_string: JSON.stringify({}) }
     * @param onSuccess The success function that will return the array of users
     * @param onError The error callback with the Error object as a parameter.
     */
    florist.createAudit = common.createAudit;

    florist.createPurchase = function (purchaseObj, onSuccess, onError) {
      var query = common.sbx.insert('purchase', purchaseObj);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('purchase')
        .addObject(purchaseObj).compile();*/

      common.method.query(common.urls.row, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.updatePurchase = function (purchaseObj, onSuccess, onError) {
      var query = common.sbx.insert('purchase', purchaseObj);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('purchase')
        .addObject(purchaseObj).compile();*/

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.loadPurchaseOrdersByCustomer = function (onSuccess, onError) {
      var query = florist.getBaseQueryPurchase();

      query.andWhereIsEqual('customer_user.customer', common.getUserData().customer);
      //query.addCondition('AND', 'customer_user.customer', '=', common.getUserData().customer);

      florist.loadPurchaseOrders(query.compile(), onSuccess, onError);
    };

    florist.getGrowerAndPackingPerMonth = function (conditions, onSuccess) {
      var query = florist.getBaseQueryCartboxItem();
      query.andWhereIsNotNull('cart_box.purchase').andWhereIsEqual('cart_box.grower', conditions.grower).andWhereGreaterOrEqualThan('cart_box.packing_date', conditions.start_date).andWhereLessOrEqualThan('cart_box.packing_date', conditions.end_date);

      common.loadAllPages(query.compile(), function (response) {
        florist.fetchCartboxItem(response, function () {
          var map = {};
          response.results.forEach(function (item) {
            var key = common.convertDateToNumberDate(item.cart_box.packing_date);
            if (!map[key]) {
              map[key] = { total: 0, cartboxItems: [], date: item.cart_box.packing_date };
            }
            map[key].cartboxItems.push(item);
          });
        });
      });
    };

    florist.listOrdersByPackingDateAndGrower = function (conditions, onSuccess) {
      var query = florist.getBaseQueryCartboxItem();
      query.andWhereIsNotNull('cart_box.purchase').andWhereIsEqual('cart_box.grower', conditions.grower).andWhereGreaterOrEqualThan('cart_box.packing_date', conditions.start_date).andWhereLessOrEqualThan('cart_box.packing_date', conditions.end_date);

      common.loadAllPages(query.compile(), function (response) {
        florist.fetchCartboxItem(response, function () {
          var map = {};
          response.results.forEach(function (item) {
            var key = common.convertDateToNumberDate(item.cart_box.packing_date);
            var aux = {
              total: 0,
              totalClient: 0,
              cartboxItems: [],
              date: item.cart_box.packing_date,
              consecutive: item.cart_box.consecutive,
              po: item.cart_box.purchase.consecutive
            };
            if (!map[key]) {
              map[key] = {};
            }
            if (!map[key][item.cart_box._KEY]) {
              map[key][item.cart_box._KEY] = aux;
            }
            map[key][item.cart_box._KEY].cartboxItems.push(item);
          });

          var total = 0;
          var clientTotal = 0;

          Object.keys(map).forEach(function (key) {

            Object.keys(map[key]).forEach(function (key2) {

              var items = map[key][key2].cartboxItems;

              for (var j = 0; j < items.length; j++) {
                var aux = items[j];
                aux.inventory = angular.copy(aux.inventory);

                var price = aux.base_price;

                if (aux.uom.uom == 'stem') {
                  price = parseFloat(aux.base_price) * parseInt(aux.stems_per_bunch.stems_per_bunch);
                }

                if (aux.grower_discount) {
                  price = price * (1 - aux.off / 100);
                }

                aux.total_price = price * aux.quantity;
                aux.cart_box.subtotal = aux.cart_box.subtotal * (1 - aux.cart_box.off / 100);
                map[key][key2].totalClient += aux.cart_box.subtotal;
                map[key][key2].total = map[key][key2].total + parseFloat(aux.total_price);
              }

              clientTotal += map[key][key2].totalClient;
              total = total + parseFloat(map[key][key2].total);
            });
          });

          onSuccess({ map: map, total: total, clientTotal: clientTotal });
        });
      });
    };

    florist.listOrdersByRole = function (conditions, onSuccess, onError) {

      if (!common.getUserData()) {
        return onError();
      }
      async.waterfall([function (cb) {

        var model = common.getUserData().ibf_role === 'FLORIST' ? 'customer' : 'grower';

        var data = {
          key: common.getUserData()[model],
          user: common.getUserData(),
          model: model,
          cartboxMap: {},
          cartboxes: [],
          orderMap: {},
          orders: []
        };

        //   console.log('loading cart_box status');
        //   florist.loadCartBoxStatus(function (res) {
        //     data.cart_box_status = res.results;
        //     for (var i = 0; i < res.results.length; i++) {
        //       if (res.results[i].code == 1) {
        //         data.status_pending = res.results[i];
        //         break;
        //       }
        //     }
        //     cb(null, data);
        //   }, cb);

        // }, function (data, cb) {
        //   console.log('loading cart_box items');
        var query = florist.getBaseQueryCartboxItem();

        query.andWhereIsNotNull('cart_box.purchase').andWhereIsEqual('cart_box.' + data.model, data.key);
        /*query.addCondition('AND', 'cart_box.purchase', 'is not', null);
        query.addCondition('AND', 'cart_box.' + data.model, '=', data.key);*/
        if (conditions.packing) {
          query.andWhereIsEqual('cart_box.packing_date', conditions.packing);
          //query.addCondition('AND', 'cart_box.packing_date', '=', conditions.packing);
        }

        if (conditions.packingFrom) {
          query.andWhereGreaterOrEqualThan('cart_box.packing_date', conditions.packingFrom);
        }

        if (conditions.packingTo) {
          query.andWhereLessOrEqualThan('cart_box.packing_date', conditions.packingTo);
        }

        if (conditions.order) {
          query.andWhereIsEqual('cart_box.consecutive', conditions.order);
          //query.addCondition('AND', 'cart_box.consecutive', '=', conditions.order);
        }

        if (conditions.customer) {
          // query.andWhereReferenceJoinBetween('customer.company_name', 'customer')
          //   .in('cart_box').filterWhereIsLike(`%${conditions.customer}%`);
          query.query.setReferenceJoin('LIKE', 'customer.company_name', 'customer', 'cart_box', '%' + conditions.customer + '%');
          query.query.addCondition('AND', 'cart_box.customer', 'in', '@reference_join@');
        }

        if (conditions.standingOrder) {
          query.andWhereIsEqual('cart_box.is_standing_order', true);
        }
        if (conditions.selectedProductGroup) {
          query.andWhereIsEqual('cart_box.product_group', conditions.selectedProductGroup);
        }

        /* if(conditions.productGroupVariety){
           query.query.setReferenceJoin('LIKE', 'product_group.common_name', 'product_group', 'cart_box', `%${conditions.productGroupVariety}%`);
          query.query.addCondition('OR', 'cart_box.product_group', 'in', '@reference_join@')
          ///
          query.query.setReferenceJoin('LIKE', 'variety.variety_name', 'variety', 'cart_box', `%${conditions.productGroupVariety}%`);
          query.query.addCondition('OR', 'cart_box.variety', 'in', '@reference_join@')
          }*/
        if (conditions.productGroupVariety) {
          query.query.newGroup('AND');
          query.query.setReferenceJoin('LIKE', 'product_group.common_name', 'product_group', 'cart_box', '%' + conditions.productGroupVariety + '%');
          query.query.addCondition('AND', 'cart_box.product_group', 'in', '@reference_join@');
          ///
          /*query.query.setReferenceJoin('LIKE', 'variety.variety_name', 'variety', 'cart_box', `%${conditions.productGroupVariety}%`);
           query.query.addCondition('OR', 'cart_box.variety', 'in', '@reference_join@')*/

          /*query = query.compile();
           queryVariety= JSON.parse(JSON.stringify(query))
          queryVariety.reference_join.filter.FIELD="variety.variety_name";
          queryVariety.reference_join.filter.reference_field="variety";
          queryVariety.where[0].GROUP[queryVariety.where[0].GROUP.length-1].FIELD='variety'
          queryVariety.where[0].GROUP[queryVariety.where[0].GROUP.length-1].ANDOR="AND"
          //queryVariety= JSON.stringify(queryVariety)*/

          query.query.addCondition('OR', 'variety.variety_name', 'LIKE', '%' + conditions.productGroupVariety + '%');
        }

        query = query.compile();

        // console.log(query);

        common.loadAllPages(query, function (response) {
          data.cart_box_items = response;
          cb(null, data);
        }, cb);
      }, function (data, cb) {
        // console.log('fetching cart_box items');
        florist.fetchCartboxItem(data.cart_box_items, function () {
          cb(null, data);
        }, cb);
      }, function (data, cb) {
        // console.log('mapping cart_box items');
        angular.forEach(data.cart_box_items.results, function (item) {
          var _key = item.cart_box._KEY;
          if (data.cartboxMap[_key] == null) {
            data.cartboxMap[_key] = data.cartboxes.length;
            data.cartboxes.push({
              cart_box: angular.copy(item.cart_box),
              items: []
            });
          }

          var key_cart = data.cartboxMap[_key];
          data.cartboxes[key_cart].items.push(angular.copy(item));
        });
        cb(null, data);
      }, function (data, cb) {
        // console.log('mapping cart_box 3');
        angular.forEach(data.cartboxes, function (cart_box) {
          var item = cart_box.cart_box;
          var day = item.eta_date.toISOString();
          var attr = 'arrival_date';
          try {
            if (data.model === 'grower') {
              attr = 'packing_date';
              day = item.packing_date.toISOString();
            }
          } catch (e) {
            console.log(e);
          }
          if (data.orderMap[day] == null) {
            data.orderMap[day] = data.orders.length;
            var obj = {
              cartboxes: []
            };
            obj[attr] = day;

            data.orders.push(obj);
          }

          item.items = cart_box.items;

          item.items = item.items.map(function (boxItem) {

            var percentage_uom = 0;

            if (item.tag !== null) {

              if (boxItem.uom && boxItem.uom.uom) {

                if (boxItem.uom.uom === "bunch") {
                  percentage_uom = boxItem.percentage / 100;
                }

                if (boxItem.uom.uom === "stem") {
                  percentage_uom = boxItem.percentage / 100 / boxItem.stems_per_bunch.stems_per_bunch;
                }

                var box_charge = boxItem.box_charge === null || boxItem.box_charge === 0 ? boxItem.grower_box_charge : boxItem.box_charge;
                boxItem.base_price = boxItem.base_price + box_charge * percentage_uom;
              }
            }

            return boxItem;
          });

          data.orders[data.orderMap[day]].cartboxes.push(item);
        });
        cb(null, data);
      }, function (data, cb) {
        angular.forEach(data.orders, function (item) {
          var total = 0;
          if (data.model === 'grower') {
            for (var i = 0; i < item.cartboxes.length; i++) {
              var _cartbox = item.cartboxes[i];
              var total_aux = 0;
              for (var j = 0; j < item.cartboxes[i].items.length; j++) {
                var aux = item.cartboxes[i].items[j];
                aux.inventory = angular.copy(aux.inventory);

                var price = aux.base_price;

                if (aux.uom && aux.uom.uom === 'stem') {
                  price = parseFloat(aux.base_price) * parseInt(aux.stems_per_bunch.stems_per_bunch);
                }

                aux.total_price = price * aux.quantity;

                if (_cartbox.grower_discount) {
                  _cartbox.discount = aux.total_price * parseFloat(_cartbox.off);
                  aux.total_price *= 1 - parseFloat(_cartbox.off);
                }

                total_aux = total_aux + parseFloat(aux.total_price);
              }
              total = total + parseFloat(total_aux);
            }
          } else {
            for (var _i3 = 0; _i3 < item.cartboxes.length; _i3++) {
              var cartbox = item.cartboxes[_i3];
              total += parseFloat(cartbox.price) * (1 - parseFloat(cartbox.off));
            }
          }
          item.total = total;
        });
        cb(null, data);
      }, function (data, cb) {
        var zipcodesArray = [];

        data.cartboxes.forEach(function (item) {
          if (item.cart_box && item.cart_box.purchase && item.cart_box.purchase.zipcode) {
            zipcodesArray.push(item.cart_box.purchase.zipcode);
          }
        });
        zipcodesArray = [].concat(_toConsumableArray(new Set(zipcodesArray)));

        if (zipcodesArray.length === 0) {

          return cb(null, data);
        }

        // data.cartboxes.forEach(item => {
        //   if (item.cart_box && item.cart_box.purchase) {
        //     const zipcode = item.cart_box.purchase.zipcode;
        //     if (zipcode) {
        //       // item.cart_box.cold = true;
        //     } else {
        //       // item.cart_box.cold = true;
        //     }
        //   }
        // });
        // cb(null, data);
        common.method.run({
          key: environment.cloudscript.weather_forecast,
          params: {
            zipcodes: zipcodesArray,
            ignore_notification: true
          }
        }).then(function (response) {

          // data.cartboxes.forEach(item => {
          //   if (item.cart_box && item.cart_box.purchase) {
          //     const zipcode = item.cart_box.purchase.zipcode;
          //     if (zipcode && response.box[zipcode]) {
          //       item.cart_box.cold = true;
          //     } else {
          //       item.cart_box.cold = true;
          //     }
          //   }
          // });

          if (response.success && response.box && Object.keys(response.box).length > 0) {

            data.cartboxes.forEach(function (item) {
              if (item.cart_box && item.cart_box.purchase) {
                var zipcode = item.cart_box.purchase.zipcode;
                item.cart_box.cold = !!(zipcode && response.box[zipcode] < -5);
              }
            });

            cb(null, data);
          }
        }, function (error) {

          cb(null, data);
        });
      }], function (e, data) {
        if (e) {
          return onError(e);
        }
        // console.log(data);
        onSuccess(data.orders);
      });
    };

    florist.listOrdersForClaim = function (onSuccess, onError) {
      var today = common.convertDateToNumberDate(new Date()),
          yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday = common.convertDateToNumberDate(yesterday);

      async.waterfall([function (cb) {

        var model = common.getUserData().ibf_role == 'FLORIST' ? 'customer' : 'grower';

        var data = {
          key: common.getUserData()[model],
          user: common.getUserData(),
          model: model,
          cartboxMap: {},
          cartboxes: [],
          orderMap: {},
          orders: []
        };
        console.log('loading cart_box status');
        florist.loadCartBoxStatus(function (res) {
          data.cart_box_status = res.results;
          for (var i = 0; i < res.results.length; i++) {
            if (res.results[i].code == 1) {
              data.status_pending = res.results[i];
              break;
            }
          }
          cb(null, data);
        }, cb);
      }, function (data, cb) {
        console.log('loading cart_box items');
        var query = florist.getBaseQueryCartboxItem();
        query.andWhereIsNotNull('cart_box.purchase').andWhereIsEqual('cart_box.' + data.model, data.key).andWhereLessOrEqualThan('cart_box.eta_date', today).andWhereGreaterOrEqualThan('cart_box.eta_date', yesterday);
        /*query.addCondition('AND', 'cart_box.purchase', 'is not', null);
        query.addCondition('AND', 'cart_box.' + data.model, '=', data.key);
        query.addCondition('AND', 'cart_box.eta_date', '<=', today);
        query.addCondition('AND', 'cart_box.eta_date', '>=', yesterday);*/

        // if (data.model == 'grower') {
        //   query.addCondition("AND", "cart_box.status", "=", data.status_pending._KEY);
        // }

        query = query.compile();

        common.loadAllPages(query, function (response) {

          data.cart_box_items = response;
          cb(null, data);
        }, cb);
      }, function (data, cb) {
        console.log('fetching cart_box items');
        florist.fetchCartboxItem(data.cart_box_items, function () {
          cb(null, data);
        }, cb);
      }, function (data, cb) {
        console.log('mapping cart_box items');
        angular.forEach(data.cart_box_items.results, function (item) {
          var _key = item.cart_box._KEY;
          if (data.cartboxMap[_key] == null) {
            data.cartboxMap[_key] = data.cartboxes.length;
            data.cartboxes.push({
              cart_box: item.cart_box,
              items: []
            });
          }

          var key_cart = data.cartboxMap[_key];
          data.cartboxes[key_cart].items.push(item);
        });
        cb(null, data);
      }, function (data, cb) {
        console.log('mapping cart_box 2');
        angular.forEach(data.cartboxes, function (cart_box) {
          var item = cart_box.cart_box;
          var day = item.eta_date.toISOString();
          var attr = 'arrival_date';

          if (data.model == 'grower') {
            attr = 'packing_date';
            day = item.packing_date.toISOString();
          }

          if (data.orderMap[day] == null) {
            data.orderMap[day] = data.orders.length;
            var obj = {
              cartboxes: []
            };
            obj[attr] = day;

            data.orders.push(obj);
          }

          item.items = cart_box.items;

          data.orders[data.orderMap[day]].cartboxes.push(item);
        });
        cb(null, data);
      }, function (data, cb) {
        angular.forEach(data.orders, function (item) {
          var total = 0;
          if (data.model == 'grower') {
            for (var i = 0; i < item.cartboxes.length; i++) {
              var total_aux = 0;
              for (var j = 0; j < item.cartboxes[i].items.length; j++) {
                var aux = item.cartboxes[i].items[j];
                aux.inventory = angular.copy(aux.inventory);

                var price = aux.base_price;

                if (aux.uom.uom == 'stem') {
                  price = parseFloat(aux.base_price) * parseInt(aux.stems_per_bunch.stems_per_bunch);
                }

                price = price * (1 - aux.off / 100);

                aux.total_price = price * aux.quantity;

                total_aux = total_aux + parseFloat(aux.total_price);
              }
              total = total + parseFloat(total_aux);
            }
          } else {
            for (var _i4 = 0; _i4 < item.cartboxes.length; _i4++) {
              total = total + parseFloat(item.cartboxes[_i4].price);
            }
          }
          item.total = total;
        });
        cb(null, data);
      }], function (e, data) {
        if (e) {
          return onError(e);
        }
        console.log(data);
        onSuccess(data.orders);
      });
    };

    florist.getOrdersByRole = function (purchase_key, onSuccess, onError) {
      async.waterfall([function (cb) {

        var model = common.getUserData().ibf_role == 'FLORIST' ? 'customer' : 'grower';

        var data = {
          purchase_key: purchase_key,
          key: common.getUserData()[model],
          user: common.getUserData(),
          model: model,
          cartboxMap: {},
          cartboxes: [],
          orderMap: {},
          orders: []
        };

        cb(null, data);
      }, function (data, cb) {
        console.log('loading cart_box items');
        var query = florist.getBaseQueryCartboxItem();

        query.andWhereIsEqual('cart_box.purchase', data.purchase_key).andWhereIsEqual('cart_box.' + data.model, data.key);
        /*query.addCondition('AND', 'cart_box.purchase', '=', data.purchase_key);
        query.addCondition('AND', 'cart_box.' + data.model, '=', data.key);*/

        query = query.compile();
        common.loadAllPages(query, function (response) {
          data.cart_box_items = response;
          cb(null, data);
        }, cb);
      }, function (data, cb) {
        console.log('fetching cart_box items');
        florist.fetchCartboxItem(data.cart_box_items, function () {
          cb(null, data);
        }, cb);
      }, function (data, cb) {
        console.log('mapping cart_box items');
        angular.forEach(data.cart_box_items.results, function (item) {
          var _key = item.cart_box._KEY;
          if (data.cartboxMap[_key] == null) {
            data.cartboxMap[_key] = data.cartboxes.length;
            data.cartboxes.push({
              cart_box: angular.copy(item.cart_box),
              items: []
            });
          }

          var key_cart = data.cartboxMap[_key];
          data.cartboxes[key_cart].items.push(item);
        });
        cb(null, data);
      }, function (data, cb) {
        console.log('mapping cart_box 1');
        angular.forEach(data.cartboxes, function (cart_box) {
          var item = cart_box.cart_box;
          var day = item.eta_date.toISOString();
          var attr = 'arrival_date';

          if (data.model == 'grower') {
            attr = 'packing_date';
            day = item.packing_date.toISOString();
          }

          if (data.orderMap[day] == null) {
            data.orderMap[day] = data.orders.length;
            var obj = {
              cartboxes: []
            };
            obj[attr] = day;

            data.orders.push(obj);
          }

          item.items = cart_box.items;

          data.orders[data.orderMap[day]].cartboxes.push(item);
        });
        cb(null, data);
      }, function (data, cb) {
        angular.forEach(data.orders, function (item) {
          var total = 0;
          if (data.model === 'grower') {
            for (var i = 0; i < item.cartboxes.length; i++) {
              var cartbox = item.cartboxes[i];
              var total_aux = 0;
              for (var j = 0; j < item.cartboxes[i].items.length; j++) {
                var aux = item.cartboxes[i].items[j];
                aux.inventory = angular.copy(aux.inventory);

                var price = aux.base_price;

                if (aux.uom.uom === 'stem') {
                  price = parseFloat(aux.base_price) * parseInt(aux.stems_per_bunch.stems_per_bunch);
                }

                aux.total_price = price * aux.quantity;

                if (cartbox.grower_discount) {
                  cartbox.discount = aux.total_price * parseFloat(cartbox.off);
                  aux.total_price *= 1 - parseFloat(cartbox.off);
                }

                total_aux = total_aux + parseFloat(aux.total_price);
              }
              total = total + parseFloat(total_aux);
            }
          } else {
            for (var _i5 = 0; _i5 < item.cartboxes.length; _i5++) {
              var _cartbox2 = item.cartboxes[_i5];
              var _price = _cartbox2.price * (1 - _cartbox2.off);
              total = total + parseFloat(_price);
            }
          }
          item.total = total;
        });
        cb(null, data);
      }], function (e, data) {
        if (e) {
          return onError(e);
        }
        console.log(data);
        onSuccess(data.orders);
      });
    };

    florist.listOrdersForCustomer = function (onSuccess, onError) {

      async.waterfall([function (cb) {
        var data = {
          cart_boxes: {},
          purchaseMap: {},
          purchases: []
        };
        var query = florist.getBaseQueryCartBox();

        query.andWhereIsEqual('customer', common.getUserData().customer).andWhereIsNotNull('purchase');
        /*query.addCondition('AND', 'customer', '=', common.getUserData().customer);
        query.addCondition('AND', 'purchase', 'is not', null);
        query = query.compile();*/

        florist.getCartBoxes(query.compile(), function (response) {
          data.cart_boxes = response;
          cb(null, data);
        }, cb);
      }, function (data, cb) {
        angular.forEach(data.cart_boxes.results, function (item) {
          if (!data.purchaseMap[item.purchase._KEY]) {
            item.purchase.customer = item.customer;
            data.purchases.push(item.purchase);
            data.purchaseMap[item.purchase._KEY] = { purchase: item.purchase, items: [item] };
          } else {
            data.purchaseMap[item.purchase._KEY].items.push(item);
          }
        });
        cb(null, data);
      }], function (e, data) {
        if (e) {
          return onError(e);
        }
        onSuccess(data);
      });
    };

    florist.loadPurchaseOrders = function (query, onSuccess, onError) {

      common.loadAllPages(query, function (res) {
        if (res.results) {
          florist.fetchPurchaseOrders(res, onSuccess);
        } else {
          onError(res.error);
        }
      }, onError);
    };

    florist.fetchPurchaseOrders = function (res, callback) {
      var fetched = res.fetched_results;
      angular.forEach(res.results, function (item, index) {
        item.customer_date = new Date(item.customer_date);
        item.customer_user = fetched.user[item.customer_user];
        item.customer_user.customer = fetched.customer[item.customer_user.customer] || item.customer_user.customer;
        item.state = fetched.state[item.state];
        item.country = fetched.country[item.country];
      });
      callback(res);
    };

    florist.getPurchaseOrder = function (purchase_key, onSuccess, onError) {
      var query = common.sbx.with('purchase').setPageSize(100).setPage(1).fetchModels(['customer_user.customer', 'state', 'country', 'customer_payment_option']).whereWithKeys([purchase_key]).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setPageSize(100)
        .setPage(1)
        .setModel('purchase')
        .fetchModels([
          'customer_user.customer',
          'state',
          'country',
          'customer_payment_option'
        ])
        .whereWithKeys([purchase_key])
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          florist.fetchPurchaseOrders(res, onSuccess);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.addMasterlistFav = function (masterlist_key, onSuccess, onError) {

      async.waterfall([function (cb) {
        var box = {
          is_duplicate: false
        };
        var query = common.sbx.with('fav_masterlist').andWhereIsEqual('masterlist', masterlist_key).andWhereIsEqual('user', common.getUserData().key).compile();
        /*let query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('fav_masterlist')
          .addCondition('AND', 'masterlist', '=', masterlist_key)
          .addCondition('AND', 'user', '=', common.getUserData().key)
          .compile();*/

        common.method.query(common.urls.find, query).then(function () {
          var res = common.response.post_query.data;
          if (res.success) {
            if (res.results.length > 0) {
              box.is_duplicate = true;
            }
            cb(null, box);
          } else {
            cb(res.error);
          }
        });
      }, function (box, cb) {
        if (box.is_duplicate) {
          return cb(null, box);
        }

        var query = common.sbx.insert('fav_masterlist', {
          masterlist: masterlist_key,
          user: common.getUserData().key
        });
        /*let query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('fav_masterlist')
          .addObject({
            masterlist: masterlist_key,
            user: common.getUserData().key
          }).compile();*/

        common.method.query(common.urls.row, query).then(function () {
          var res = common.response.post_query.data;
          if (res.success) {
            _totalListFav++;
            cb(null);
          } else {
            cb(res.error);
          }
        });
      }], function (err) {
        if (err) {
          return onError(err);
        }

        onSuccess(null);
      });
    };

    florist.removeMasterlistFav = function (masterlist_key, onSuccess, onError) {

      var query = common.sbx.with('fav_masterlist').andWhereIsEqual('masterlist', masterlist_key).andWhereIsEqual('user', common.getUserData().key).compile();
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('fav_masterlist')
        .addCondition('AND', 'masterlist', '=', masterlist_key)
        .addCondition('AND', 'user', '=', common.getUserData().key)
        .compile();*/

      common.method.query(common.urls.delete, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          _totalListFav--;
          onSuccess(res);
        } else {
          onError(res.error);
        }
      });
    };

    florist.removeMasterlistFavDuplicate = function (array_keys, onSuccess, onError) {

      var query = common.sbx.with('fav_masterlist').whereWithKeys(array_keys).compile();
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('fav_masterlist')
        .whereWithKeys(array_keys)
        .compile();*/

      common.method.query(common.urls.delete, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(res.error);
        }
      });
    };

    // SETUP
    // ---> Company

    florist.getCompanyInfo = function (model, onSuccess, onError) {
      var key = common.getUserData()[model];

      var query = common.sbx.with(model).fetchModels(['state', 'country', 'time_zone']).whereWithKeys([key]).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel(model)
        .fetchModels([
          'state',
          'country',
          'time_zone'
        ])
        .whereWithKeys([key])
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          var fetched = res.fetched_results;
          angular.forEach(res.results, function (item, index) {
            item.state = fetched.state[item.state];
            item.country = fetched.country[item.country];
            item.time_zone = fetched.time_zone[item.time_zone];
          });
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.updateCompanyInfo = function (company, onSuccess, onError) {
      var query = common.sbx.insert('customer', company);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer')
        .addObject(company)
        .compile();*/

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.shippingDayByCountry = function (countryKey, onSuccess, onError) {
      var query = common.sbx.with('shipping_day').andWhereIsEqual('country', countryKey).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('shipping_day')
        .addCondition('AND', 'country', '=', countryKey)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res.results);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    // ---> User
    florist.getUserList = function (model, onSuccess, onError) {
      var key = common.getUserData()[model];

      var query = common.sbx.with(model + '_user_config').fetchModels(['user']).andWhereIsEqual('user.customer', key).andWhereIsEqual('user.active', true).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel(model + '_user_config')
        .fetchModels([
          'user',
        ])
        .addCondition('AND', 'user.customer', '=', key)
        .addCondition('AND', 'user.active', '=', true)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {

        var res = common.response.post_query.data;
        if (res.success) {
          _setupTotal.users = res.row_count;
          var fetched_results = res.fetched_results;
          angular.forEach(res.results, function (item) {
            item.user = fetched_results.user[item.user];
            item.user.isAdmin = florist.isAdmin(item.user.user_id);
          });
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.deactivaUser = function (user_key, onSuccess, onError) {
      var query = common.sbx.insert('user', {
        '_KEY': user_key,
        'active': false });
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('user')
        .addObject({
          '_KEY': user_key,
          'active': false
        }).compile();*/

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getUserPermision = function (model, onSuccess, onError) {
      var key = common.getUserData().key;

      var query = common.sbx.with(model + '_user_config').fetchModels(['user']).andWhereIsEqual('user', key).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel(model + '_user_config')
        .fetchModels([
          'user',
        ])
        .addCondition('AND', 'user', '=', key)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          var fetched_results = res.fetched_results;
          angular.forEach(res.results, function (item) {
            item.user = fetched_results.user[item.user];
            item.user.isAdmin = florist.isAdmin(item.user.user_id);
          });
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.getGrowersByCustomer = function (onSuccess, onError) {
      async.waterfall([function (cb) {
        var query = common.sbx.with('grower').fetchModels(['country']).andWhereIsEqual('active', true).compile();
        /*var query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('grower')
          .fetchModels([
            'country',
          ])
          .addCondition('AND', 'active', '=', true)
          .compile();*/
        common.method.query(common.urls.find, query).then(function () {
          var res = common.response.post_query.data;
          if (res.success) {
            var fetched_results = res.fetched_results;
            angular.forEach(res.results, function (item) {
              item.country = fetched_results.country[item.country];
            });

            var box = { growers: res.results };
            cb(null, box);
          } else {
            cb(res.error);
          }
        });
      }, function (box, cb) {
        common.loadGrowerCustomerRelation(function (res) {
          box.results = res.results;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        var resGrowers = [];
        var resMap = {};
        if (box.results.length > 0) {
          angular.forEach(box.results, function (item) {
            resMap[item.grower] = item;
          });
          angular.forEach(box.growers, function (grower) {
            grower.status = true;
            grower.your_rating = 0;
            if (resMap[grower._KEY]) {
              var item = resMap[grower._KEY];
              grower.your_rating = parseInt(item.rating);
              grower.status = item.customer_perm;
              grower.relationship = item._KEY;
              if (item.grower_perm) {
                resGrowers.push(grower);
              }
            } else {
              resGrowers.push(grower);
            }
          });
          box.res = resGrowers;
        } else {
          for (var i = 0; i < box.growers.length; i++) {
            var grower = box.growers[i];
            grower.status = true;
          }
          box.res = box.growers;
        }
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }
        _setupTotal.growers = box.growers.length;
        onSuccess($filter('orderBy')(box.growers, 'company_name'));
      });
    };

    florist.getGrowerCustomerRelation = function (key, onSuccess, onError) {

      var model = common.getUserData().ibf_role == 'FLORIST' ? 'customer' : 'grower';
      var model_two = common.getUserData().ibf_role == 'FLORIST' ? 'grower' : 'customer';
      var query = common.sbx.with('customer_grower_relationship').andWhereIsEqual(model, common.getUserData()[model]).andWhereIsEqual(model_two, key).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer_grower_relationship')
        .addCondition('AND', model, '=', common.getUserData()[model])
        .addCondition('AND', model_two, '=', key)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(res.error);
        }
      });
    };

    florist.changeRelationStatus = function (model_key, onSuccess, onError) {
      var model = common.getUserData().ibf_role == 'FLORIST' ? 'customer' : 'grower';
      var model_two = common.getUserData().ibf_role == 'FLORIST' ? 'grower' : 'customer';

      async.waterfall([function (cb) {
        var box = {};
        florist.getGrowerCustomerRelation(model_key, function (res) {
          if (res.results.length > 0) {
            box.relationship = res.results[0];
          }
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (!box.relationship) {
          return cb(null, box);
        }
        var relationUpdate = {
          '_KEY': box.relationship._KEY
        };
        relationUpdate[model + '_perm'] = !box.relationship[model + '_perm'];

        var queryUpdate = common.sbx.insert('customer_grower_relationship', relationUpdate);
        /*let queryUpdate = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('customer_grower_relationship')
          .addObject(relationUpdate)
          .compile();*/

        florist.updateGrowerCustomerRelation(queryUpdate, function () {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (box.relationship) {
          return cb(null, box);
        }

        var newRelation = {
          'rating': 0
        };
        newRelation[model] = common.getUserData()[model];
        newRelation[model_two] = model_key;

        newRelation[model + '_perm'] = false;
        newRelation[model_two + '_perm'] = true;

        florist.createRelation(newRelation, function () {
          cb(null, box);
        }, cb);
      }], function (err) {
        if (err) {
          return onError(err);
        }

        onSuccess(null);
      });
    };

    florist.updateGrowerCustomerRelation = function (query, onSuccess, onError) {
      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.removeRelation = function (relationship, onSuccess, onError) {
      var query = common.sbx.with('customer_grower_relationship').whereWithKeys([relationship._KEY]).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer_grower_relationship')
        .whereWithKeys([relationship._KEY])
        .compile();*/

      common.method.query(common.urls.delete, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.createRelation = function (grower, onSuccess, onError) {
      var query = common.sbx.insert('customer_grower_relationship', grower);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer_grower_relationship')
        .addObject(grower).compile();*/

      common.method.query(common.urls.row, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.addUser = function (config) {
      return $uibModal.open({
        templateUrl: 'views/florist/setup.users.add.html',
        controller: 'floristUserManagerCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
          data: function data() {
            return config;
          }
        }
      });
    };

    florist.showDetailCartBox = function (config) {
      return $uibModal.open({
        templateUrl: 'views/florist/ibuyflowers.shoppingcart.cart_item.detail.html' + '?v=' + environment.versionApp,
        controller: 'floristIBuyFlwCartItemsCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          data: function data() {
            return config;
          }
        }
      });
    };

    florist.addBoxCode = function (config) {
      return $uibModal.open({
        templateUrl: 'views/florist/ibuyflowers.shoppingcart.box_code.html',
        controller: 'floristIBuyFlwBoxCodeCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          data: function data() {
            return config;
          }
        }
      });
    };

    florist.filterProductGroupsBox = function (config) {
      return $uibModal.open({
        templateUrl: 'views/florist/ibuyflowers.filter_box.html',
        controller: 'floristIBuyFlwFilterBoxCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          data: function data() {
            return config;
          }
        }
      });
    };

    florist.productGroupsByGrower = function (config) {
      if (!config) {
        config = {};
      }
      config.load = florist.loadProductGroupsByGrower;
      return $uibModal.open({
        templateUrl: 'views/florist/ibuyflowers.products_by_grower.html',
        controller: 'floristIBuyFlwProdByGrowerCtrl',
        controllerAs: 'modal',
        bindToController: true,
        backdrop: 'static',
        keyboard: false,
        size: 'md',
        resolve: {
          data: function data() {
            return config;
          }
        }
      });
    };

    florist.loadProductGroupsByGrower = function (onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.getProdByGrower,
        params: {}
      }).then(function (response) {
        if (response.success) {
          onSuccess(response.res);
        } else {
          onError(response.error);
        }
      }, onError);
    };

    // RATING

    florist.verifyRating = function (growers, onSuccess, onError) {
      var box = {
        growersMap: {}
      };
      async.eachSeries(growers, function (item, cbEach) {
        florist.getGrowerCustomerRelation(item._KEY, function (res) {
          if (res.results.length > 0) {
            box.growersMap[item._KEY] = {
              grower: item,
              relationship: res.results[0]
            };
          }
          cbEach(null);
        });
      }, function (errEach) {
        if (errEach) {
          return onError(errEach);
        }
        var response = {
          rated: [],
          pending: []
        };
        angular.forEach(growers, function (item) {
          var obj = box.growersMap[item._KEY];
          item.your_rating = 0;
          if (!obj) {
            response.pending.push(item);
          } else if (!obj.relationship.rating) {
            response.pending.push(item);
          } else {
            item.your_rating = obj.relationship.rating;
            response.rated.push(item);
          }
        });
        onSuccess(response);
      });
    };

    florist.rateGrower = function (grower_key, rate, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          grower_key: grower_key,
          rate: rate
        };
        florist.getGrowerCustomerRelation(box.grower_key, function (res) {
          if (res.results.length > 0) {
            box.relationship = res.results[0];
          }
          cb(null, box);
        });
      }, function (box, cb) {
        if (!box.relationship) {
          return cb(null, box);
        }

        var updateGrower = common.sbx.insert('customer_grower_relationship', {
          '_KEY': box.relationship._KEY,
          'rating': box.rate
        });
        /*let updateGrower = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('customer_grower_relationship')
          .addObject({
            '_KEY': box.relationship._KEY,
            'rating': box.rate
          })
          .compile();*/

        florist.updateGrowerCustomerRelation(updateGrower, function () {
          cb(null, box);
        }, cb);
      }, function (box, cb) {

        if (box.relationship) {
          return cb(null, box);
        }

        var newGrower = {
          'customer': common.getUserData().customer,
          'grower': box.grower_key,
          'customer_perm': true,
          'grower_perm': true,
          'rating': box.rate
        };

        florist.createRelation(newGrower, function (res) {
          box.res = res;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        florist.calculateRateGrower(box.grower_key, function (res) {
          box.rate_ave = res.rate;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        florist.updateRateGrower(grower_key, box.rate_ave, function (res) {
          cb(null, box);
        }, cb);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box);
      });
    };

    // FREIGHT COST
    florist.loadFreightCostByDate = function (date, onSuccess, onError) {
      var year = date.getFullYear();
      var month = date.getMonth();
      var query = common.sbx.with('freight_cost').andWhereIsEqual('year', year).andWhereIsEqual('month', month).fetchModels(['carrier']).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('freight_cost')
        .fetchModels(['carrier'])
        .addCondition('AND', 'year', '=', year)
        .addCondition('AND', 'month', '=', month)
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.results) {
          var fetched = res.fetched_results;
          angular.forEach(res.results, function (item, index) {
            item.carrier = fetched.carrier[item.carrier];
          });
          onSuccess(res);
        } else {
          onError(res.error);
        }
      });
    };

    // IMPORT DUTIES
    florist.loadImportDuties = function (onSuccess, onError) {
      var query = common.sbx.with('import_duties').compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('import_duties')
        .compile();*/

      common.loadAllPages(query, function (res) {
        if (res.results) {
          onSuccess(res);
        } else {
          onError(res.error);
        }
      }, onError);
    };

    florist.calculateRateGrower = function (grower_key, onSuccess, onError) {
      var query = common.sbx.with('customer_grower_relationship').andWhereIsEqual('grower', grower_key).compile();
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer_grower_relationship')
        .addCondition('AND', 'grower', '=', grower_key)
        .compile();*/

      common.loadAllPages(query, function (res) {
        var temp = 0;
        angular.forEach(res.results, function (item) {
          temp = temp + item.rating;
        });

        res.rate = temp / res.results.length;
        onSuccess(res);
      }, onError);
    };

    florist.updateRateGrower = function (grower_key, rate, onSuccess, onError) {
      var query = common.sbx.insert('grower', {
        '_KEY': grower_key,
        'rating': rate
      });
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('grower')
        .addObject({
          '_KEY': grower_key,
          'rating': rate
        })
        .compile();*/

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res);
        } else {
          onError(new Error(res.error));
        }
      });
    };

    florist.folderList = function (params, onSuccess, onError) {
      common.method.get(common.urls.folderList, params).then(function () {
        var response = common.response.get.data;
        if (response.success) {
          onSuccess(response.contents);
        } else {
          onError(response.error);
        }
      });
    };

    florist.claimReasons = function (onSuccess, onError) {
      var query = common.sbx.with('claim_reason').compile();
      /*var query = common.queryBuilder()
      .setDomain(common.actual_domain)
      .setModel('claim_reason')
      .compile();*/

      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess(res.results);
        } else {
          onError(res.error);
        }
      });
    };

    florist.saveClaim = function (row, uploader, onSuccess, onError) {

      async.waterfall([function (cb) {

        var box = {
          uploader: uploader,
          claim_reasons: row.claim_reasons,
          customer_folder: row.customer_folder,
          customer: row.customer,
          grower: row.grower,
          data: row.query_obj,
          order_info: row.order_info
        };

        var base_query = common.sbx.with('request_claim');
        /*let base_query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('request_claim');*/

        box.base_query = base_query;

        var first_query = common.sbx.insert('request_claim', row.query_obj);
        /*let first_query = angular.copy(base_query);
        first_query.addObject(row.query_obj);
         first_query = first_query.compile();*/

        common.method.query(common.urls.row, first_query).then(function () {
          var res = common.response.post_query.data;

          if (res.success) {
            box.claim_key = res.keys[0];
            cb(null, box);
          } else {
            cb(res.error, box);
          }
        });
      }, function (box, cb) {

        var obj = {
          _KEY: box.claim_key
        };
        var aux = 0;
        async.eachSeries(box.uploader, function (uploader, cbEach) {
          uploader.queue[0].url = common.urls.api + common.urls.uploadFile;
          uploader.queue[0].headers = common.getHeaders();
          uploader.queue[0].formData = [{ model: JSON.stringify({ key: box.customer_folder }) }];
          uploader.queue[0].file.name = 'claim_photo_' + aux + '_' + box.claim_key + '.jpg';

          var url = common.actual_base_url + '/customers/' + common.getUserData().customer + '/' + 'claim_photo_' + aux + '_' + box.claim_key + '.jpg';

          switch (aux) {
            case 0:
              obj.picture_including_shipping_label = url;
              break;
            case 1:
              obj.picture_including_farm_name = url;
              break;
            case 2:
              obj.picture_product_to_be_claimed_1 = url;
              break;
            case 3:
              obj.picture_product_to_be_claimed_2 = url;
              break;
          }
          aux = aux + 1;
          uploader.queue[0].upload();

          uploader.queue[0].onError = function () {
            cbEach('Error on image: ' + uploader.queue[0].file.name);
          };

          uploader.queue[0].onComplete = function () {
            cbEach(null);
          };
        }, function (error) {
          if (error) {
            cb(error);
          }
          box.row = obj;
          cb(null, box);
        });
      }, function (box, cb) {
        var query = common.sbx.insert('request_claim', box.row);
        /*let query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('request_claim')
          .addObject(box.row)
          .compile();*/

        common.method.query(common.urls.update, query).then(function () {
          var res = common.response.post_query.data;
          if (res.success) {
            cb(null, box);
          } else {
            cb(res.error, box);
          }
        });
      }, function (box, cb) {

        async.eachSeries(box.claim_reasons, function (claim_reason, cbEach) {

          var query = common.sbx.insert('reason_per_claim', {
            request_claim: box.claim_key,
            claim_reason: claim_reason._KEY
          });
          /*let query = common.queryBuilder()
            .setDomain(common.actual_domain)
            .setModel('reason_per_claim')
            .addObject({
              request_claim: box.claim_key,
              claim_reason: claim_reason._KEY
            })
            .compile();*/

          common.method.query(common.urls.row, query).then(function () {
            var res = common.response.post_query.data;
            if (res.success) {
              cbEach(null);
            } else {
              cbEach(res.error);
            }
          });
        }, function (error) {
          if (error) {
            return cb(error, box);
          }

          cb(null, box);
        });
      }, function (box, cb) {
        // mail notification

        var price = parseFloat(box.data.total_claim);
        var margin = parseFloat(box.customer.margin) / 100;
        box.total_claim_grower = price * (1 - margin);
        box.total_claim_customer = box.data.total_claim;
        var reasons = [];
        for (var i = 0; i < box.claim_reasons.length; i++) {
          reasons.push(box.claim_reasons[i].claim_reason);
        }

        var customer_claim = {
          'subject': 'A claim has been placed via iBuyFlowers.com',
          'to': box.customer.office_email,
          'bcc': 'customerservice@ibuyflowers.com,carloscoral@ibuyflowers.com',
          'domain': common.actual_domain,
          'from': 'info@ibuyflowers.com',
          'template_key': common.request_claim_mail_customer,
          'data': {
            'customer': box.customer.company_name,
            'order_number': box.order_info.po,
            'reasons': reasons,
            'total_claim': box.total_claim_customer
          }
        };

        var grower_claim = {
          'subject': 'A claim has been placed via iBuyFlowers.com',
          'to': box.grower.email_address,
          'bcc': 'customerservice@ibuyflowers.com,carloscoral@ibuyflowers.com',
          'domain': common.actual_domain,
          'from': 'info@ibuyflowers.com',
          'template_key': common.request_claim_mail_customer,
          'data': {
            'customer': box.grower.company_name,
            'order_number': box.order_info.order,
            'reasons': reasons,
            'total_claim': box.total_claim_grower
          }
        };

        common.method.send_mail(customer_claim).then(function (res) {
          if (res.success) {
            console.log('Customer claim email sent !!!');
          }
        });

        common.method.send_mail(grower_claim).then(function (res) {
          if (res.success) {
            console.log('Grower claim email sent !!!');
          }
        });

        cb(null, box);
      }], function (error, box) {
        if (error) {
          return onError(error);
        }
        onSuccess(box);
      });
    };

    florist.getClaims = function (claim_state, query_mode, onSuccess, onError) {

      // getClaim return the claims from the request_claims table, it has 3 params wich represents
      // the variables the return the set of claims that is needed, i.e:

      // - role(implicit): FLORIST / GROWER, depends on the user that is logged and is using the app
      // - state: Pending / Settled / Rejected / Approved; for the claim state
      // - mode: all / [claim_key]; for retreving a singular claim or the whole set

      var role = common.getUserData().ibf_role === 'FLORIST' ? 'customer' : 'grower';
      var target = role === 'customer' ? 'grower' : 'customer';

      var query = common.sbx.with('request_claim').fetchModels(['cart_box_item', 'cart_box.product_group', 'cart_box.variety', 'cart_box_item.product_group', 'cart_box_item.variety', 'cart_box.' + target, 'cart_box.purchase', 'cart_box.grade', 'cart_box_item.uom', 'cart_box_item.stems_per_bunch', 'cart_box.grower']).andWhereIsEqual('cart_box.' + role, common.getUserData()[role]);
      /*var query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('request_claim')
        .fetchModels(['cart_box', 'cart_box_item', 'cart_box.product_group', 'cart_box.variety', 'cart_box.' + target, 'cart_box.purchase', 'cart_box.grade', 'cart_box_item.uom'])
        .addCondition('AND', 'cart_box.' + role, '=', common.getUserData()[role]);*/

      if (claim_state) {
        query.andWhereIsEqual('state', claim_state);
        query.andWhereIsEqual('arrived', true);
        //query.addCondition('AND', 'state', '=', claim_state);
      } else {
        if (role === 'grower') {
          query.andWhereIsEqual('arrived', true);
        }
        query.andWhereIsNotEqual('state', 'Pending');
        //query.addCondition('AND', 'state', '!=', 'Pending');
      }

      if (query_mode != 'all') {
        query.whereWithKeys([query_mode]);
      }

      query = query.compile();

      common.loadAllPages(query, function (response) {

        if (response.results) {

          florist.fetchClaims(response, onSuccess, onError);
        } else {
          alertify.error(response.error);
        }
      }, function (err) {
        alertify.error(err);
      });
    };

    florist.fetchClaims = function (res, onSuccess, onError) {
      var role = common.getUserData().ibf_role == 'FLORIST' ? 'customer' : 'grower';
      var target = role == 'customer' ? 'grower' : 'customer';
      var fetched = res.fetched_results;
      angular.forEach(res.results, function (item) {
        item.cart_box = fetched.cart_box[item.cart_box];
        item.cart_box.grower = fetched.grower[item.cart_box.grower] || item.cart_box.grower;
        item.cart_box.purchase = fetched.purchase[item.cart_box.purchase] || item.cart_box.purchase;
        item.cart_box_item = fetched.cart_box_item ? fetched.cart_box_item[item.cart_box_item] : item.cart_box_item;
        item.cart_box_item.uom = fetched.uom[item.cart_box_item.uom] || item.cart_box_item.uom;
        item.cart_box_item.stems_per_bunch = fetched.stems_per_bunch[item.cart_box_item.stems_per_bunch] || item.cart_box_item.stems_per_bunch;
        item.cart_box_item.product_group = fetched.product_group[item.cart_box_item.product_group] || item.cart_box_item.product_group;
        item.cart_box_item.variety = fetched.variety[item.cart_box_item.variety] || item.cart_box_item.variety;

        var base_price_stem = item.cart_box_item.base_price;
        if (item.cart_box_item.uom.uom === "bunch") {
          // If not is stem we need to divide the base price by the stems per bunch
          base_price_stem = base_price_stem / item.cart_box_item.stems_per_bunch.stems_per_bunch;
        }

        if (role === 'grower') {

          item.cart_box.customer = fetched.customer[item.cart_box.customer] || item.cart_box.customer;
          var price = parseFloat(item.total_claim);
          var margin = parseFloat(item.cart_box.purchase.margin) / 100;

          if (item.total_claim_grower === null || item.total_claim_grower === "") {
            // item.total_claim_grower = price * (1 - margin);
            item.show_no_shipping_price = true;
            item.total_claim_grower = item.cart_box.grower.hasOwnProperty("excl_transport_cost") && item.cart_box.grower.excl_transport_cost ? base_price_stem * item.total_units_to_be_claimed : price * (1 - margin);
          }
          item.total_claim = price * (1 - margin);
        } else {
          item.cart_box.grower = fetched.grower[item.cart_box.grower] || item.cart_box.grower;
        }
        item.cart_box.grade = fetched.grade[item.cart_box.grade] || item.cart_box.grade;
        item.cart_box.product_group = fetched.product_group[item.cart_box.product_group] || item.cart_box.product_group;
        item.cart_box.variety = fetched.variety[item.cart_box.variety] || item.cart_box.variety;
        item.cart_box.eta_date = typeof item.cart_box.eta_date == 'number' ? common.convertNumberDateToDate(item.cart_box.eta_date) : item.cart_box.eta_date;
        item.cart_box.packing_date = typeof item.cart_box.packing_date == 'number' ? common.convertNumberDateToDate(item.cart_box.packing_date) : item.cart_box.packing_date;

        item.total_grower_no_shipping = item.total_claim_grower === 0 ? 0 : base_price_stem * item.total_units_to_be_claimed;

        if (item.settled_date) {
          item.settled_date = common.convertNumberDateToDate(item.settled_date);
        } else {
          item.settled_date = item.settle_date;
        }
      });

      onSuccess(res.results);
    };

    florist.getClaimReasons = function (claim, onSuccess, onError) {
      var query = common.sbx.with('reason_per_claim').fetchModels(['claim_reason']).andWhereIsEqual('request_claim', claim).compile();
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('reason_per_claim')
        .fetchModels(['claim_reason'])
        .addCondition('AND', 'request_claim', '=', claim)
        .compile();*/
      common.method.query(common.urls.find, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          var fetched = res.fetched_results;
          angular.forEach(res.results, function (item) {
            item.claim_reason = fetched.claim_reason[item.claim_reason];
          });

          onSuccess(res.results);
        } else {
          alertify.error(res.error);
        }
      });
    };

    florist.setClaimStatus = function (status, claim, onSuccess, onError) {

      var query = common.sbx.insert('request_claim', {
        '_KEY': claim._KEY,
        'state': status,
        'settle_date': new Date(),
        'settled_date': common.convertDateToNumberDate(new Date())
      });

      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('request_claim')
        .addObject({
          '_KEY': claim._KEY,
          'state': status,
          'settle_date': new Date(),
          'settled_date': common.convertDateToNumberDate(new Date())
        }).compile();*/

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          if (status === "Void") {
            onSuccess('ok');
          } else {
            common.salesforceSync({ action: 'update', model: 'request_claim', key: claim._KEY });
            var cc_mail = null;

            if (claim.cart_box.customer.acc_manager) {
              cc_mail = claim.cart_box.customer.acc_manager;
            }

            var query2 = common.sbx.with('request_claim').whereWithKeys([claim._KEY]).compile();

            common.loadAllPages(query2, function (res) {

              var claimObj = claim;

              if (res && res.results && res.results.length > 0) {
                claimObj = res.results[0];
              }

              try {
                var auditDesc = 'The user ' + common.getUserData().data.first_name + ' ' + common.getUserData().data.last_name;
                auditDesc += ' with the ID ' + common.getUserData().data.id + ' update the claim ' + claim.consecutive + ' status to ' + status;

                var auditObj = {
                  action: 'CLAIM_UPDATE_STATUS',
                  user: common.getUserData().key,
                  date: new Date(),
                  reason: 'Status: ' + status,
                  description: auditDesc,
                  object_string: JSON.stringify(claimObj)
                };
                florist.createAudit(auditObj, function () {
                  console.log('claim status audit created');
                }, function (err) {
                  console.log(err);
                });
              } catch (e) {}

              var customer_claim = {
                'subject': 'Hi ' + claim.cart_box.customer.company_name + ', ' + claim.cart_box.grower.company_name + ' has responded to your claim via iBuyFlowers.com',
                'to': claim.cart_box.customer.office_email,
                'cc': cc_mail,
                'bcc': 'customerservice@ibuyflowers.com, carloscoral@ibuyflowers.com',
                'domain': common.actual_domain,
                'from': 'customerservice@ibuyflowers.com',
                'template_key': common.response_claim_mail,
                'data': {
                  'customer': claim.cart_box.customer.company_name,
                  'order_consecutive': claim.cart_box.consecutive,
                  'grower': claim.cart_box.grower.name,
                  'claim_number': claim.consecutive,
                  'amount': claimObj.total_claim.toFixed(2),
                  'reason': claimObj.comments,
                  'status': status === 'Accepted' ? 'accepted' : 'denied'
                }
              };
              common.method.send_mail(customer_claim).then(function (res) {
                if (res.success) {
                  console.log('Customer claim response email sent !!!');
                }
                onSuccess('ok');
              });
            });
          }
        } else {
          alertify.error(res.error);
        }
      });
    };

    florist.revertClaimStatus = function (status, claim, onSuccess, onError) {

      var query = common.sbx.insert('request_claim', {
        '_KEY': claim._KEY,
        'state': status,
        'settle_date': new Date(),
        'settled_date': common.convertDateToNumberDate(new Date())
      });

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess('ok');
        } else {
          alertify.error(res.error);
        }
      });
    };

    //======================================== STANDING ORDERS ============================================//

    /**
     * STANDING ORDERS
     * Function: get the list for the standing order
     */
    florist.getStandingList = function (conditions, onSuccess, onError) {

      async.waterfall([function (cb) {
        // relacion de customer - set inicial de calendario o por box

        var box = {
          available: true,
          conditions: conditions,
          favorites: [],
          fav_masterlist: []
        };

        if (!_standingBox.model._KEY) {
          box.isCurrentBox = false;
          box.now = box.conditions.date;
          if (!box.conditions.date) {
            var dateInt = common.convertDateToNumberDate(florist.getArrivalDate());
            box.now = dateInt;
          }
          _arrival_date = common.convertNumberDateToDate(box.now);
        } else {
          box.isCurrentBox = true;
          box.now = typeof _standingBox.model.eta_date == 'number' ? _standingBox.model.eta_date : common.convertDateToNumberDate(_standingBox.model.eta_date);
        }

        common.loadGrowerCustomerRelation(function (response) {
          box.conditions.notLoad = [];
          angular.forEach(response.results, function (item) {
            if (!item.customer_perm) {
              box.conditions.notLoad.push(item.grower);
            }
          });
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        //get country list
        florist.getCountriesList(function (res) {
          box.countries = res.results;

          // angular.forEach(countries, function(item){
          //   box.countries.push(item._KEY);
          // });
          cb(null, box);
        }, function (e) {
          cb(e, box);
        });
      }, function (box, cb) {
        //get masterlist from inventory

        if (!box.available) {
          box.res = { results: [] };
          return cb(null, box);
        }

        async.eachSeries(box.countries, function (country, cbEach) {

          var query = florist.getBaseQueryInventory(box.conditions.size, box.conditions.page);
          var now = common.convertNumberDateToDate(box.now);

          if (!box.isCurrentBox) {
            if (box.conditions.notLoad.length) {
              query.andWhereNotIn('masterlist.grower', box.conditions.notLoad);
              //query.addCondition('AND', 'masterlist.grower', 'not in', box.conditions.notLoad);
            }
          } else {
            florist.addInventoryConditionsByCartBox(query, _standingBox.model);
          }

          var today = new Date();
          if (common.getTimeEST() > 8) {
            today.setDate(today.getDate() + 1);
          }
          today.setHours(0);
          today.setMinutes(0);
          today.setSeconds(0);
          today.setMilliseconds(0);

          query.newGroupWithAnd();
          if (box.conditions.by_fav) {
            query.andWhereReferenceJoinBetween('user', 'masterlist').in('fav_masterlist').filterWhereIsEqual(common.userData.key);
            /*query.setReferenceJoin('=', 'user', 'masterlist', 'fav_masterlist', common.userData.key);
            query.addCondition('AND', 'masterlist', 'in', '@reference_join@');*/
          }
          query.andWhereIsEqual('grower.country', country._KEY);
          query.andWhereGreaterThan('price', 0);
          /*query.addCondition('AND', 'grower.country', '=', country._KEY);
          query.addCondition('AND', 'price', '>', 0);*/
          // let packingDay = angular.copy(now);
          // packingDay.setDate(packingDay.getDate() - country.delay);
          // let timeDiff = Math.abs(packingDay.getTime() - today.getTime());
          var dayP = now.getDay();
          var start_date = new Date(now);
          // let week = new Date(packingDay);
          start_date.setDate(now.getDate() - dayP + 1);
          // if ((week.getDay()) == 0) {
          //   week.setDate(week.getDate() - 1)
          // };
          // if (common.getWeekNum(now) != common.getWeekNum(week)) {
          //   dayP = week.getDay();
          //   start_date = new Date(week);
          //   start_date.setDate(week.getDate() - dayP + 1);
          // }

          // let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

          //let end_date = new Date(start_date);
          start_date.setDate(start_date.getDate() + 14);

          query.newGroupWithAnd();
          query.andWhereIsEqual('week', common.convertDateToNumberDate(start_date));
          //query.addCondition('AND', 'week', '=', common.convertDateToNumberDate(start_date));

          //query.addCondition('OR', 'week', '=', common.convertDateToNumberDate(end_date));These were already commented
          // query.addCondition('AND', 'quantity', '>', 0);


          // if (diffDays == 0) {
          //   query.addCondition('AND', 'masterlist.order_in_advance', '=', 0);
          // } else {
          //   query.addCondition('AND', 'masterlist.order_in_advance', '>=', 0);
          //   if (diffDays < 21) {
          //     query.addCondition('AND', 'masterlist.order_in_advance', '<=', diffDays);
          //   };
          // }//These were already commented

          query = query.compile();
          box.query = query;
          console.log('QUERY', JSON.stringify(query));
          common.loadAllPages(box.query, function (res) {
            // for (var i = 0; i < res.results.length; i++) {
            //   res.results[i].packing_date = common.convertDateToNumberDate(packingDay);
            // };
            if (!box.res) {
              box.res = angular.copy(res);
            } else {

              box.res.results = box.res.results.concat(res.results);

              for (var model in Object.keys(res.fetched_results)) {

                var model_obj = Object.keys(res.fetched_results)[model];
                if (!box.res.fetched_results[model_obj]) {
                  box.res.fetched_results[model_obj] = {};
                }
                for (var key in Object.keys(res.fetched_results[model_obj])) {
                  var key_obj = Object.keys(res.fetched_results[model_obj])[key];
                  box.res.fetched_results[model_obj][key_obj] = res.fetched_results[model_obj][key_obj];
                }
              }
            }
            cbEach(null, box);
          }, cbEach);
        }, function (err) {
          if (err) {
            return cb(err, box);
          }
          if (box.res) {
            _totalList = box.res.results.length;
          } else {
            box.res = {
              results: []
            };
          }
          cb(null, box);
        });
      }, function (box, cb) {

        if (!box.res.results.length) {
          return cb(null, box);
        }
        console.log('fetching..');

        florist.fetchInventory(box.res, function () {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        //carga de los freight costs

        if (!box.res.results.length) {
          return cb(null, box);
        }
        var now = common.convertNumberDateToDate(box.now);
        var year = now.getFullYear();
        var month = now.getMonth();
        console.log(now, box.now);
        var yearMonth = year + '_' + month;

        if (_freightCost[yearMonth]) {
          box.freightCosts = _freightCost[yearMonth];
          return cb(null, box);
        }
        florist.loadFreightCostByDate(now, function (res) {
          _freightCost[yearMonth] = res.results;
          box.freightCosts = res.results;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        // carga de los factors

        if (!box.res.results.length) {
          return cb(null, box);
        }
        if (_factors) {
          box.factorsMap = _factors;
        }
        ps.listFactors(function (res) {
          var mapFactors = {};
          angular.forEach(res.data, function (factor) {
            var keyMap = factor.carrier._KEY + '_' + factor.country._KEY;
            if (!mapFactors[keyMap]) {
              mapFactors[keyMap] = factor;
            }
          });
          _factors = mapFactors;
          box.factorsMap = mapFactors;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        // carga de los import duties

        if (!box.res.results.length) {
          return cb(null, box);
        }
        if (_importDuties) {
          box.importDuties = _importDuties;
          return cb(null, box);
        }

        florist.loadImportDuties(function (res) {
          var mapImportDuties = {};
          for (var i = 0; i < res.results.length; i++) {
            var importDutie = res.results[i];
            var keyMap = importDutie.product_group + '_' + importDutie.country;
            if (!mapImportDuties[keyMap]) {
              mapImportDuties[keyMap] = importDutie.tax;
            }
          }
          _importDuties = mapImportDuties;
          box.importDuties = mapImportDuties;
          cb(null, box);
        }, cb);
      },
      // function (box, cb) { // carga listado de favs
      //   if (!box.res.results.length) {
      //     return cb(null, box);
      //   };
      //   let favListMap = {};
      //   let listFavKey = [];
      //   box.fav_masterlist = [];
      //   florist.getFlowersListFav(function (res) {
      //     angular.forEach(res.results, function (fav) {
      //       if (!favListMap[fav.masterlist]) {
      //         favListMap[fav.masterlist] = fav;
      //         box.fav_masterlist.push(fav);
      //       } else {
      //         listFavKey.push(fav._KEY);
      //       }
      //     });
      //     if (listFavKey.length) {
      //       florist.removeMasterlistFavDuplicate(listFavKey, function () { });
      //     }
      //     cb(null, box)
      //   }, cb)
      // },

      function (box, cb) {

        if (!box.res.results.length) {
          return cb(null, box);
        }
        console.log('calculatePrice..');
        florist.calculateInventoryPrice(box.res.results, box.freightCosts, box.importDuties, box.factorsMap, function () {
          cb(null, box);
        }, cb);
      }, function (box, cb) {

        if (!box.res.results.length) {
          return cb(null, box);
        }
        for (var i = 0; i < box.fav_masterlist.length; i++) {
          for (var j = 0; j < box.res.results.length; j++) {
            if (box.fav_masterlist[i].masterlist != box.res.results[j].masterlist._KEY) {
              continue;
            }

            box.res.results[j].is_favorite = true;
            box.favorites.push(box.res.results[j]);
          }
        }
        cb(null, box);
      }], function (err, box) {

        if (err) {
          return onError(err);
        }
        _totalListFav = box.favorites.length;
        _list_fav = box.favorites;
        box.res.results = $filter('orderBy')(box.res.results, ['variety.product_group.common_name', 'variety.variety_name', 'masterlist.length']);
        onSuccess(box.res);
      });
    };

    /**
     * STANDING ORDERS
     * Function: get actual items for the cartbox related to the current standing order
     */
    florist.getStandingBoxItems = function (onSuccess, onError) {
      florist.getStandingBox().items = [];
      florist.getStandingBox().itemsMap = {};
      florist.getCartBoxItems(_standingBox.model._KEY, function (res) {
        angular.forEach(res.results, function (item, index) {
          item.is_editable = true;
          florist.getStandingBox().items.push(item);
          florist.getStandingBox().itemsMap[item.inventory._KEY] = item;
        });
        onSuccess(res);
      }, onError);
    };
    /**
     * STANDING ORDERS
     * Function: and the item to the standing box order
     */
    florist.addToStandingOrder = function (inventory, quantity, arrival_date, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          standingBox: florist.getStandingBox(),
          is_complete: false,
          invalid: false,
          arrival_date: arrival_date,
          inventory: inventory,
          quantity: quantity
        };
        florist.checkStandingBox();
        if (box.standingBox.model._KEY && box.standingBox.model.product_group._KEY != inventory.variety.product_group._KEY) {
          box.invalid = true;
        }
        cb(null, box);
      }, function (box, cb) {
        if (box.invalid) {
          return cb(null, box);
        }
        florist.validateStandingBox(box.inventory, parseInt(box.quantity), box.arrival_date, function (data) {
          box.inventory.available = box.inventory.available - box.quantity;
          box.is_complete = box.standingBox.model.current_items >= box.standingBox.model.total_items;
          cb(null, box);
        }, function (err) {
          cb(err, box);
        });
      }, function (box, cb) {
        if (box.is_complete) {
          var meta = {
            grower: box.standingBox.model.grower.company_name,
            product: box.standingBox.model.product_group.common_name,
            user_id: common.getUserData().data.id
          };
          //common.registerEvent(meta, "added_to_cart");
          console.log('complete- price');
          florist.calculateBoxPrice(box.standingBox, common.onSuccessDefault, common.onErrorDefault);
          //florist.clearStandingBox();
          florist.getCartBoxByCustomer(common.onSuccessDefault, common.onErrorDefault);
        }
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box);
      });
    };

    /**
     * STANDING ORDERS
     * Function: save the current standing order to the model in SBXcloud
     */
    florist.saveStandingOrder = function (order, onSuccess, onError) {

      order.info.subscription = order.info.subscription == 'Short term' ? 'term' : 'year';
      order.info.frequency = order.info.frequency == 'Weekly' ? 'weekly' : 'bi-weekly';

      var data = {
        frequency: order.info.frequency,
        cart_box: order.model._KEY,
        subscription: order.info.subscription,
        start_date: order.info.start_date,
        end_date: order.info.end_date,
        status: 'pending'
      };

      var query = common.sbx.insert('standing_order', data);
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('standing_order')
        .addObject(data)
        .compile();*/

      common.method.query(common.urls.row, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess('ok');
        } else {
          onError(res.error);
        }
      });
    };

    /**
     * STANDING ORDERS
     * Function: send the mail notification for the saved standing order
     */
    florist.sendStandingOrderNotif = function (order) {

      var items = [];

      for (var i = 0; i < order.items.length; i++) {
        items.push({
          product_group: order.items[i].product_group.common_name,
          variety: order.items[i].variety.variety_name,
          quantity: order.items[i].quantity,
          picture: order.items[i].picture,
          stems_per_bunch: order.items[i].stems_per_bunch.stems_per_bunch
        });
      }

      var grower_mail = {
        'subject': 'You have a standing order request via iBuyFlowers.com',
        'to': order.model.grower.email_address,
        'domain': common.actual_domain,
        'from': 'info@ibuyflowers.com',
        'template_key': common.standing_order_notif,
        'data': {
          'grower': order.model.grower.company_name,
          'info': order.info,
          'items': items
        }
      };

      common.method.send_mail(grower_mail).then(function (res) {
        if (res.success) {
          console.log('grower email sent for the standing order !!!');
        }
      });
    };

    /**
     * STANDING ORDERS
     * Function: validate the actual box for the standing order
     */
    florist.validateStandingBox = function (inventory, quantity, arrival_date, onSuccess, onError) {

      var current_box = florist.getStandingBox();

      async.waterfall([function (cb) {
        var box = {
          inv: inventory,
          quant: quantity,
          isBoxNew: false
        };
        if (!current_box.model._KEY) {
          box.isBoxNew = true;
          current_box.model.product_group = inventory.variety.product_group;
          current_box.model.variety = inventory.variety;
          current_box.model.grade = inventory.masterlist.grade;
          current_box.model.box = inventory.masterlist.box;
          current_box.model.grower = inventory.masterlist.grower;
          current_box.model.customer = common.getUserData().customer;
          current_box.model.price = inventory.masterlist.box_charge;
          current_box.model.length = inventory.masterlist.length;
          current_box.model.current_items = quantity;
          current_box.model.total_items = inventory.total_box;
          current_box.model.eta_date = common.convertDateToNumberDate(arrival_date);
          current_box.model.packing_date = inventory.packing_date;
          current_box.model.arrival_date = arrival_date;
          current_box.model.is_standing_order = true;
        }

        cb(null, box);
      }, function (box, cb) {
        if (!box.isBoxNew) {
          return cb(null, box);
        }

        console.log('Creating CartBox..');
        florist.createBox(current_box.model, function (data) {
          current_box.model._KEY = data.keys[0];
          box.isBoxItemNew = true;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (box.isBoxNew) {
          return cb(null, box);
        }

        console.log('Updating CartBox..');
        var finalquant = parseInt(box.quant) + parseInt(current_box.model.current_items);
        if (finalquant > current_box.model.current_items) {
          return cb('Error Updating', box);
        }

        var cartbox = {
          '_KEY': current_box.model._KEY,
          'current_items': current_box.model.current_items + box.quant
        };

        florist.updateBox(cartbox, function (data) {
          if (!current_box.itemsMap[inventory._KEY]) {
            box.isBoxItemNew = true;
          } else {
            box.isBoxItemNew = false;
          }
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (!box.isBoxItemNew) {
          return cb(null, box);
        }

        console.log('Creating CartBoxItem..');
        var model = current_box.model;
        var cart_box_item = {
          'inventory': box.inv._KEY,
          'product_group': model.product_group._KEY,
          'grower': model.grower._KEY,
          'variety': box.inv.variety._KEY,
          'quantity': box.quant,
          'cart_box': model._KEY,
          'price': box.inv.price,
          'picture': box.inv.picture,
          'uom': box.inv.masterlist.UoM._KEY,
          'stems_per_bunch': box.inv.masterlist.stems_per_bunch._KEY,
          'custom_box_cost': box.inv.custom_box_cost
        };
        florist.addBoxItem(cart_box_item, function (data) {
          cb(null, box);
        });
      }, function (box, cb) {
        if (box.isBoxItemNew) {
          return cb(null, box);
        }
        console.log('Updating CartBoxItem..');
        var maps = current_box.itemsMap;
        var box_item = maps[box.inv._KEY];
        var cart_box_item = {
          '_KEY': box_item._KEY,
          'quantity': box_item.quantity + box.quant
        };
        florist.updateBoxItem(cart_box_item, function (data) {
          cb(null, box);
        });
      }, function (box, cb) {

        console.log('Get CartBoxItem..');
        florist.getStandingBoxItems(function (data) {
          cb(null, box);
        }, cb);
      },
      // function (box, cb) {

      //   console.log('Updating Inventory..');
      //   florist.updateInventory(box.inv._KEY, box.quant, function (data) {
      //     cb(null, box)
      //   }, cb);
      // },
      function (box, cb) {
        if (box.isBoxNew) {
          return cb(null, box);
        }
        current_box.model.current_items = current_box.model.current_items + box.quant;
        cb(null, box);
      }], function (err, box) {
        console.log(err, box);
        if (err) {
          console.log(box);
          return onError(err);
        }

        onSuccess(null);
      });
    };

    /**
     * STANDING ORDERS
     * Function: update the cartbox releated to the current standing order to make the boolean for standing order placed as true
     */
    florist.updateStandingOrderPlaced = function (key, onSuccess, onError) {
      console.log('updating cartbox: ' + key);
      var query = common.sbx.insert('cart_box', {
        '_KEY': key,
        'standing_order_placed': true
      });
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addObject({
          '_KEY': key,
          'standing_order_placed': true
        }).compile();*/
      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess('ok');
        } else {
          onError(res.error);
        }
      });
    };
    /**
     * STANDING ORDERS
     * Function: delete an item for teh standing order box
     */
    florist.deleteStandingBoxItem = function (cartboxItem, onSuccess, onError) {
      var current_box = florist.getStandingBox();

      async.waterfall([function (cb) {
        var box = {
          cartbox_item: cartboxItem,
          inv: cartboxItem.inventory,
          quant: -cartboxItem.quantity
        };
        cb(null, box);
      }, function (box, cb) {
        florist.getCartBox(box.cartbox_item.cart_box, function (cartbox) {
          box.cartbox = cartbox;
          cb(null, box);
        }, cb);
      }, function (box, cb) {

        var cartbox = {
          '_KEY': box.cartbox._KEY,
          'current_items': box.cartbox.current_items + box.quant
        };
        florist.updateBox(cartbox, function (data) {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        florist.deleteBoxItem(box.cartbox_item, function (data) {
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        florist.getStandingBoxItems(function (data) {
          box.cartboxitems = data.results;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (box.cartboxitems.length > 0) {
          return cb(null, box);
        }

        florist.deleteCartbox(box.cartbox_item.cart_box, function () {
          florist.clearStandingBox();
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        if (box.isBoxNew) {
          return cb(null, box);
        }
        current_box.model.current_items = current_box.model.current_items + box.quant;
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(null);
      });
    };

    /**
     * STANDING ORDERS
     * Function: get all pending standing orders
     */
    florist.getStandingOrders = function (status, onSuccess, onError) {

      console.log(common.getUserData());

      var role = common.getUserData().ibf_role;

      async.waterfall([function (cb) {
        // get the actual standing orders for the grower logged
        var box = {
          orders: {},
          map: {},
          collection: {}
        };

        var query = common.sbx.with('standing_order').fetchModels(['cart_box', 'cart_box.box', 'cart_box.customer', 'cart_box.grower']);
        /*let query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('standing_order')
          .fetchModels(['cart_box', 'cart_box.box', 'cart_box.customer', 'cart_box.grower']);*/

        if (role == 'GROWER') {
          query.andWhereIsEqual('cart_box.grower', common.getUserData().grower);
          //query.addCondition('AND', 'cart_box.grower', '=', common.getUserData().grower);
        } else {
          if (role == 'FLORIST') {
            query.andWhereIsEqual('cart_box.customer', common.getUserData().customer);
            //query.addCondition('AND', 'cart_box.customer', '=', common.getUserData().customer);
          }
        }

        if (status) {
          if (status == 'canceled' || status == 'rejected') {
            query.newGroupWithAnd().orWhereIsEqual('status', 'rejected').orWhereIsEqual('status', 'canceled');
            /*query.newGroup('AND');
            query.addCondition('OR', 'status', '=', 'rejected');
            query.addCondition('OR', 'status', '=', 'canceled');*/
          } else {
            query.andWhereIsEqual('status', status);
            //query.addCondition('AND', 'status', '=', status);
          }
        }

        query = query.compile();

        common.method.query(common.urls.find, query).then(function () {
          var res = common.response.post_query.data;

          if (res.success) {
            box.orders = res.results;
            var fetched = res.fetched_results;
            box.cartbox_keys = [];
            angular.forEach(box.orders, function (item) {
              // get all the cartboxes keys to request one query for them
              box.cartbox_keys.push(item.cart_box);
              item.cart_box = fetched.cart_box[item.cart_box];
              item.cart_box.box = fetched.admin_box[item.cart_box.box];
              item.cart_box.customer = fetched.customer[item.cart_box.customer];
              item.cart_box.grower = fetched.grower[item.cart_box.grower];
            });
            box.map = common.toMap(res.results, 'standingMap', '_KEY');

            cb(null, box);
          } else {
            cb(res.error, box);
          }
        });
      }, function (box, cb) {

        if (box.orders.length == 0) {
          cb(null, box);
        } else {
          var query = common.sbx.with('cart_box_item').fetchModels(['product_group', 'variety', 'uom', 'stems_per_bunch']).andWhereIn('cart_box', box.cartbox_keys).compile();
          /*let query = common.queryBuilder()
            .setDomain(common.actual_domain)
            .setModel('cart_box_item')
            .fetchModels([
              'product_group',
              'variety',
              'uom',
              'stems_per_bunch'
            ])
            .addCondition('AND', 'cart_box', 'in', box.cartbox_keys)
            .compile();*/

          common.method.query(common.urls.find, query).then(function () {

            var res = common.response.post_query.data;
            if (res.success) {

              var fetched = res.fetched_results;
              //fetch cartbox items
              angular.forEach(res.results, function (item) {
                item.product_group = fetched.product_group[item.product_group];
                item.variety = fetched.variety[item.variety];
                item.uom = fetched.uom[item.uom];
                item.stems_per_bunch = fetched.stems_per_bunch[item.stems_per_bunch];
              });

              //fetch carbox with the items
              angular.forEach(res.results, function (item) {
                if (!box.collection[item.cart_box]) {
                  box.collection[item.cart_box] = [item];
                } else {
                  box.collection[item.cart_box].push(item);
                }
              });

              console.log(box);

              cb(null, box);
            } else {
              cb(res.error, box);
            }
          });
        }
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box);
      });
    };

    /**
     * STANDING ORDERS
     * Function: get the reasons for rejecting or cancel a standing order
     */

    florist.getRejectReasons = function (onSuccess, onError) {
      var query = common.sbx.with('standing_order_reasons').compile();
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('standing_order_reasons')
        .compile();*/

      common.method.query(common.urls.find, query).then(function () {

        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(res.results);
        } else {
          onerror(res.error);
        }
      });
    };

    /**
     * STANDING ORDERS
     * Function: update the standing order status
     */
    florist.updateOrderStatus = function (key, status, reason, onSuccess, onError) {
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('standing_order');*/

      var now = new Date();
      var obj = {
        _KEY: key,
        status: status,
        updated: now
      };
      if (reason) {
        obj.cancel_reason = reason;
      }
      var query = common.sbx.insert('standing_order', obj);

      //query = query.compile();

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;

        if (res.success) {
          onSuccess('ok');
          console.log('Standing order successfully updated.');
        } else {
          onError(res.error);
        }
      });
    };

    //====================================== FILTERS PRODUCT ===========================================//

    /**
     * Example Object
     * {
     *  _KEY: $p.{product_group._KEY}_$v.{variety._KEY}_$c.{color._KEY}_$l.{number},
     *  name: {product_group.common_name} {variety.variety_name} {color.color_name} {number+'cm'}
     * }
     */

    florist.getFilterProducts = function (onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.buildFilterTree,
        params: {}
      }).then(function (response) {
        if (response.success) {
          onSuccess(response.items);
        } else {
          onError(response.error);
        }
      }, onError);
    };

    return florist;
  }
})(angular);
//# sourceMappingURL=floristSrv.js.map

'use strict';

(function (angular) {
  angular.module('ibf').factory('paymentSrv', ['commonSrv', 'floristSrv', '$filter', '$uibModal', paymentSrv]);

  function paymentSrv(commonSrv, floristSrv, $filter, $uibModal) {
    var common = commonSrv;

    return {

      addPaymentMethodModal: function addPaymentMethodModal(config) {
        return $uibModal.open({
          templateUrl: 'views/florist/setup.payment-options.add.html',
          controller: 'floristAddPaymentOptionCtrl',
          controllerAs: 'modal',
          bindToController: true,
          backdrop: 'static',
          keyboard: false,
          size: 'md',
          resolve: {
            data: function data() {
              return config;
            }
          }
        });
      },

      setupPaymentInfo: function setupPaymentInfo(customer, onSuccess, onError) {

        async.waterfall([

        // 1) create the customer
        function (cb) {
          var box = new Object(null);
          box.customer = customer;

          var cus = {
            domain: common.actual_domain,
            customer: {
              business_vat_id: box.customer.tax_id,
              description: box.customer.company_name,
              email: box.customer.office_email,
              metadata: {
                company_name: box.customer.company_name,
                office_phone: box.customer.office_phone,
                business_hours: box.customer.business_hours,
                office_email: box.customer.office_email,
                tax_id: box.customer.tax_id,
                city: box.customer.city,
                line1: box.customer.street,
                state: box.customer.state.state_iso,
                postal_code: box.customer.zipcode,
                country: box.customer.country.country_iso
              },
              shipping: {
                address: {
                  city: box.customer.city,
                  line1: box.customer.street,
                  state: box.customer.state.state_iso,
                  postal_code: box.customer.zipcode,
                  country: box.customer.country.country_iso
                },
                name: 'shipping',
                phone: box.customer.office_phone
              }
            }
          };
          common.method.query(common.urls.payment_customer, cus).then(function () {

            var res = common.response.post_query.data;

            if (res.success) {
              box.customer.payment_key = res.customer.id;
              cb(null, box);
            } else {
              console.error(res.error);
              cb(new Error(res.error), box);
            }
          });
        },
        // 2) update the customer payment key
        function (box, cb) {

          var query = common.sbx.insert('customer', { _KEY: box.customer._KEY,
            payment_key: box.customer.payment_key
          });
          /*const query = common.queryBuilder()
            .setDomain(common.actual_domain)
            .setModel('customer')
            .addObject({
              _KEY:box.customer._KEY,
              payment_key:box.customer.payment_key
            }).compile();*/

          common.method.query(common.urls.update, query).then(function () {
            var res = common.response.post_query.data;
            if (res.success) {
              cb(null, box);
            } else {
              cb(new Error(res.error), box);
            }
          });
        }], function (err, box) {

          if (err) {
            return onError(err);
          }

          onSuccess(box.customer.payment_key);
        });
      },

      addPaymentMethod: function addPaymentMethod(card, cardPlaceHolder, onSuccess, onError) {
        var dialog = common.showDialogProgress({ msj: 'Adding the card' });

        var self = this;
        var element = card;
        console.log(element);
        async.waterfall([function (cb) {

          var box = {
            options: {}
          };

          floristSrv.getCompanyInfo('customer', function (info) {
            box.customer = info.results[0];
            box.options.name = cardPlaceHolder;
            box.options.address_city = box.customer.city;
            box.options.address_line1 = box.customer.street;
            box.options.address_state = box.customer.state.state;
            box.options.address_zip = box.customer.zipcode;

            console.log(box.card);

            cb(null, box);
          }, function (err) {
            return cb(err, box);
          });
        },
        /**
         * This function create the stripe card to the user
         * @param box
         * @param cb
         * @author carlos@socobox.co
         */
        function (box, cb) {
          var stripe = common.getStripe();
          stripe.createToken(element, box.options).then(function (res) {
            if (res.token) {
              // Use the token to create a charge or a customer
              // https://stripe.com/docs/charges
              box.token = res.token;
              cb(null, box);
            } else if (res.error) {
              return cb(new Error(res.error.message), box);
            }
          });
        }, function (box, cb) {
          // if the customer has already been created into stripe, skip this step
          if (box.customer.payment_key) {
            return cb(null, box);
          }

          self.setupPaymentInfo(box.customer, function (payment_key) {
            box.customer.payment_key = payment_key;
            cb(null, box);
          }, function (err) {
            return cb(err, box);
          });
        }, function (box, cb) {

          var card = {
            token: box.token.id,
            customer_id: box.customer.payment_key,
            domain: common.actual_domain
          };

          common.method.query(common.urls.payment_card, card).then(function () {

            var res = common.response.post_query.data;

            if (res.success) {
              box.card = res.card;
              cb(null, box);
            } else {
              console.error(res.error);
              cb(new Error(res.error), box);
            }
          });
        }, function (box, cb) {
          //add the payment method into our db, card key and payment method key included.
          // add the payment method into the customer in stripe
          var card = {
            card_id: box.card.id,
            customer: box.customer._KEY,
            is_default: true,
            card_name: box.token.card.name,
            client_ip: box.token.client_ip,
            created: new Date(),
            card_last4: box.token.card.last4,
            card_brand: box.token.card.brand,
            card_country: box.token.card.country
          };

          var query = common.sbx.insert('customer_payment_option', card);
          /*const query = common.queryBuilder()
            .setDomain(common.actual_domain)
            .setModel('customer_payment_option')
            .addObject(card).compile();*/

          common.method.query(common.urls.row, query).then(function () {
            var res = common.response.post_query.data;
            if (res.success) {
              cb(null, box);
            } else {
              cb(new Error(res.error), box);
            }
          });
        }], function (err) {

          if (err) {
            return onError(err);
          }

          // finish this process.
          dialog.close();
          onSuccess();
        });
      },

      removePaymentMethod: function removePaymentMethod(payment_method_key, onSuccess, onError) {

        if (!payment_method_key || payment_method_key.length == 0) {
          return onError(new Error('Invalid Payment Method Selected.'));
        }

        var query = {
          domain: common.actual_domain,
          page: 1,
          row_model: 'customer_payment_option',
          where: {
            keys: [payment_method_key]
          }
        };

        common.method.query(common.urls.delete, query).then(function () {

          var res = common.response.post_query.data;

          if (res.success) {
            onSuccess();
          } else {
            onError(new Error(res.error));
          }
        });
      },

      listPaymentMethods: function listPaymentMethods(onSuccess, onError) {

        var query = common.sbx.with('customer_payment_option').andWhereIsEqual('customer', common.getUserData()['customer']).compile();
        /*const query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('customer_payment_option')
          .addCondition('AND', 'customer', '=', common.getUserData()['customer']).compile();*/

        common.method.query(common.urls.find, query).then(function () {
          var res = common.response.post_query.data;
          if (res.success) {
            floristSrv.getSeptupTotal().payOptions = res.results.length;
            onSuccess(res.results);
          } else {
            onError(new Error(res.error));
          }
        });
      }
    };
  }
})(angular);
//# sourceMappingURL=paymentSrv.js.map

'use strict';

(function (angular) {
  angular.module('ibf').factory('shippingSrv', ['commonSrv', '$filter', '$uibModal', 'environment', shippingSrv]);

  function shippingSrv(commonSrv, $filter, $uibModal, environment) {
    var shipping = {},
        common = commonSrv;
    var _shippingDays = [];
    var closed_day = 0;
    var dayMap = {
      sunday: 0,
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6

    };

    var holidays = [20170704, 20171226, 20171228, 20180102, 20180104];

    shipping.getDayMap = function () {
      return dayMap;
    };

    shipping.checkCartBoxShipDay = function (cartbox) {
      var today = new Date();
      if (common.getTimeEST() > 8) {
        today.setDate(today.getDate() + closed_day);
      }
      var packing_date = cartbox.packing_date;
      if (common.convertDateToNumberDate(packing_date) === common.convertDateToNumberDate(today)) {
        console.log('checking for:', common.getTimeEST());
        return common.getTimeEST() < 8;
      }
      return common.convertDateToNumberDate(packing_date) > common.convertDateToNumberDate(today);
    };

    shipping.checkShippingDay = function (arrival_date, shippingDay) {
      if (holidays.indexOf(common.convertDateToNumberDate(arrival_date)) !== -1) {
        return false;
      }
      var shipDay = new Date(arrival_date);
      var today = common.getTodayEST();
      var hourTodayEST = common.getTimeEST();
      var dayMap = shipping.getDayMap();
      shipDay.setDate(shipDay.getDate() - shippingDay.customer_delay);
      var shipDayNumber = common.convertDateToNumberDate(shipDay);
      if (shipDayNumber === today) {
        return shipDay.getDay() === dayMap[shippingDay.shipping_day] && hourTodayEST < 8;
      }
      return shipDay.getDay() === dayMap[shippingDay.shipping_day] && shipDayNumber > today;
    };

    /**
     * params: growers, arrival_date, shippingDaysMap, growerPref
     */
    shipping.checkGrowerShipping = function (params, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          growers: params.growers,
          arrival_date: params.arrival_date,
          shippingDays: params.shippingDays,
          growersPref: params.growersPref,
          growersCheck: [],
          growersInvalid: [],
          growerPrefMap: {}
        };

        for (var i = 0; i < box.growersPref.length; i++) {
          var preferences = box.growersPref[i];
          box.growerPrefMap[preferences.grower] = preferences;
        }
        cb(null, box);
      }, function (box, cb) {
        for (var i = 0; i < box.growers.length; i++) {
          var notValid = true;
          var grower = box.growers[i];
          var pref = box.growerPrefMap[grower._KEY];
          if (!pref) {
            box.growersInvalid.push(grower._KEY);
            continue;
          }
          for (var j = 0; j < box.shippingDays.length; j++) {
            var shippingDay = box.shippingDays[j];
            if (shippingDay.country._KEY !== grower.country) {
              continue;
            }
            if (shipping.checkShippingDay(box.arrival_date, shippingDay) && pref['shipping_' + shippingDay.shipping_day]) {
              notValid = false;
              box.growersCheck.push(grower._KEY);
              break;
            }
          }
          if (notValid) {
            box.growersInvalid.push(grower._KEY);
          }
        }
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess({
          valid: box.growersCheck,
          invalid: box.growersInvalid
        });
      });
    };

    shipping.getGrowersShipping = function (arrival_date, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          arrival_date: arrival_date,
          countries: [],
          growers: [],
          results: {
            valid: [],
            invalid: []
          },
          notValid: false
        };

        common.method.run({
          key: environment.cloudscript.getGrowShip,
          params: {
            arrival_date: arrival_date
          }
        }).then(function (response) {
          if (response.success) {
            box.countries = response.res.countries;
            box.growers = response.res.growers;
            box.growersPref = response.res.growersPref;
            box.shippingDays = response.res.shippingDays;
            box.notValid = response.res.notValid;
            cb(null, box);
          } else {
            box.notValid = true;
            cb(response.error, box);
          }
        }, cb);
      }, function (box, cb) {
        if (box.notValid) {
          return cb(null, box);
        };
        shipping.checkGrowerShipping(box, function (result) {
          box.results = result;
          if (box.results.valid.length == 0) {
            box.notValid = true;
          };
          cb(null, box);
        }, cb);
      }], function (err, box) {
        if (err) {
          return onError(err);
        };
        onSuccess({
          notValid: box.notValid,
          valid: box.results.valid,
          invalid: box.results.invalid,
          countries: box.countries
        });
      });
    };

    return shipping;
  }
})(angular);
//# sourceMappingURL=shippingSrv.js.map

'use strict';

(function (angular) {
  angular.module('ibf').factory('managerSrv', ['commonSrv', managerSrv]);

  function managerSrv(commonSrv) {
    var manager = {},
        common = commonSrv;

    manager.loadInformation = function (conditions, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          conditions: conditions,
          cartBoxMapCurrent: {},
          cartBoxMapLast: {},
          cartBoxMapTotal: {},
          userCustomersMap: {},
          managerData: null
        };
        manager.getManagerData(function (data) {
          box.managerData = data;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        manager.getCustomerByManager(box.managerData.user_email, box.conditions, function (data) {
          box.customers = data.results;
          box.totalPages = data.total_pages;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        async.each(box.customers, function (customer, cbEach) {
          box.cartBoxMapCurrent[customer._KEY] = 0;
          box.cartBoxMapLast[customer._KEY] = 0;
          box.cartBoxMapTotal[customer._KEY] = 0;
          manager.getCartBox(customer._KEY, function (data) {
            if (data.length > 0) {
              var today = new Date();
              var firstDay = common.convertDateToNumberDate(new Date(today.getFullYear(), today.getMonth(), 1));
              var lastDay = common.convertDateToNumberDate(new Date(today.getFullYear(), today.getMonth(), 0));
              var firstDay2 = common.convertDateToNumberDate(new Date(today.getFullYear(), today.getMonth() - 1, 1));
              today = common.convertDateToNumberDate(today);

              var current = data.filter(function (cartBox) {
                if (cartBox.packing_date) {
                  return firstDay <= cartBox.packing_date && cartBox.packing_date <= today;
                }
              });
              var lastMonth = data.filter(function (cartBox) {
                if (cartBox.packing_date) {
                  return firstDay2 <= cartBox.packing_date && cartBox.packing_date <= lastDay;
                }
              });
              var totalCurrent = 0;
              current.forEach(function (cartBox) {
                totalCurrent += cartBox.price;
              });
              var totalLastMonth = 0;
              lastMonth.forEach(function (cartBox) {
                totalLastMonth += cartBox.price;
              });
              box.cartBoxMapCurrent[customer._KEY] = {
                boxes: current.length,
                price: totalCurrent

              };
              box.cartBoxMapLast[customer._KEY] = {
                boxes: lastMonth.length,
                price: totalLastMonth
              };
              box.cartBoxMapTotal[customer._KEY] = data.length;
            }
            cbEach();
          }, cbEach);
        }, function (err) {
          if (err) {
            return cb(err);
          }
          cb(null, box);
        });
      }, function (box, cb) {
        manager.getManagerUsers(function (users) {
          users.forEach(function (user) {
            box.userCustomersMap[user.customer] = user;
          });
        }, cb);
        cb(null, box);
      }], function (err, box) {
        if (err) {
          return onError(err);
        }

        onSuccess(box);
      });
    };

    manager.getManagerUsers = function (onSuccess, onError) {
      var query = common.sbx.with('user').andWhereIsEqual('user_id', common.userData.data.id).andWhereIsEqual('role', 'FLORIST').compile();
      /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('user')
        .addCondition('AND', 'user_id', '=', common.userData.data.id)
        .addCondition('AND', 'role', '=', 'FLORIST')
        .compile();*/

      common.loadAllPages(query, function (response) {
        var fetch = response.fetched_results;

        onSuccess(response.results);
      }, function (err) {
        onError(new Error(err));
      });
    };

    manager.getCustomerByManager = function (manager, conditions, onSuccess, onError) {
      var page = conditions.page;

      var query = common.sbx.with('customer').andWhereIsEqual('acc_manager', manager).setPage(page).setPageSize(10);
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer')
        .addCondition('AND', 'acc_manager', '=', manager)
        .setPage(page)
        .setPageSize(10);*/

      if (conditions.customer) {
        query.andWhereContains('company_name', '%' + conditions.customer + '%');
        //query.addCondition('AND', 'company_name', 'LIKE', `%${conditions.customer}%`);
      }

      query = query.compile();

      common.loadPage(query, page, function (response) {
        var fetch = response.fetched_results;
        onSuccess(response);
      }, function (err) {
        onError(new Error(err));
      });
    };

    manager.getManagerData = function (onSuccess, onError) {
      var query = common.sbx.with('user').andWhereIsEqual('user_id', common.userData.data.id).andWhereIsEqual('role', 'MANAGER').fetchModels(['manager']).compile();
      /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('user')
        .addCondition('AND', 'user_id', '=', common.userData.data.id)
        .addCondition('AND', 'role', '=', 'MANAGER')
        .fetchModels(['manager'])
        .compile();*/

      common.loadAllPages(query, function (response) {
        var fetch = response.fetched_results;
        response.results.forEach(function (item) {
          item.manager = fetch.manager[item.manager];
        });
        onSuccess(response.results[0]);
      }, function (err) {
        onError(new Error(err));
      });
    };

    manager.getCartBox = function (customer, onSuccess, onError) {
      var query = common.sbx.with('cart_box').andWhereIsEqual('customer', customer).fetchModels(['product_group', 'grade', 'grower', 'customer', 'purchase', 'status', 'box', 'variety', 'group_type']).compile();
      /*const query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('cart_box')
        .addCondition('AND', 'customer', '=', customer)
        .fetchModels(['product_group', 'grade', 'grower', 'customer', 'purchase', 'status', 'box', 'variety', 'group_type'])
        .compile();*/

      common.loadAllPages(query, function (response) {
        var fetch = response.fetched_results;
        response.results.forEach(function (cart) {
          cart.grade = fetch.grade[cart.grade] || null;
          cart.grower = fetch.grower[cart.grower] || null;
          cart.group_type = fetch.group_type[cart.group_type] || null;
          cart.product_group = fetch.product_group[cart.product_group] || null;
          cart.box = fetch.admin_box[cart.box] || null;
          cart.customer = fetch.customer[cart.customer] || null;
          cart.purchase = fetch.purchase[cart.purchase] || null;
          cart.status = fetch.cart_box_status[cart.status] || null;
          cart.variety = fetch.variety[cart.variety] || null;
        });
        onSuccess(response.results);
      }, function (err) {
        onError(new Error(err));
      });
    };

    manager.updateUserManager = function (user, onSuccess, onError) {
      var query = common.sbx.insert('user', user);
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('user')
        .addObject(user).compile();*/
      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        if (res.success) {
          onSuccess(user);
        } else {
          onError(res.error);
        }
      });
    };

    manager.setUserPermissions = function (key) {
      var perm = {
        user: key,
        ibuyflowers: true,
        auto_buy: false,
        standing_orders: false,
        purchase_orders: true,
        claims: false,
        accounting: false
      };

      var query = common.sbx.insert('customer_user_config', perm);
      /*let query = common.queryBuilder()
        .setDomain(common.actual_domain)
        .setModel('customer_user_config')
        .addObject(perm)
        .compile();*/

      common.method.query(common.urls.row, query).then(function () {
        var response = common.response.post_query.data;
      });
    };

    manager.requestAuth = function (request, onSuccess, onError) {
      async.waterfall([function (cb) {
        var box = {
          customer: request.customer,
          user: request.user
        };

        if (box.user) {
          return cb(null, box);
        }

        var arrayName = common.userData.data.name.split(' ');

        var user = {
          user_id: common.userData.data.id,
          role: 'FLORIST',
          first_name: arrayName[0],
          last_name: arrayName[arrayName.length - 1],
          user_email: common.userData.data.email,
          is_admin: false,
          active: false,
          manager: common.userData.manager,
          customer: box.customer._KEY,
          from_manager: true
        };

        var query = common.sbx.insert('user', user);
        /*var query = common.queryBuilder()
          .setDomain(common.actual_domain)
          .setModel('user')
          .addObject(user).compile();*/

        common.method.query(common.urls.row, query).then(function () {
          var res = common.response.post_query.data;
          if (res.success) {
            user._KEY = res.keys[0];
            box.user = user;
            manager.setUserPermissions(box.user._KEY);
            cb(null, box);
          } else {
            cb(res.error, box);
          }
        });
      }, function (box, cb) {
        // code_auth
        var code = $.now().toString().substr(-6);
        var tmp = {
          _KEY: box.user._KEY,
          code_auth: code
        };

        manager.updateUserManager(tmp, function () {
          box.user.code_auth = code;
          cb(null, box);
        }, cb);
      }, function (box, cb) {
        var mail = {
          'subject': 'Request for authorization personal Account Executive iBuyFlowers',
          'to': box.customer.office_email,
          'domain': common.actual_domain,
          'from': 'info@ibuyflowers.com',
          'template_key': common.template_email_request_auth,
          'data': {
            'customer': box.customer.company_name,
            'code': box.user.code_auth,
            'manager': common.userData.name
          }
        };
        // sendEmail
        common.method.send_mail(mail).then(function (res) {
          if (res.success) {
            cb(null, box);
            console.log('Email sent !!!');
          }
        });
      }], function (err, box) {
        if (err) {
          return onError(err, box);
        }

        onSuccess(box.user);
      });
    };

    manager.verifyAuth = function (user, onSuccess) {
      var tmp = {
        _KEY: user._KEY,
        code_auth: null,
        active: true
      };

      manager.updateUserManager(tmp, function () {
        onSuccess(null);
      });
    };
    return manager;
  }
})(angular);
//# sourceMappingURL=managerSrv.js.map

'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function (angular) {
  'use strict';

  angular.module('ibf').factory('adminSrv', ['commonSrv', '$filter', '$uibModal', 'productSrv', 'growerSrv', 'shippingSrv', 'floristSrv', 'environment', adminSrv]);

  function adminSrv(commonSrv, $filter, $uibModal, productSrv, growerSrv, shippingSrv, floristSrv, environment) {

    var admin = {},
        common = commonSrv,
        ps = productSrv,
        gs = growerSrv,
        ss = shippingSrv,
        fs = floristSrv;
    admin.growerStates = null;
    admin.balanceMonth = null;

    admin.getGrowersByCountry = function (country, callback) {
      var query = common.sbx.with('user').andWhereIsEqual('active', true).andWhereIsEqual('grower.active', true).andWhereIsEqual('grower.country', country).fetchModels(['grower']).compile();

      common.loadAllPages(query, function (data) {
        var growers = data.fetched_results.grower;

        if (growers) {
          growers = Object.keys(growers).map(function (k) {
            return growers[k];
          }).sort(function (a, b) {
            return a.company_name.localeCompare(b.company_name);
          });
          callback(null, { growers: growers });
        } else {
          callback(null, { growers: [] });
        }
      }, callback);
    };

    admin.getMasterlistsByCartbox = function (cartbox, callback) {
      var query = common.sbx.with('cart_box_item').andWhereIsEqual('cart_box', cartbox).fetchModels(['inventory.masterlist']).compile();

      common.loadAllPages(query, function (data) {
        var masterlists = [];
        for (var key in data.fetched_results.add_masterlist) {
          masterlists.push(data.fetched_results.add_masterlist[key]);
        }
        callback({ success: true, masterlists: masterlists });
      }, callback);
    };

    admin.growerCountryArrival = function (onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.growerCountryArrival,
        params: {}
      }).then(function (response) {
        console.log(response);
        if (response.success) {
          onSuccess(response.infoArray);
        } else {
          onError(response.message);
        }
      }, onError);
    };

    admin.deleteBoxPurchase = function (cartbox, onSuccess, onError) {

      var params = {
        cartbox: cartbox._KEY,
        issue: cartbox.issue,
        customer: cartbox.customer._KEY,
        override_key: '943f46f9-2440-4999-87f3-478292be6635',
        userDispatcher: common.getUserData().key
      };

      if (cartbox.restore_inventory === false) {
        params.restore_inventory = false;
      }

      common.method.run({
        key: environment.cloudscript.cancelBorder,
        params: params
      }).then(function (response) {
        if (response.success) {

          onSuccess('The box has been deleted');
        } else {
          onError(response);
        }
      }, onError);
    };

    admin.sendPackingListEmail = function (selected, date, cb) {

      var lines = '';

      $filter('orderBy')(selected, 'name').forEach(function (grower) {

        lines += '<tr>\n                    <td class="tg-us36">' + grower.name + '</td>\n                    <td class="tg-c3ow">' + grower.orders + '</td>\n                  </tr>\n                  ';
      });

      var table = '<table class="tg">\n                      <tr>\n                        <th class="tg-us36">Grower</th>\n                        <th class="tg-us36">No. Boxes</th>\n                      </tr>\n                      ' + lines + '\n                    </table>';

      var template = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">\n                  <html xmlns="http://www.w3.org/1999/xhtml">\n                    <head>\n                      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />\n                      <meta name="viewport" content="width=device-width, initial-scale=1.0"/>\n                      <title>iBuyFlowers.com</title>\n                      <style type="text/css">\n                        .tg  {border-collapse:collapse;border-spacing:0;border-color:#999;}\n                        .tg td{font-family:Arial, sans-serif;font-size:14px;padding:10px 5px;border-style:solid;border-width:1px;overflow:hidden;word-break:normal;border-color:#999;color:#444;background-color:#F7FDFA;}\n                        .tg th{font-family:Arial, sans-serif;font-size:14px;font-weight:normal;padding:10px 5px;border-style:solid;border-width:1px;overflow:hidden;word-break:normal;border-color:#999;color:#fff;background-color:#26ADE4;}\n                        .tg .tg-c3ow{border-color:inherit;text-align:center;vertical-align:top}\n                        .tg .tg-us36{border-color:inherit;vertical-align:top\n                      </style>\n                    </head>\n                    <body>\n                      ' + table + '\n                    </body>\n                  </html>';

      var mail = {
        'subject': 'Packing list Fedex ' + date,
        'domain': common.actual_domain,
        'cc': 'farmmanager@ibuyflowers.com',

        'to': common.getUserData().email ? common.getUserData().email : "farmmanager@ibuyflowers.com",
        'from': 'info@ibuyflowers.com',
        'html': template
      };

      // sendEmail
      common.method.send_mail(mail).then(function (res) {
        if (res.success) {
          cb();
        }
      });
    };

    admin.getClaims = function (key, state, date, grower, onSuccess, onError) {

      var query = common.sbx.with('request_claim').fetchModels(['cart_box', 'cart_box_item', 'cart_box.product_group', 'cart_box.variety', 'cart_box.grower', 'cart_box.customer', 'cart_box.purchase', 'cart_box.grade', 'cart_box_item.uom', 'cart_box_item.stems_per_bunch', 'cart_box_item.variety', 'cart_box_item.product_group']);

      if (state === '=') {
        query.andWhereIsEqual('state', 'Pending');
      } else if (state === '!=') {
        query.andWhereIsNotEqual('state', 'Pending');
      } else {
        query.andWhereIsEqual('state', state);
      }

      if (date) {
        var firstDay = common.convertDateToNumberDate(new Date(date.year, date.month, 1), true);
        var lastDay = common.convertDateToNumberDate(new Date(date.year, date.month + 1, 0), true);

        query.andWhereGreaterOrEqualThan(date.dateType, firstDay).andWhereLessOrEqualThan(date.dateType, lastDay);

        if (date.hasOwnProperty('arrived')) {
          query.andWhereIsEqual('arrived', date.arrived);
        }
      }

      if (grower) {
        query.andWhereIsEqual('cart_box.grower', grower);
      }

      if (key) {
        query.whereWithKeys([key]);
      }

      common.loadAllPages(query.compile(), function (res) {
        if (res.results.length) {
          var fetched = res.fetched_results;
          res.results = res.results.reduce(function (claims, item) {
            item.cart_box = angular.copy(fetched.cart_box[item.cart_box]);
            if (item.cart_box) {

              item.cart_box.purchase = fetched.purchase[item.cart_box.purchase] || item.cart_box.purchase;
              item.cart_box.customer = fetched.customer[item.cart_box.customer] || item.cart_box.customer;
              item.cart_box.grower = fetched.grower[item.cart_box.grower] || item.cart_box.grower;
              item.cart_box.grade = fetched.grade[item.cart_box.grade] || item.cart_box.grade;
              item.cart_box.product_group = fetched.product_group[item.cart_box.product_group] || item.cart_box.product_group;
              item.cart_box.variety = fetched.variety[item.cart_box.variety] || item.cart_box.variety;
              item.cart_box.eta_date = typeof item.cart_box.eta_date === 'number' ? common.convertNumberDateToDate(item.cart_box.eta_date) : item.cart_box.eta_date;
              item.cart_box.charge_date = typeof item.cart_box.charge_date === 'number' ? common.convertNumberDateToDate(item.cart_box.charge_date) : item.cart_box.charge_date;
              item.cart_box.packing_date = typeof item.cart_box.packing_date === 'number' ? common.convertNumberDateToDate(item.cart_box.packing_date) : item.cart_box.packing_date;
              item.cart_box.arrival_date_fedex = item.cart_box.arrival_date_fedex ? new Date(item.cart_box.arrival_date_fedex) : item.cart_box.arrival_date_fedex;
              item.cart_box_item = fetched.cart_box_item ? fetched.cart_box_item[item.cart_box_item] : item.cart_box_item;

              item.cart_box_item.uom = fetched.uom[item.cart_box_item.uom] || item.cart_box_item.uom;
              item.cart_box_item.stems_per_bunch = fetched.stems_per_bunch[item.cart_box_item.stems_per_bunch] || item.cart_box_item.stems_per_bunch;
              item.cart_box_item.variety = fetched.variety[item.cart_box_item.variety] || item.cart_box_item.variety;
              item.cart_box_item.product_group = fetched.product_group[item.cart_box_item.product_group] || item.cart_box_item.product_group;
              if (!item.cart_box_item.stems_per_bunch.stems_per_bunch) {
                item.cart_box_item.stems_per_bunch.stems_per_bunch = 1;
              }
              var percentage_uom = 0;

              if (item.cart_box.tag !== null) {
                if (item.cart_box_item.uom && item.cart_box_item.uom.uom) {

                  if (item.cart_box_item.uom.uom === "bunch") {
                    percentage_uom = item.cart_box_item.percentage / 100;
                  }

                  if (item.cart_box_item.uom.uom === "stem") {
                    percentage_uom = item.cart_box_item.percentage / 100 / item.cart_box_item.stems_per_bunch.stems_per_bunch;
                  }

                  var box_charge = item.cart_box_item.box_charge === null || item.cart_box_item.box_charge === 0 ? item.cart_box_item.grower_box_charge : item.cart_box_item.box_charge;

                  item.cart_box_item.base_price = item.cart_box_item.base_price + box_charge * percentage_uom;
                }
              }

              var price = parseFloat(item.total_claim);
              var margin = parseFloat(item.cart_box.purchase.margin) / 100;
              var base_price_stem = item.cart_box_item.base_price;
              if (item.cart_box_item.uom.uom === "bunch") {
                // If not is stem we need to divide the base price by the stems per bunch
                base_price_stem = base_price_stem / item.cart_box_item.stems_per_bunch.stems_per_bunch;
              }

              if (item.total_claim_grower === null) {
                item.show_no_shipping_price = true;

                item.total_claim_grower = item.cart_box.grower.hasOwnProperty("excl_transport_cost") && item.cart_box.grower.excl_transport_cost ? base_price_stem * item.total_units_to_be_claimed : price * (1 - margin);
              }

              item.total_grower_no_shipping = item.total_claim_grower === 0 ? 0 : base_price_stem * item.total_units_to_be_claimed;

              if (item.arrived) {
                item.extra_photos = [res.results[0].picture_including_farm_name, res.results[0].picture_including_shipping_label, res.results[0].picture_product_to_be_claimed_1, res.results[0].picture_product_to_be_claimed_2];
              }
              claims.push(item);
            }
            return claims;
          }, []);

          if (key && res.results[0].claim_folder && res.results[0]._KEY) {
            common.method.run({
              key: environment.cloudscript.ibf_getClaim,

              params: {
                claim: res.results[0]._KEY
              }
            }).then(function (response) {

              if (response.success && response.data && response.data.images) {
                res.results[0].extra_photos = response.data.images.map(function (image) {
                  return image.url;
                });
                onSuccess(res.results);
              } else {
                onSuccess(res.results);
              }
            }).catch(function (err) {
              onSuccess(res.results);
            });

            // floristSrv.folderList({key: res.results[0].claim_folder}, data => {
            //   res.results[0].extra_photos = data.map(item => `${common.actual_base_url}/claims/${key}/${item.name}?cb=${new Date().getTime()}`);
            //   onSuccess(res.results);
            // }, err => onSuccess(res.results));
          } else {
            onSuccess(res.results);
          }
        } else {
          onSuccess(res.results);
        }
      }, onError);
    };

    admin.loadConfig = function (onSuccess, onError) {
      common.method.get(common.urls.appKeys, { domain: common.actual_domain }).then(function () {
        var response = common.response.get.data;
        if (response.success) {
          var app = response.items.find(function (item) {
            return item.app_key === common.current_app_key;
          });
          onSuccess(app);
        } else {
          onError(response.error);
        }
      });
    };

    admin.updateConfig = function (config, onSuccess, onError) {
      common.method.postData(common.urls.configAppKey, config).then(function () {
        var response = common.response.post.data;
        if (response.success) {
          onSuccess();
        } else {
          onError();
        }
      });
    };

    admin.uploadFileToUrl = function (fd, onSuccess) {
      common.method.upload(common.urls.uploadFile, fd).then(function () {
        var res = common.response.post.data;
        if (res.success) {
          return onSuccess(true);
        } else {
          return onSuccess(false);
        }
      }, function () {
        return onSuccess(false);
      });
    };

    admin.getClaimReasons = function (claim, onSuccess, onError) {
      fs.getClaimReasons(claim, onSuccess, onError);
    };

    admin.insertCustomerAddress = function (address, onSuccess) {
      var query = common.sbx.insert('customer_address', address);

      common.method.query(common.urls.row, query).then(function () {
        var res = common.response.post_query.data;
        onSuccess(res);
      });
    };

    admin.updatePurchaseAddress = function (purchase, onSuccess) {
      var query = common.sbx.insert('purchase', { _KEY: purchase._KEY, street: purchase.street, state: purchase.state, zipcode: purchase.zipcode, city: purchase.city });

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        onSuccess(res);
      });
    };

    admin.setTotalClaimGrower = function (claim, incl_cost, onSuccess) {

      var query = common.sbx.insert('request_claim', {
        '_KEY': claim._KEY,
        'total_claim_grower': incl_cost ? claim.total_claim_grower : claim.total_grower_no_shipping,
        'incl_cost': claim.incl_cost,
        'total_claim': claim.total_claim
      });

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        common.salesforceSync({ action: 'update', model: 'request_claim', key: claim._KEY });
        onSuccess(res);
      });
    };

    admin.folderList = function (params, onSuccess, onError) {
      common.method.get(common.urls.folderList, params).then(function () {
        var response = common.response.get.data;
        if (response.success) {
          onSuccess(response.contents);
        } else {
          onError(response.error);
        }
      });
    };

    admin.getPurchases = function (conditions, callback) {
      common.method.run({
        key: environment.cloudscript.getPurchase,
        params: { conditions: conditions }
      }).then(function (response) {
        callback(response);
      }, function (err) {
        callback({ success: false, error: err.message });
      });
    };

    function getInventory(query, conditions, onSuccess) {
      if (conditions.product !== 'all') {
        if (conditions.variety) {
          query.andWhereIsEqual('masterlist.variety', conditions.variety);
        } else {
          query.andWhereIsEqual('masterlist.product_group', conditions.product);
        }
      }

      if (conditions.grower === 'all') {
        query.andWhereIsEqual('grower.country', conditions.country);
      } else {
        query.andWhereIsEqual('grower', conditions.grower);
      }

      commonSrv.loadAllPages(query.compile(), function (data) {
        onSuccess(data);
      });
    }

    admin.getInventoryWithoutFetch = function (conditions, onSuccess) {
      var query = commonSrv.sbx.with('inventory').andWhereGreaterOrEqualThan('week', commonSrv.convertDateToNumberDate(conditions.start_date)).andWhereLessThan('week', commonSrv.convertDateToNumberDate(conditions.end_date));
      return getInventory(query, conditions, onSuccess);
    };

    admin.getInventory = function (conditions, onSuccess) {
      var query = commonSrv.sbx.with('inventory').andWhereIsEqual('masterlist.active', true).andWhereIsEqual('grower.active', true).andWhereIsNull('kind').andWhereGreaterOrEqualThan('week', commonSrv.convertDateToNumberDate(conditions.start_date)).andWhereLessThan('week', commonSrv.convertDateToNumberDate(conditions.end_date)).fetchModels(['grower', 'masterlist.box']);
      return getInventory(query, conditions, onSuccess);
    };

    admin.getPromoInventory = function (conditions, callback) {
      async.waterfall([function (cb) {
        common.method.run({
          key: environment.cloudscript.searchInventory,
          params: conditions
        }).then(function (response) {
          if (response.success && !response.isEmpty) {
            cb(null, response.inventories.map(function (item) {
              return { _KEY: item._KEY, packing_date: item.packing_date, charge_date: item.charge_date };
            }));
          } else {
            cb('There is no promo inventories to arrival date provided.');
          }
        }, function () {
          cb('Error occurred, please try again.');
        });
      }, function (inventories, cb) {
        var chunk = _.chunk(inventories, 1000);
        var inventoriesArray = [];
        async.eachSeries(chunk, function (items, next) {
          var aux = { inv: items, arrival_date: conditions.arrival_date, customer: conditions.customer };
          common.method.run({
            key: environment.cloudscript.fetchInventory,
            params: aux
          }).then(function (response) {
            if (response.success) {
              inventoriesArray = inventoriesArray.concat(response.box);
              next();
            } else {
              next('Error occurred, please try again.');
            }
          }, function () {
            next('Error occurred, please try again.');
          });
        }, function (err) {
          cb(err, inventoriesArray);
        });
      }], function (err, inventories) {
        if (err) {
          return callback({ success: false, error: err });
        }
        callback({ success: true, inventories: inventories });
      });
    };

    // admin.getPromoInventory = function(conditions, callback) {
    //   common.method.run({
    //     key: environment.cloudscript.cassandraSearchInv,
    //     params: conditions
    //   }).then(function (data) {
    //     if (data.success) {
    //       callback(null, data.response);
    //     } else {
    //       callback('There is no inventories for the arrival date provided.');
    //     }
    //   }, () => {
    //     callback('Error occurred, please try again.');
    //   });
    // };

    admin.getPromoGroups = function (arrival_date, callback) {
      var query = commonSrv.sbx.with('promo_inventory').andWhereIsEqual('arrival_date', arrival_date).compile();

      commonSrv.loadAllPages(query, function (data) {
        var masterlist = [];
        data.results.forEach(function (item) {
          var list = JSON.parse(item.items);
          item.items = {};
          list.forEach(function (key) {
            return item.items[key] = {};
          });
          masterlist.push.apply(masterlist, _toConsumableArray(list));
        });
        if (masterlist.length) {
          query = commonSrv.sbx.with('add_masterlist').whereWithKeys(masterlist).fetchModels(['variety.product_group', 'grade']).compile();
          commonSrv.loadAllPages(query, function (res) {
            var masterlistMap = {};
            res.results.forEach(function (item) {
              item.variety = res.fetched_results.variety[item.variety];
              item.product_group = res.fetched_results.product_group[item.variety.product_group];
              item.grade = res.fetched_results.grade[item.grade];
              item.name = item.product_group.common_name + ' ' + item.variety.variety_name + ' ' + item.length + 'cm ' + (item.grade ? item.grade.grade : '');
              masterlistMap[item._KEY] = item;
            });
            data.results.forEach(function (item) {
              Object.keys(item.items).forEach(function (key) {
                item.items[key] = { _KEY: key, name: masterlistMap[key].name };
                item.isCreating = false;
              });
            });
            callback({ success: true, groups: data.results });
          }, function () {
            callback({ success: false, error: 'Error occurred, please try again.' });
          });
        } else {
          callback({ success: true, groups: data.results });
        }
      }, function () {
        callback({ success: false, error: 'Error occurred, please try again.' });
      });
    };

    admin.saveGroup = function (group, arrival_date, callback) {
      var end_date = common.convertDateToNumberDate(group.end_date);
      var start_date = common.convertDateToNumberDate(group.start_date);
      var code = common.generateUUID();
      var url = environment.baseUrl + 'search?date=' + arrival_date + '&promo_code=' + code;
      var aux = {
        code: code,
        arrival_date: arrival_date,
        items: JSON.stringify(group.items.map(function (item) {
          return item._KEY;
        })),
        url: url,
        end_date: end_date,
        start_date: start_date,
        off: group.off / 100
      };

      var query = common.sbx.insert('promo_inventory', aux);

      common.method.query(common.urls.row, query).then(function () {
        var res = common.response.post_query.data;
        callback(res);
      });
    };

    admin.removeGroup = function (group, callback) {
      var query = common.sbx.with('promo_inventory').whereWithKeys([group._KEY]).compile();

      common.method.query(common.urls.delete, query).then(function () {
        var res = common.response.post_query.data;
        callback(res);
      });
    };

    admin.getSeasons = function (onSuccess, onError) {
      var query = commonSrv.sbx.with('season').compile();

      commonSrv.loadAllPages(query, function (data) {
        data = data.results;

        data = data.map(function (item) {
          if (item.from) item.from = common.convertNumberDateToDate(item.from);
          if (item.to) item.to = common.convertNumberDateToDate(item.to);
          return item;
        });
        onSuccess(data);
      });
    };

    admin.updateSeasons = function (season, onSuccess, onError) {
      var query = commonSrv.sbx.insert('season', season);

      commonSrv.method.query(common.urls.update, query).then(function (res) {
        if (res.data.success) {
          onSuccess(res);
        } else {
          onError(res.data.error);
        }
      });
    };

    admin.addSeasons = function (season, onSuccess, onError) {
      var query = commonSrv.sbx.insert('season', season);

      commonSrv.method.query(common.urls.row, query).then(function (res) {
        if (res.data.success) {
          onSuccess(res);
        } else {
          onError(res.data.error);
        }
      });
    };

    admin.getMasterListSearch = function (params, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.getMasterListSearch,
        params: params
      }).then(function (res) {
        if (res.success) {
          onSuccess(res.response);
        } else {
          onError(res.error);
        }
      }, onError);
    };

    admin.getSeasonMasterlist = function (params, onSuccess) {
      var query = commonSrv.sbx.with('season_masterlist').andWhereIsEqual('season', params.season).andWhereIsEqual('add_masterlist', params.add_masterlist).compile();

      return commonSrv.loadAllPages(query, function (data) {
        onSuccess(data);
      });
    };

    admin.addSeasonsMasterlist = function (params, onSuccess) {
      var query = commonSrv.sbx.insert('season_masterlist', params);

      commonSrv.method.query(common.urls.row, query).then(function (res) {
        if (res.data.success) {
          onSuccess(res);
        } else {
          onError(res.data.error);
        }
      });
    };

    admin.getSeasonsMasterlist = function (params, onSuccess, onError) {
      common.method.run({
        key: environment.cloudscript.searchSeasonMasterlist,
        params: params
      }).then(function (res) {
        if (res.success) {
          onSuccess(res.response);
        } else {
          onError(res.error);
        }
      }, onError);
    };

    admin.deleteSeasonMasterlist = function (params, onSuccess, onError) {
      var query = common.sbx.with('season_masterlist').andWhereIsEqual('season', params.season).andWhereIsEqual('add_masterlist', params.add_masterlist).compile();

      common.method.query(common.urls.delete, query).then(function (res) {
        console.log(res);
        onSuccess(res);
      });
    };

    admin.getBalancePerMonth = function (params, onSuccess, onError) {
      if (admin.balanceMonth) {
        onSuccess(admin.balanceMonth);
      } else {
        common.method.run({
          key: environment.cloudscript.getBalancePerMonth,
          params: params
        }).then(function (response) {
          if (response.success) {
            onSuccess(response.results);
            admin.setBalanceMonth(response.results);
          } else {
            onError(response.error);
          }
        }, onError);
      }
    };

    admin.getGrowerState = function (onSuccess, onError) {
      if (admin.growerStates) {
        onSuccess(admin.growerStates);
      } else {
        common.method.run({
          key: environment.cloudscript.getGrowerState,
          params: {}
        }).then(function (response) {
          if (response.success) {
            onSuccess(response.results);
            admin.setGrowerState(response.results);
          } else {
            onError(response.error);
          }
        }, onError);
      }
    };

    admin.getCustomsByPacking = function (params, callback) {
      var query = common.sbx.with('customs_box_summary').andWhereIsEqual('packing_date', params.date).andWhereIn('grower', params.growers).fetchModels(["carrier"]).compile();

      common.loadAllPages(query, function (data) {
        var map = data.results.reduce(function (total, item) {
          if (item.carrier) {
            item.carrier = data.fetched_results["carrier"][item.carrier];
          }

          if (!item.carrier || item.carrier && item.carrier.carrier.toLowerCase() === 'fedex') {
            total[item.grower] = item;
          }

          return total;
        }, {});
        callback(map);
      }, callback);
    };

    admin.setCustoms = function (params, callback) {
      var query = commonSrv.sbx.insert('customs_box_summary', params);

      commonSrv.method.query(common.urls.row, query).then(function (res) {
        if (res.data.success) {
          callback(res.data.keys);
        } else {
          callback(res.data.error);
        }
      });
    };

    admin.updateCustoms = function (params, callback) {
      var query = common.sbx.insert('customs_box_summary', params);

      common.method.query(common.urls.update, query).then(function () {
        var res = common.response.post_query.data;
        callback(res);
      });
    };

    admin.setBalanceMonth = function (results) {
      admin.balanceMonth = results;
    };

    admin.setGrowerState = function (results) {
      admin.growerStates = results;
    };

    return admin;
  }
})(angular);
//# sourceMappingURL=adminSrv.js.map

'use strict';

(function (angular) {
  angular.module('ibf').factory('shoppingListSrv', ['commonSrv', '$filter', '$uibModal', 'environment', shoppingListSrv]);

  function shoppingListSrv(commonSrv, $filter, $uibModal, environment) {
    var shoppingListSrv = {},
        common = commonSrv;
    /**
     * Get all the shoppings lists with his items and customer.
     */
    shoppingListSrv.getShoppingLists = function (conditions, onSuccess, onError) {
      async.waterfall([function (cb) {
        if (conditions.customer) {
          var query = common.sbx.with('customer').andWhereContains('company_name', conditions.customer).compile();
          common.loadPage(query, 1, function (res) {
            cb(null, res.results.map(function (i) {
              return i._KEY;
            }));
          }, cb);
        } else {
          cb(null, []);
        }
      }, function (box, cb) {
        if (!box.length && conditions.customer) {
          return cb(null, []);
        }
        var query = common.sbx.with('shopping_list_item').fetchModels(['shopping_list.customer', 'product_group', 'variety']);
        if (conditions.id) {
          query.andWhereIsEqual('shopping_list.consecutive', conditions.id);
        }
        if (conditions.initial_date) {
          query.andWhereGreaterOrEqualThan('shopping_list.delivery_date', conditions.initial_date);
        }
        if (conditions.end_date) {
          query.andWhereLessOrEqualThan('shopping_list.delivery_date', conditions.end_date);
        }

        if (box.length && conditions.customer) {
          query.andWhereIsIn('shopping_list.customer', box);
        }
        common.loadAllPages(query.compile(), function (res) {
          var list = _.values(res.fetched_results.shopping_list);
          res.results.forEach(function (item) {
            item.product_group = Object.assign({}, res.fetched_results.product_group[item.product_group]);
            item.variety = Object.assign({}, res.fetched_results.variety[item.variety]);
            item.name = item.product_group.common_name + ' ' + item.variety.variety_name;
          });
          var items = _.orderBy(res.results, ['name']);
          list.forEach(function (i) {
            i.items = items.filter(function (item) {
              return item.shopping_list === i._KEY;
            });
            i.customer = Object.assign({}, res.fetched_results.customer[i.customer]);
            i.delivery_date = common.convertNumberDateToDate(i.delivery_date);

            i.date1 = i.date1 ? common.convertNumberDateToDate(i.date1) : null;
            i.date2 = i.date2 ? common.convertNumberDateToDate(i.date2) : null;
          });
          cb(null, { list: list, items: res.results });
        }, cb);
      }], function (error, res) {
        if (error) {
          return onError(error);
        } else {
          return onSuccess(res);
        }
      });
    };

    shoppingListSrv.nameSort = function (items) {
      if (items) {
        items.sort(function (a, b) {
          return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
        });
      }
      return items;
    };

    return shoppingListSrv;
  }
})(angular);
//# sourceMappingURL=shoppingListSrv.js.map
